<template>
  <page-header-wrapper :class="{ 'product-form-page-active': formVisible }">
    <div v-if="!formVisible" class="dj-product-page product-master-page erp-list-page baidao-list-page">
      <aside class="product-category-panel erp-table-card">
        <div class="category-hd product-type-head">
          <h3 class="tree-head-title">商品分类目录</h3>
          <div class="tree-actions product-type-head-actions">
            <a-button size="small" type="primary" @click="openCategoryCreate">新建</a-button>
            <a-button size="small" @click="openCategoryMaintain">编辑</a-button>
            <a-button size="small" type="danger" ghost @click="removeCategory">删除</a-button>
          </div>
        </div>
        <div class="category-list product-type-tree">
          <product-type-node
            v-for="node in categoryTree"
            :key="node.id"
            :node="node"
            :depth="0"
            :selected-key="String((selectedCategoryKeys && selectedCategoryKeys[0]) || '')"
            :expanded-keys="expandedCategories"
            :count-of="categoryCount"
            @select="onTypeSelect"
            @toggle="onTypeToggle"
          />
        </div>
      </aside>

      <main class="product-main product-list-pane">
        <div class="product-list-system-card erp-table-card">
          <div class="table-page-search-wrapper list-search-card erp-search-card">
            <div class="archive-filter-grid">
              <label class="archive-filter-field">
                <span>建档方式</span>
                <a-select v-model="query.buildMethod" allow-clear placeholder="全部">
                  <a-select-option value="SPU建档">SPU建档</a-select-option>
                  <a-select-option value="SKU直建">SKU直建</a-select-option>
                </a-select>
              </label>
              <label class="archive-filter-field">
                <span>品牌</span>
                <a-select v-model="query.brand" allow-clear placeholder="全部">
                  <a-select-option v-for="o in filterBrandOptions" :key="o" :value="o">{{ o }}</a-select-option>
                </a-select>
              </label>
              <label class="archive-filter-field">
                <span>基本单位</span>
                <a-select v-model="query.baseUnit" allow-clear placeholder="全部">
                  <a-select-option v-for="o in filterUnitOptions" :key="o" :value="o">{{ o }}</a-select-option>
                </a-select>
              </label>
              <label class="archive-filter-field">
                <span>商品状态</span>
                <a-select v-model="query.status" allow-clear placeholder="全部">
                  <a-select-option value="启用">启用</a-select-option>
                  <a-select-option value="停用">停用</a-select-option>
                </a-select>
              </label>
              <label class="archive-filter-field">
                <span>上架商城</span>
                <a-select v-model="query.mall" allow-clear placeholder="全部">
                  <a-select-option v-for="o in mallFilterOptions" :key="o" :value="o">{{ o }}</a-select-option>
                </a-select>
              </label>
              <label class="archive-filter-field archive-filter-narrow">
                <span>华住同步</span>
                <a-select v-model="query.hzSyncStatus" allow-clear placeholder="全部">
                  <a-select-option value="0">未同步</a-select-option>
                  <a-select-option value="1">已同步</a-select-option>
                  <a-select-option value="2">同步失败</a-select-option>
                </a-select>
              </label>
              <label class="archive-filter-field archive-filter-keyword">
                <span>关键字</span>
                <a-input
                  v-model="query.keyword"
                  allow-clear
                  placeholder="输入商品名称、编码或分类"
                  @pressEnter="handleQuery"
                />
              </label>
              <div class="archive-filter-actions">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />查询
                </a-button>
                <a-button @click="resetQuery">
                  <a-icon type="redo" />重置
                </a-button>
              </div>
            </div>
          </div>

          <div class="table-operations list-toolbar statsbar">
            <div class="archive-current total">
              当前目录：<span class="active-type-label">{{ categoryLabel(activeCategory) }}</span>商品数：<b>{{ pagination.total }}</b>
            </div>
            <div class="list-actions">
              <a-button :loading="syncLoading" @click="batchEnable">批量启用</a-button>
              <a-button :loading="syncLoading" @click="batchDisable">批量停用</a-button>
              <a-button title="同步到华住商城" :loading="syncLoading" @click="batchSyncHuazhu">批量同步华住商城</a-button>
              <a-button disabled title="商城同步接口待接入">批量同步美团</a-button>
              <a-button @click="openSpuCreate">新建SPU商品</a-button>
              <a-button type="primary" @click="openSkuCreate">创建SKU</a-button>
              <a-button @click="openProductMore">更多功能 <a-icon type="down" /></a-button>
            </div>
          </div>

          <div class="table-wrap">
            <a-table
              rowKey="id"
              class="product-list-table"
              :loading="listLoading || syncLoading || deleteLoading"
              :columns="columns"
              :data-source="list"
              :pagination="false"
              :row-selection="{ selectedRowKeys, onChange: onSelectChange }"
              :expandedRowKeys="expandedRowKeys"
              :expandIcon="renderExpandIcon"
              :scroll="{ x: 1780 }"
              size="middle"
              @expand="onProductExpand"
            >
              <div slot="expandedRowRender" slot-scope="record" class="expand-box">
                <div><b>建档方式：</b>{{ buildMethodLabel(record) }}</div>
                <div><b>商品类型：</b>{{ record.productType || '—' }}</div>
                <div><b>SKU数量：</b>{{ record.skuCount || 0 }}</div>
                <div><b>基本单位：</b>{{ record.baseUnit || '—' }}</div>
                <div><b>销售单位：</b>{{ record.baseUnit || '—' }}</div>
                <div><b>采购单位：</b>{{ record.baseUnit || '—' }}</div>
                <div><b>已配置仓库：</b>{{ record.warehouseCount || 0 }} 个</div>
                <div><b>上架商城：</b>{{ mallText(record) }}</div>
                <div><b>创建时间：</b>{{ formatCreateTime(record.createTime) }}</div>
              </div>
              <div slot="image" slot-scope="text, record" class="imgcell">
                <img v-if="isResourceUrl(record.image)" class="list-thumb" :src="publicAttachmentUrl(record.image)" alt="" />
                <span v-else>{{ imageText(record) }}</span>
              </div>
              <div slot="spu" slot-scope="text, record" class="product-name-cell">
                <a class="product-name" @click="openDetail(record)">{{ record.spuName }}</a>
                <span class="product-code">{{ record.spuCode }}</span>
              </div>
              <span slot="buildMethod" slot-scope="text, record" class="archive-mode" :class="{ auto: record.buildMethod === 'sku_direct' }">{{ buildMethodLabel(record) }}</span>
              <span slot="category" slot-scope="text, record" class="category-path">{{ productCategoryPath(record) }}</span>
              <span slot="malls" slot-scope="text, record">{{ mallText(record) }}</span>
              <span slot="hzSyncStatus" slot-scope="text, record" class="hz-sync-status" :class="hzSyncStatusClass(record.hzSyncStatus)">{{ hzSyncStatusLabel(record.hzSyncStatus) }}</span>
              <span slot="status" slot-scope="text, record" class="status-dot" :class="{ off: !isEnabledStatus(record.status) }">{{ statusLabel(text) }}</span>
              <span slot="createTime" slot-scope="text">{{ formatCreateTime(text) }}</span>
              <span slot="operation" slot-scope="text, record" class="ops">
                <a-button size="small" @click="openDetail(record)">查看</a-button>
                <a-button size="small" @click="openEdit(record)">编辑</a-button>
                <button
                  type="button"
                  class="iconbtn"
                  title="同步到华住商城"
                  @click="syncHuazhuOne(record)"
                >华</button>
                <button type="button" class="iconbtn" disabled title="同步美团暂未开放">美</button>
                <button type="button" class="iconbtn" title="删除" @click="askDelete(record)">⌫</button>
              </span>
            </a-table>
          </div>

          <div class="ant-table-pagination list-pagination">
            <span class="pagination-total">共 {{ pagination.total }} 条</span>
            <a-pagination
              :current="pagination.current"
              :page-size="pagination.pageSize"
              :total="pagination.total"
              :page-size-options="pagination.pageSizeOptions"
              show-size-changer
              @change="onPageChange"
              @showSizeChange="onShowSizeChange"
            />
          </div>
        </div>
      </main>
    </div>

    <div v-if="formVisible" class="product-archive-form-page product-form-drawer" :class="{ 'form-readonly': formReadonly, 'form-mode-sku': formMode === 'sku' }">
      <div class="archive-page-title">
        <div>
          <h1>{{ formPageTitle }}</h1>
          <p>{{ formMode === 'sku' ? '直接维护 SKU 级商品信息；保存后系统自动生成所属 SPU，并建立固定归属关系。' : '基础信息维护商品 SPU 级主数据；规格级销售与采购属性在「规格信息」中维护。' }}</p>
        </div>
        <div class="archive-page-title-right">
          <span class="archive-page-badge">{{ formPageBadge }}</span>
          <div class="archive-page-actions">
            <template v-if="formReadonly">
              <a-button @click="closeFormPage">返回列表</a-button>
              <a-button type="primary" @click="switchFormToEdit">编辑</a-button>
            </template>
            <template v-else-if="formMode === 'sku'">
              <a-button @click="closeFormPage">返回列表</a-button>
              <a-button type="primary" :loading="submitLoading" @click="saveForm">{{ form.id ? '保存' : '保存SKU并自动生成SPU' }}</a-button>
            </template>
            <template v-else-if="formTab === 'sku'">
              <a-button @click="closeFormPage">返回列表</a-button>
              <a-button type="primary" :loading="submitLoading" @click="saveSku(false, false)">保存</a-button>
              <a-button :loading="submitLoading" @click="saveSkuAndEnterPrice">保存并进入价格体系</a-button>
            </template>
            <template v-else>
              <a-button @click="closeFormPage">返回列表</a-button>
              <a-button type="primary" :loading="submitLoading" @click="saveForm">保存</a-button>
              <a-button :loading="submitLoading" @click="saveFormAndEnterSku">保存并进入规格信息</a-button>
            </template>
          </div>
        </div>
      </div>

      <div class="product-archive-form-scroll">
      <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
        layout="horizontal"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }">
        <!-- SKU直建：单页版式（字段与 SPU 一致，仅隐藏 Tab 纵向展开） -->
        <div v-if="formMode === 'sku'" class="sku-direct-single-tab">
          <span class="sku-direct-single-tab-item">{{ form.id ? 'SKU商品档案' : '创建SKU商品档案' }}</span>
        </div>
        <!-- SPU：双 Tab；SKU直建：同字段单页滚动 -->
        <template>
          <a-tabs v-model="formTab" class="product-form-tabs" :animated="false" @change="onFormTabChange">
            <a-tab-pane key="base" tab="基础信息" force-render>
              <div class="form-panel tab-pane-body">
                <section class="section">
                  <div class="section-head"><div class="section-title">基本信息 <small>商品主体、分类、计量及效期</small></div></div>
                  <a-row :gutter="24">
                    <a-col :span="12">
                      <a-form-model-item label="所属分类" prop="categoryId">
                        <div class="fake-select" role="button" tabindex="0" :class="{ 'is-placeholder': !categoryPickerLabel }" @click="openCategoryPicker">
                          <span class="fake-select-text">{{ categoryPickerLabel || '请选择商品分类' }}</span>
                          <span class="fake-select-arrow">⌄</span>
                        </div>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="商品名称" prop="spuName"><a-input v-model="form.spuName" placeholder="请输入商品名称" /></a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="商品别名"><a-input v-model="form.alias" placeholder="可输入多个别名，以空格区分" /></a-form-model-item>
                    </a-col>
                    <a-col v-if="formMode === 'sku'" :span="12">
                      <a-form-model-item label="建档方式"><a-input value="SKU直建 · 系统自动生成SPU" disabled /></a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="商品类型">
                        <a-select v-model="form.productType" placeholder="请选择"><a-select-option value="标准产品">标准产品</a-select-option><a-select-option value="非标准产品">非标准产品</a-select-option></a-select>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="商品编码"><a-input v-model="form.spuCode" :placeholder="formMode === 'sku' ? '保存后自动生成所属SPU编码，支持手动修改' : '系统自动生成，支持手动修改'" /></a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="自定义编码" prop="customCode">
                        <a-input
                          v-model="form.customCode"
                          :disabled="formReadonly || customCodeLocked"
                          placeholder="必填，保存后不可修改"
                          maxlength="64"
                        />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="基本单位" prop="baseUnit">
                        <a-select v-model="form.baseUnit" placeholder="请选择" @change="syncBaseUnit"><a-select-option v-for="o in unitOptions" :key="o" :value="o">{{ o }}</a-select-option></a-select>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="品牌">
                        <a-select v-model="form.brand" show-search allow-clear placeholder="请选择品牌"><a-select-option v-for="o in brandOptions" :key="o" :value="o">{{ o }}</a-select-option></a-select>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="温区">
                        <a-select v-model="form.tempZone" placeholder="请选择"><a-select-option v-for="o in tempOptions" :key="o" :value="o">{{ o }}</a-select-option></a-select>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="采购属性">
                        <a-select v-model="form.purchaseAttr" placeholder="请选择" @change="onPurchaseAttrChange"><a-select-option value="临采">临采</a-select-option><a-select-option value="备货">备货</a-select-option></a-select>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="采购方式"><a-radio-group v-model="form.purchaseMethod"><a-radio value="订单采购">订单采购</a-radio><a-radio value="库存采购">库存采购</a-radio></a-radio-group></a-form-model-item>
                    </a-col>
                    <a-col :span="12" v-if="form.purchaseAttr === '备货'">
                      <a-form-model-item label="智能补货规则">
                        <a-select v-model="form.smartReplenishment" placeholder="请选择"><a-select-option value="安全库存补货">安全库存补货</a-select-option><a-select-option value="销量预测补货">销量预测补货</a-select-option><a-select-option value="上下限补货">上下限补货</a-select-option><a-select-option value="周期补货">周期补货</a-select-option></a-select>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="绩效方式"><a-radio-group v-model="form.performanceMethod"><a-radio value="计重">计重</a-radio><a-radio value="计件">计件</a-radio></a-radio-group></a-form-model-item>
                    </a-col>
                    <a-col v-if="showLossRate" :span="12">
                      <a-form-model-item label="耗损比例">
                        <div style="display:flex;align-items:center;gap:6px">
                          <a-input-number v-model="form.lossRate" :min="0" :precision="1" style="flex:1" />
                          <span>%</span>
                        </div>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="产地"><a-input v-model="form.origin" placeholder="如：山东寿光" /></a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="保质期">
                        <div style="display:flex;align-items:center;gap:6px">
                          <a-input-number v-model="form.shelfLifeDays" :min="0" style="flex:1" placeholder="请输入保质期" />
                          <span>天</span>
                        </div>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </section>
                <section class="section">
                  <div class="section-head"><div class="section-title">商品资料 <small>图片、视频、描述、标签及品质标准</small></div></div>
                  <a-row :gutter="24">
                    <a-col :span="12">
                      <a-form-model-item label="商品图片"><product-attachment-upload v-model="form.image" kind="image" /></a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="商品视频"><product-attachment-upload v-model="form.video" kind="video" /></a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="描述"><a-textarea v-model="form.description" :rows="3" placeholder="请输入商品基础描述" /></a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="商品标签"><a-select mode="multiple" v-model="form.tags" allow-clear placeholder="请选择商品标签"><a-select-option v-for="o in tagOptions" :key="o" :value="o">{{ o }}</a-select-option></a-select></a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="商品特征"><a-textarea v-model="form.feature" :rows="3" placeholder="请输入商品特征" /></a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="售后标准"><a-textarea v-model="form.afterSale" :rows="3" placeholder="请输入验收 / 售后标准" /></a-form-model-item>
                    </a-col>
                  </a-row>
                </section>
                <section class="section">
                  <div class="section-head"><div class="section-title">财税与质量信息 <small>税务与开票</small></div></div>
                  <a-row :gutter="24">
                    <a-col :span="12">
                      <a-form-model-item label="商品税率">
                        <div style="display:flex;align-items:center;gap:6px">
                          <a-input-number v-model="form.taxRate" :min="0" :max="100" :precision="2" style="flex:1" />
                          <span>%</span>
                        </div>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="开票名称"><a-input v-model="form.invoiceName" placeholder="请输入开票名称" /></a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="税收编码"><a-input v-model="form.taxCode" placeholder="请输入税收编码" /></a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="大类名称"><a-input v-model="form.taxCategory" placeholder="请输入大类名称" /></a-form-model-item>
                    </a-col>
                  </a-row>
                </section>
              </div>
            </a-tab-pane>
            <a-tab-pane key="sku" tab="规格信息" force-render>
              <div class="tab-pane-body sku-tab-body">
                <div class="sku-form-page">
                  <section class="sku-detail" v-if="activeSku">
                    <div class="sku-toolbar">
                      <div>
                        <h3 class="sku-detail-title">
                          {{ activeSku.skuName ? ('规格信息 - ' + activeSku.skuName) : '规格信息' }}
                        </h3>
                        <div class="sku-meta">
                          SKU编码：{{ activeSku.skuCode || '待生成' }}
                          　状态：{{ normalizeStatus(activeSku.status) }}
                          <template v-if="form.spuCode">　所属SPU：{{ form.spuCode }}</template>
                        </div>
                      </div>
                    </div>

                    <a-tabs v-model="skuInnerTab" class="sku-inner-tabs" :animated="false">
                      <!-- 二级 Tab：规格信息 = Demo skuDetailBody / .sku-spec-section -->
                      <a-tab-pane key="spec" tab="规格信息" force-render>
                        <!-- 对齐最新 Demo product_archive.html #skuDetailBody -->
                        <div class="section">
                          <div class="section-head">
                            <div class="section-title">
                              销售信息
                              <small>销售规格与基础属性</small>
                            </div>
                          </div>
                          <a-row :gutter="24">
                            <a-col :span="12">
                              <a-form-model-item label="SKU编码">
                                <a-input v-model="activeSku.skuCode" placeholder="系统保存后自动生成，支持手动修改" />
                              </a-form-model-item>
                            </a-col>
                            <a-col :span="12" />
                            <a-col :span="12">
                              <a-form-model-item label="规格名称" required>
                                <a-input v-model="activeSku.skuName" placeholder="请输入规格名称" />
                              </a-form-model-item>
                            </a-col>
                            <a-col :span="24">
                              <div class="section-title" style="margin:4px 0 12px">单位配置 <small>基本单位与左侧商品信息同步；库存仍按规格原核算单位记账</small></div>
                            </a-col>
                            <a-col :span="12">
                              <a-form-model-item label="基本单位" required>
                                <a-select
                                  :key="'sku-base-unit-' + activeSkuIndex + '-' + skuBaseUnitSelectValue(activeSku)"
                                  :value="skuBaseUnitSelectValue(activeSku)"
                                  placeholder="请选择"
                                  @change="onConfigBaseChange(activeSku, $event)">
                                  <a-select-option v-for="o in unitOptions" :key="o" :value="o">{{ o }}</a-select-option>
                                </a-select>
                              </a-form-model-item>
                            </a-col>
                            <a-col :span="12">
                              <a-form-model-item label="整箱单位" :required="activeSku.saleUnitMode === 'case'">
                                <a-select
                                  v-model="activeSku.caseUnitName"
                                  placeholder="默认与基本单位相同"
                                  @change="onCaseUnitChange(activeSku, $event)">
                                  <a-select-option v-for="o in unitOptions" :key="'case-' + o" :value="o">{{ o }}</a-select-option>
                                </a-select>
                              </a-form-model-item>
                            </a-col>
                            <a-col :span="12">
                              <a-form-model-item label="销售单位" required>
                                <a-radio-group :value="activeSku.saleUnitMode || 'base'" @change="onSaleModeChange(activeSku, $event)">
                                  <a-radio value="base">基本单位</a-radio>
                                  <a-radio value="case">整箱单位</a-radio>
                                </a-radio-group>
                              </a-form-model-item>
                            </a-col>
                            <a-col :span="12">
                              <a-form-model-item label="箱规" :required="activeSku.saleUnitMode === 'case'">
                                <a-input-number
                                  v-model="activeSku.caseRate"
                                  :min="0.000001"
                                  :precision="6"
                                  style="width:100%"
                                  placeholder="默认 1" />
                                <div class="help">1 整箱单位 = 箱规 × 基本单位。默认 1，即 1:1。</div>
                              </a-form-model-item>
                            </a-col>
                            <a-col :span="12">
                              <a-form-model-item label="最小下单数" required>
                                <div style="display:flex;align-items:center;gap:8px">
                                  <a-input-number v-model="activeSku.minQty" :min="0" style="flex:1" />
                                  <span class="help" style="margin:0;white-space:nowrap">{{ skuSaleUnit(activeSku) }}</span>
                                </div>
                              </a-form-model-item>
                            </a-col>
                            <a-col :span="12">
                              <a-form-model-item label="毛重(kg)">
                                <a-input-number v-model="activeSku.grossWeight" :min="0" :precision="3" style="width: 100%" placeholder="请输入毛重" />
                              </a-form-model-item>
                            </a-col>
                            <a-col :span="12">
                              <a-form-model-item label="净重(kg)">
                                <a-input-number v-model="activeSku.netWeight" :min="0" :precision="3" style="width: 100%" placeholder="请输入净重" />
                              </a-form-model-item>
                            </a-col>
                            <a-col :span="12">
                              <a-form-model-item label="体积(m³)">
                                <a-input-number v-model="activeSku.volume" :min="0" :precision="3" style="width: 100%" placeholder="请输入体积" />
                              </a-form-model-item>
                            </a-col>
                            <a-col :span="12">
                              <a-form-model-item label="损耗比例">
                                <div style="display:flex;align-items:center;gap:6px">
                                  <a-input-number v-model="activeSku.lossRate" :min="0" :precision="1" style="flex:1" />
                                  <span>%</span>
                                </div>
                              </a-form-model-item>
                            </a-col>
                            <a-col :span="12">
                              <a-form-model-item label="是否称重">
                                <a-radio-group v-model="activeSku.weigh">
                                  <a-radio value="是">是</a-radio>
                                  <a-radio value="否">否</a-radio>
                                </a-radio-group>
                              </a-form-model-item>
                            </a-col>
                          </a-row>
                        </div>

                        <div class="section">
                          <div class="section-head">
                            <div class="section-title">
                              更多设置
                              <small>规格编码、状态、区域、图片及商品描述</small>
                            </div>
                          </div>
                          <a-row :gutter="24">
                            <a-col :span="12">
                              <a-form-model-item label="分拣分包">
                                <a-switch
                                  :checked="activeSku.sorting === '开启'"
                                  checked-children="开"
                                  un-checked-children="关"
                                  @change="v => { activeSku.sorting = v ? '开启' : '关闭' }"
                                />
                              </a-form-model-item>
                            </a-col>
                            <a-col :span="12">
                              <a-form-model-item label="区域">
                                <a-input v-model="activeSku.region" placeholder="请输入区域" />
                              </a-form-model-item>
                            </a-col>
                            <a-col :span="12">
                              <a-form-model-item label="商品图片">
                                <product-attachment-upload v-model="activeSku.image" kind="image" />
                                <div class="help">默认继承商品主图，规格可单独维护。</div>
                              </a-form-model-item>
                            </a-col>
                            <a-col :span="12">
                              <a-form-model-item label="产地">
                                <a-input v-model="activeSku.origin" placeholder="请输入产地" />
                              </a-form-model-item>
                            </a-col>
                            <a-col :span="12">
                              <a-form-model-item label="描述" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                                <a-textarea v-model="activeSku.skuDesc" :rows="2" placeholder="规格描述" />
                              </a-form-model-item>
                            </a-col>
                            <a-col :span="12">
                              <a-form-model-item label="商品规格">
                                <a-textarea v-model="activeSku.specDesc" :rows="2" placeholder="如：1斤/斤（约500g~600g/斤）" />
                              </a-form-model-item>
                            </a-col>
                            <a-col :span="12">
                              <a-form-model-item label="商品特征">
                                <a-textarea v-model="activeSku.feature" :rows="2" placeholder="规格级商品特征" />
                              </a-form-model-item>
                            </a-col>
                            <a-col :span="12">
                              <a-form-model-item label="售后标准">
                                <a-textarea v-model="activeSku.afterSale" :rows="2" placeholder="规格级售后标准" />
                              </a-form-model-item>
                            </a-col>
                          </a-row>
                        </div>

                        <div class="section">
                          <div class="section-head">
                            <div class="section-title">
                              供应链信息
                              <small>包装、采购说明与库存规则</small>
                            </div>
                          </div>
                          <a-row :gutter="24">
                            <a-col :span="12">
                              <a-form-model-item label="装箱类型">
                                <a-select v-model="activeSku.packType" placeholder="请选择">
                                  <a-select-option v-for="item in packOptions" :key="item" :value="item">{{ item }}</a-select-option>
                                </a-select>
                              </a-form-model-item>
                            </a-col>
                            <a-col :span="24">
                              <a-form-model-item label="采购描述" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                                <a-textarea v-model="activeSku.purchaseDesc" :rows="2" placeholder="请输入采购说明" />
                              </a-form-model-item>
                            </a-col>
                            <a-col :span="12">
                              <a-form-model-item label="库存设置" required>
                                <a-radio-group v-model="activeSku.stockMode">
                                  <a-radio value="虚拟库存">虚拟库存</a-radio>
                                  <a-radio value="实际库存">实际库存</a-radio>
                                  <a-radio value="设置库存">设置库存</a-radio>
                                </a-radio-group>
                              </a-form-model-item>
                            </a-col>
                            <a-col v-if="activeSku.stockMode === '设置库存'" :span="12">
                              <a-form-model-item label="库存数量">
                                <div style="display:flex;align-items:center;gap:6px">
                                  <a-input-number v-model="activeSku.stockValue" :min="0" style="flex:1" />
                                  <span style="white-space:nowrap;color:#8792a5">{{ skuSaleUnitLabel }}</span>
                                </div>
                              </a-form-model-item>
                            </a-col>
                          </a-row>
                        </div>

                        <div class="section">
                          <div class="section-head">
                            <div class="section-title">
                              备注
                              <small>规格级补充说明</small>
                            </div>
                          </div>
                          <a-row :gutter="24">
                            <a-col :span="24">
                              <a-form-model-item label="备注" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                                <a-textarea v-model="activeSku.remark" :rows="4" placeholder="请输入该规格的补充说明或业务备注" />
                              </a-form-model-item>
                            </a-col>
                          </a-row>
                        </div>
                        <section class="section base-info-group">
                          <div class="section-head base-info-group-head">
                            <div class="section-title">仓库信息 <small>按当前规格维护采购属性、采购方式、供应商及供应成本</small></div>
                            <a-button :disabled="!canAddWarehouse" :title="warehouseAddHint" @click="addWarehouse">+ 添加仓库</a-button>
                          </div>
                          <div class="base-info-card">
                            <warehouse-table :rows="form.warehouses" :warehouse-options="warehouseRecords" :supplier-options="supplierRecords" @remove="removeWarehouse" />
                          </div>
                        </section>
                        <section class="section base-info-group">
                          <div class="section-head base-info-group-head">
                            <div class="section-title">商品MOQ设置 <small>按当前规格维护最低采购限制，可按数量或金额控制</small></div>
                            <a-button @click="openMoqModal">+ 添加MOQ规则</a-button>
                          </div>
                          <div class="base-info-card">
                            <moq-table :rows="form.moqs" @remove="removeMoq" />
                          </div>
                        </section>
                      </a-tab-pane>

                      <!-- 二级 Tab：价格体系（规格内维护；侧栏「价格体系」菜单仍隐藏） -->
                      <a-tab-pane key="price" tab="价格体系" force-render>
                        <div v-if="formMode === 'sku'" class="section sku-direct-price-block">
                          <div class="section-head">
                            <div class="section-title">价格体系 <small>规格维度独立维护；保存 SKU 后可绑定仓库指导价</small></div>
                          </div>
                        </div>
                        <guide-price-editor
                          :sku-id="activeSku && activeSku.id"
                          :readonly="formReadonly"
                          :sale-rate="salePriceRate(activeSku)"
                          :sale-unit-name="salePriceUnitName(activeSku)" />
                        <!-- 历史演示配置暂不展示，避免未落库的价格被误认为正式指导价。 -->
                        <div v-if="false" class="price-system-page">
                          <div class="section-head price-system-head">
                            <div class="section-title">
                              仓库价格体系
                              <small>规格维度独立维护，不关联基础信息仓库</small>
                            </div>
                            <div class="price-system-head-actions">
                              <a-button size="small" @click="openAddPriceWarehouseModal">+ 新增仓库</a-button>
                              <a-button
                                v-show="activeSku.customerPriceMode === 'tier'"
                                size="small"
                                class="price-rule-config-btn"
                                @click="openPriceRuleModal(false)"
                              >
                                智能客户销售调价规则
                              </a-button>
                            </div>
                          </div>

                          <div class="price-mode-switch">
                            <span class="price-mode-label">定价方式</span>
                            <a-radio-group
                              :value="activeSku.customerPriceMode"
                              @change="onCustomerPriceModeChange"
                            >
                              <a-radio value="fixed">固定定价</a-radio>
                              <a-radio value="tier">阶梯定价</a-radio>
                            </a-radio-group>
                          </div>

                          <div
                            v-if="!activeSkuWarehousePrices.length"
                            class="price-empty-note"
                          >
                            当前规格尚未添加仓库，请点击右上角“+ 新增仓库”进行配置。
                          </div>

                          <div
                            v-for="(wh, wi) in activeSkuWarehousePrices"
                            :key="wh.warehouse + '-' + wi"
                            class="warehouse-price-card"
                          >
                            <div class="warehouse-price-card-hd">
                              <div class="warehouse-price-card-left">
                                <strong class="warehouse-name">{{ wh.warehouse }}</strong>
                                <span class="price-master-badge">
                                  {{ activeSku.customerPriceMode === 'tier' ? '阶梯定价 · 手动维护' : '固定定价 · 手动维护' }}
                                </span>
                                <span class="warehouse-price-meta">最近自动调整 {{ wh.adjusted || '首次建档' }}</span>
                              </div>
                              <div class="warehouse-price-card-right">
                                <label class="latest-cost-label">
                                  最新进货价金额
                                  <span class="yen">¥</span>
                                  <a-input-number
                                    v-model="wh.latestCost"
                                    :min="0"
                                    :precision="2"
                                    size="small"
                                    style="width: 96px"
                                    @change="v => onLatestCostChange(wi, v)"
                                  />
                                </label>
                                <a class="price-action-link" @click.prevent="openViewPriceRuleModal(wh.warehouse)">查看调价规则</a>
                                <a class="price-action-link danger" @click.prevent="removePriceSystemWarehouse(wi)">删除仓库</a>
                              </div>
                            </div>

                            <div class="warehouse-price-table-wrap">
                              <div class="tier-price-toolbar">
                                <span>{{ activeSku.customerPriceMode === 'tier' ? '阶梯定价：按仓库手动维护价格名称与金额' : '固定定价：按仓库手动维护价格名称与金额' }}</span>
                                <a-button size="small" type="primary" @click="addGuidePriceRow(wi)">+ 添加价格</a-button>
                              </div>
                              <table class="warehouse-price-table">
                                <thead>
                                  <tr>
                                    <th>价格名称</th>
                                    <th>当前价格</th>
                                    <th>上一次价格</th>
                                    <th style="min-width:210px">上架商城</th>
                                    <th style="width:100px">操作</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(row, pi) in (wh.prices || [])" :key="pi">
                                    <td>
                                      <strong v-if="row.isSpecial" class="special-price-name">{{ row.name || '客户特殊价' }}</strong>
                                      <a-input
                                        v-else
                                        v-model="row.name"
                                        size="small"
                                        class="guide-name-input"
                                        placeholder="请输入价格名称"
                                      />
                                    </td>
                                    <td>
                                      <div class="price-input-group">
                                        <span class="yen">¥</span>
                                        <a-input-number
                                          v-model="row.price"
                                          :min="0"
                                          :precision="2"
                                          size="small"
                                          :disabled="!!row.isSpecial || priceRuleAutoStarted"
                                          style="width: 110px"
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div class="price-input-group">
                                        <span class="yen">¥</span>
                                        <a-input-number
                                          v-model="row.previous"
                                          :min="0"
                                          :precision="2"
                                          size="small"
                                          disabled
                                          style="width: 110px"
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div class="mall-checks">
                                        <a-checkbox
                                          v-for="mall in mallOptions"
                                          :key="mall"
                                          :checked="(row.malls || []).indexOf(mall) >= 0"
                                          @change="e => toggleGuideMall(wi, pi, mall, e.target.checked)"
                                        >
                                          {{ mall }}
                                        </a-checkbox>
                                      </div>
                                    </td>
                                    <td>
                                      <a-button
                                        v-if="row.isSpecial"
                                        size="small"
                                        @click="openSpecialPriceRuleModal(wh.warehouse)"
                                      >
                                        规则
                                      </a-button>
                                      <a
                                        v-else
                                        class="danger-link"
                                        @click="removeGuidePriceRow(wi, pi)"
                                      >删除</a>
                                    </td>
                                  </tr>
                                  <tr v-if="!(wh.prices || []).length">
                                    <td colspan="5" class="nutrition-empty">暂无价格，请点击右上角「+ 添加价格」</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </a-tab-pane>
                    </a-tabs>
                  </section>
                </div>
              </div>
            </a-tab-pane>
          </a-tabs>
        </template>

      </a-form-model>
      </div>
    </div>

    <a-drawer
      v-if="detailVisible"
      :visible="detailVisible"
      width="80%"
      :closable="false"
      destroyOnClose
      class="product-detail-drawer erp-doc-drawer baidao-drawer-sample"
      @close="detailVisible = false"
    >
      <template slot="title">
        <div class="drawer-title erp-drawer-header product-detail-header">
          <div class="drawer-heading">
            <button type="button" class="drawer-back-button" title="返回列表" @click.stop="detailVisible = false"><a-icon type="arrow-left" /></button>
            <div><span class="drawer-kicker">商品主数据</span><div class="drawer-main-title">商品详情</div></div>
          </div>
        </div>
      </template>
      <div v-if="detail" class="detail-body">
        <div class="detail-hero">
          <div class="detail-image">
            <img v-if="isResourceUrl(detail.image)" :src="publicAttachmentUrl(detail.image)" alt="商品主图" @click="previewProductImage(detail.image)" />
            <span v-else>{{ detail.image || '🥬' }}</span>
          </div>
          <div>
            <h2>{{ detail.spuName }}</h2>
            <p>{{ detail.spuCode }} ｜ {{ detail.category }} ｜ {{ detail.status }}</p>
            <div class="detail-attachment-links">
              <a v-if="detail.videoUrl" @click="openAttachment(detail.videoUrl)"><a-icon type="play-circle" /> 预览商品视频</a>
            </div>
          </div>
        </div>
        <h3 class="detail-section-title">基础档案</h3>
        <a-descriptions bordered :column="3" size="small">
          <a-descriptions-item v-for="p in detailPairs" :key="p.label" :label="p.label">{{ detailValue(p.value) }}</a-descriptions-item>
        </a-descriptions>
        <h3 class="detail-section-title">商品说明与财税质检</h3>
        <a-descriptions bordered :column="3" size="small">
          <a-descriptions-item v-for="p in detailQualityPairs" :key="p.label" :label="p.label" :span="p.span || 1">
            <a v-if="p.link" @click="openAttachment(p.link)"><a-icon type="paper-clip" /> 查看附件</a>
            <template v-else>{{ detailValue(p.value) }}</template>
          </a-descriptions-item>
        </a-descriptions>
        <h3 class="detail-section-title">仓库采购配置</h3>
        <a-table
          class="product-detail-table"
          rowKey="warehouseId"
          :columns="warehouseDetailColumns"
          :data-source="detail.warehouses || []"
          :pagination="false"
          :scroll="{ x: 1180 }"
          size="small"
          bordered
          :locale="{ emptyText: '当前商品未配置仓库采购属性' }"
        />
        <h3 class="detail-section-title">商品 MOQ 规则</h3>
        <a-table
          class="product-detail-table"
          rowKey="id"
          :columns="moqDetailColumns"
          :data-source="detail.moqs || []"
          :pagination="false"
          size="small"
          bordered
          :locale="{ emptyText: '当前商品未配置 MOQ 规则' }"
        />
        <h3 class="detail-section-title">SKU 规格</h3>
        <a-table
          class="product-detail-table"
          rowKey="skuCode"
          :columns="skuColumns"
          :data-source="detail.skus || []"
          :pagination="false"
          :scroll="{ x: 1160 }"
          size="small"
          bordered
        />
        <section v-for="(sku, index) in (detail.skus || [])" :key="sku.skuCode || index" class="detail-sku-card">
          <div class="detail-sku-card-title"><div><b>{{ sku.skuName || detail.spuName || '未命名 SKU' }}</b><span>{{ sku.skuCode || '未生成 SKU 编码' }}</span></div><a-tag :color="isEnabledStatus(sku.status) ? 'green' : 'default'">{{ statusLabel(sku.status) }}</a-tag></div>
          <a-descriptions bordered :column="4" size="small">
            <a-descriptions-item v-for="p in skuDetailPairs(sku)" :key="p.label" :label="p.label">{{ detailValue(p.value) }}</a-descriptions-item>
          </a-descriptions>
          <div class="detail-subtable-grid">
            <div>
              <h4>仓库价格</h4>
              <table class="detail-mini-table"><thead><tr><th>仓库</th><th>价格名称</th><th>当前价格</th></tr></thead><tbody><template v-for="(warehouse, warehouseIndex) in (sku.warehousePrices || [])"><tr v-for="(price, priceIndex) in (warehouse.prices || [{}])" :key="(warehouse.warehouseId || warehouse.warehouse || warehouseIndex) + '-' + priceIndex"><td>{{ warehouse.warehouse }}</td><td>{{ price.name || '销售指导价' }}</td><td>{{ moneyValue(price.price) }}</td></tr></template><tr v-if="!(sku.warehousePrices || []).length"><td colspan="3" class="detail-empty-cell">未配置仓库价格</td></tr></tbody></table>
            </div>
          </div>
        </section>
      </div>
    </a-drawer>

    <!-- Demo：添加商品MOQ规则 -->
    <a-modal
      title="添加商品MOQ规则"
      :visible="moqModalVisible"
      :width="620"
      ok-text="确定添加"
      cancel-text="取消"
      destroy-on-close
      class="moq-rule-modal"
      @ok="confirmAddMoq"
      @cancel="moqModalVisible = false"
    >
      <a-form-model layout="horizontal" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="MOQ类型" required>
              <a-select v-model="moqDraft.type" style="width:100%" @change="onMoqTypeChange">
                <a-select-option value="qty">按数量</a-select-option>
                <a-select-option value="amount">按金额</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col v-if="moqDraft.type === 'qty'" :span="12">
            <a-form-model-item label="最低采购数量" required>
              <a-input-number
                v-model="moqDraft.value"
                :min="0"
                :precision="2"
                style="width:100%"
                placeholder="请输入数量"
              />
            </a-form-model-item>
          </a-col>
          <a-col v-else :span="12">
            <a-form-model-item label="最低采购金额" required>
              <a-input-number
                v-model="moqDraft.value"
                :min="0"
                :precision="2"
                style="width:100%"
                placeholder="请输入金额"
              />
            </a-form-model-item>
          </a-col>
          <a-col v-if="moqDraft.type === 'qty'" :span="12">
            <a-form-model-item label="计量单位" required>
              <a-select v-model="moqDraft.unit" style="width:100%" placeholder="请选择">
                <a-select-option v-for="u in moqUnitOptions" :key="u" :value="u">{{ u }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="备注" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
              <a-input v-model="moqDraft.remark" placeholder="请输入备注（选填）" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>

    <!-- Demo：新增仓库弹窗 -->
    <a-modal
      title="新增仓库"
      :visible="priceWarehouseModalVisible"
      :width="420"
      ok-text="确定添加"
      cancel-text="取消"
      destroy-on-close
      @ok="confirmAddPriceSystemWarehouse"
      @cancel="priceWarehouseModalVisible = false"
    >
      <div class="field" style="margin-bottom:8px">
        <div style="margin-bottom:6px;font-weight:600">仓库</div>
        <a-select v-model="priceWarehouseDraft" style="width:100%" placeholder="请选择仓库">
          <a-select-option v-for="w in availablePriceWarehouses" :key="w" :value="w">{{ w }}</a-select-option>
        </a-select>
      </div>
      <div class="help">仅用于当前规格的价格体系维护，与基础信息中的仓库独立。</div>
    </a-modal>

    <!-- Demo：采购价区间与调价规则 -->
    <a-modal
      :title="priceRuleModalTitle"
      :visible="priceRuleModalVisible"
      :width="860"
      :ok-text="priceRuleReadonly ? '关闭' : '确定'"
      cancel-text="取消"
      :cancel-button-props="priceRuleReadonly ? { style: { display: 'none' } } : {}"
      destroy-on-close
      @ok="savePriceRules"
      @cancel="priceRuleModalVisible = false"
    >
      <template v-if="priceRuleReadonly" slot="footer">
        <a-button type="primary" @click="priceRuleModalVisible = false">关闭</a-button>
      </template>
      <div class="help" style="margin-bottom:12px">
        一套调价规则可同时适用于多个仓库。系统按各仓库的 SKU 最新采购入库价匹配价格区间，并调用对应价格公式模板自动计算价格体系。
      </div>
      <div style="margin-bottom:14px">
        <span class="price-hint">适用仓库（可多选）</span>
        <div v-if="priceRuleReadonly" style="margin-top:8px;color:#64748b">
          适用仓库：
          <strong>{{ (priceRuleDraft.ruleWarehouses || []).join('、') || '暂未配置' }}</strong>
        </div>
        <div v-else style="display:flex;gap:16px;flex-wrap:wrap;margin-top:8px">
          <a-checkbox
            v-for="w in activeSkuWarehousePrices"
            :key="w.warehouse"
            :checked="(priceRuleDraft.ruleWarehouses || []).indexOf(w.warehouse) >= 0"
            @change="e => toggleRuleWarehouse(w.warehouse, e.target.checked)"
          >
            {{ w.warehouse }}
          </a-checkbox>
        </div>
      </div>
      <div class="price-range-table-wrap">
        <table class="warehouse-price-table price-range-table">
          <thead>
            <tr>
              <th style="width:90px">操作</th>
              <th style="width:15%">采购价下限（含）</th>
              <th style="width:15%">采购价上限（不含）</th>
              <th>价格公式模板</th>
              <th>模板公式摘要</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(r, i) in priceRuleDraft.ranges" :key="i">
              <td>
                <a-button
                  v-if="!priceRuleReadonly"
                  size="small"
                  type="danger"
                  ghost
                  @click="removePriceRange(i)"
                >
                  删除
                </a-button>
                <span v-else>—</span>
              </td>
              <td>
                <a-input-number v-model="r.min" :min="0" :disabled="priceRuleReadonly" style="width:100%" />
              </td>
              <td>
                <a-input-number
                  v-model="r.max"
                  :min="0"
                  :disabled="priceRuleReadonly"
                  placeholder="无上限"
                  style="width:100%"
                />
              </td>
              <td>
                <a-select v-model="r.tpl" :disabled="priceRuleReadonly" style="width:100%">
                  <a-select-option v-for="t in formulaTemplateKeys" :key="t" :value="t">{{ t }}</a-select-option>
                </a-select>
              </td>
              <td>
                <span
                  v-for="(chip, ci) in (FORMULA_TEMPLATES[r.tpl] || []).slice(0, 3)"
                  :key="ci"
                  class="formula-chip"
                >{{ chip }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <a-button
        v-if="!priceRuleReadonly"
        size="small"
        style="margin-top:12px"
        @click="addPriceRange"
      >
        + 添加价格区间
      </a-button>
    </a-modal>

    <!-- Demo：客户特殊价调价规则 -->
    <a-modal
      title="客户特殊价调价规则"
      :visible="specialPriceRuleModalVisible"
      :width="760"
      ok-text="保存规则"
      cancel-text="取消"
      destroy-on-close
      @ok="saveSpecialPriceRule"
      @cancel="specialPriceRuleModalVisible = false"
    >
      <div class="special-rule-section">
        <h4>适用客户</h4>
        <a-row :gutter="16">
          <a-col :span="12">
            <div class="field-label"><span class="req">*</span> 适用客户</div>
            <a-select v-model="specialRuleDraft.scope" style="width:100%" @change="onSpecialScopeChange">
              <a-select-option value="all">全部已绑定特殊定价客户</a-select-option>
              <a-select-option value="specified">指定客户</a-select-option>
            </a-select>
          </a-col>
          <a-col v-if="specialRuleDraft.scope === 'specified'" :span="12">
            <div class="field-label"><span class="req">*</span> 选择客户</div>
            <a-select v-model="specialRuleDraft.customers" mode="multiple" style="width:100%" placeholder="请选择客户">
              <a-select-option value="永辉超市（郑州店）">永辉超市（郑州店）</a-select-option>
              <a-select-option value="丹尼斯大卫城店">丹尼斯大卫城店</a-select-option>
              <a-select-option value="华润万家郑州店">华润万家郑州店</a-select-option>
              <a-select-option value="苏果社区店（奥体店）">苏果社区店（奥体店）</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </div>
      <div class="special-rule-section">
        <h4>跟价基准</h4>
        <a-row :gutter="16">
          <a-col :span="12">
            <div class="field-label"><span class="req">*</span> 参与销售指导价</div>
            <a-select v-model="specialRuleDraft.guide" style="width:100%">
              <a-select-option value="销售指导价1">销售指导价1</a-select-option>
              <a-select-option value="销售指导价2">销售指导价2</a-select-option>
              <a-select-option value="销售指导价1 + 销售指导价2">销售指导价1 + 销售指导价2</a-select-option>
              <a-select-option value="销售指导价1 + 销售指导价2 + 销售指导价3">销售指导价1 + 销售指导价2 + 销售指导价3</a-select-option>
            </a-select>
          </a-col>
          <a-col :span="12">
            <div class="field-label"><span class="req">*</span> 基准计算方式</div>
            <a-select v-model="specialRuleDraft.basis" style="width:100%">
              <a-select-option value="单指导价">单指导价</a-select-option>
              <a-select-option value="平均值">平均值</a-select-option>
              <a-select-option value="加权平均">加权平均</a-select-option>
              <a-select-option value="求和">求和</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </div>
      <div class="special-rule-section">
        <h4>涨跌跟价规则</h4>
        <a-row :gutter="16">
          <a-col :span="12">
            <div class="field-label"><span class="req">*</span> 基准每上涨（元）</div>
            <a-input-number v-model="specialRuleDraft.riseBase" :min="0" :precision="2" style="width:100%" />
          </a-col>
          <a-col :span="12">
            <div class="field-label"><span class="req">*</span> 特殊价上涨（元）</div>
            <a-input-number v-model="specialRuleDraft.risePrice" :min="0" :precision="2" style="width:100%" />
          </a-col>
          <a-col :span="12">
            <div class="field-label"><span class="req">*</span> 基准每下降（元）</div>
            <a-input-number v-model="specialRuleDraft.fallBase" :min="0" :precision="2" style="width:100%" />
          </a-col>
          <a-col :span="12">
            <div class="field-label"><span class="req">*</span> 特殊价下降（元）</div>
            <a-input-number v-model="specialRuleDraft.fallPrice" :min="0" :precision="2" style="width:100%" />
          </a-col>
        </a-row>
      </div>
      <div class="fin-tip">
        <b>计算逻辑：</b>比较本次与上一次指导价基准；上涨与下降分别按对应跟价幅度更新当前客户特殊价。
      </div>
    </a-modal>

    <a-modal
      :title="categoryModalMode === 'edit' ? '编辑商品类型' : '新建商品类型'"
      :visible="categoryModalVisible"
      :confirm-loading="categorySaving"
      ok-text="保存"
      cancel-text="取消"
      width="720px"
      wrap-class-name="archive-op-modal"
      destroy-on-close
      @ok="submitCategory"
      @cancel="categoryModalVisible = false"
    >
      <div class="archive-op">
        <div class="archive-op-summary">
          <div><span>功能模块</span><b>商品管理 / 商品档案</b></div>
          <div><span>当前操作</span><b>{{ categoryModalMode === 'edit' ? '编辑商品类型' : '新建商品类型' }}</b></div>
          <div><span>操作对象</span><b>{{ categoryModalMode === 'edit' ? (categoryForm.categoryName || '未选择') : categoryForm.parentName }}</b></div>
        </div>
        <div class="archive-op-section">
          <div class="archive-op-title">类型信息</div>
          <div class="archive-op-body">
            <div class="archive-op-grid">
              <label v-if="categoryModalMode === 'create'" class="archive-op-field">
                <span>上级类型</span>
                <a-input :value="categoryForm.parentName" disabled />
              </label>
              <label class="archive-op-field">
                <span>类型名称</span>
                <a-input v-model="categoryForm.categoryName" placeholder="请输入类型名称" />
              </label>
              <label class="archive-op-field">
                <span>类型编码</span>
                <a-input v-model="categoryForm.categoryCode" placeholder="系统自动生成" />
              </label>
              <label v-if="categoryModalMode === 'edit'" class="archive-op-field">
                <span>商品数量</span>
                <a-input :value="String(categoryForm.productCount)" disabled />
              </label>
              <label class="archive-op-field">
                <span>排序号</span>
                <a-input-number v-model="categoryForm.sortNo" :min="0" :precision="0" style="width:100%" />
              </label>
              <label class="archive-op-field">
                <span>状态</span>
                <a-select v-model="categoryForm.status">
                  <a-select-option value="启用">启用</a-select-option>
                  <a-select-option value="停用">停用</a-select-option>
                </a-select>
              </label>
              <label class="archive-op-field archive-op-field-full">
                <span>备注</span>
                <a-textarea v-model="categoryForm.remark" :rows="3" placeholder="请输入类型说明" />
              </label>
            </div>
          </div>
        </div>
      </div>
    </a-modal>

    <a-modal
      :visible="categoryPickerVisible"
      title="选择商品分类"
      ok-text="确定"
      cancel-text="取消"
      width="760px"
      :mask-closable="false"
      @ok="confirmCategoryPicker"
      @cancel="categoryPickerVisible = false"
    >
      <div class="category-grid">
        <div v-for="(column, index) in categoryPickerColumns" :key="index" class="cat-col">
          <div class="cat-title">{{ ['一级分类', '二级分类', '三级分类'][index] }}</div>
          <div
            v-for="node in column"
            :key="node.id"
            class="cat-item"
            role="button"
            :class="{ active: String(categoryPickerSelected[index]) === String(node.id) }"
            @click="pickCategoryLevel(index, node)"
          >{{ node.name }}</div>
        </div>
      </div>
      <div class="category-picker-current">当前选择：<b>{{ categoryPickerPathText || '未选择' }}</b></div>
    </a-modal>

    <a-modal
      :visible="deleteVisible"
      title="删除商品档案"
      :confirm-loading="deleteLoading"
      ok-text="确认删除"
      cancel-text="取消"
      @ok="confirmDelete"
      @cancel="deleteVisible = false"
    >
      <p>确认删除商品 <b>{{ deleteTarget && deleteTarget.spuName }}</b>？删除后不再出现在商品档案列表，历史单据仍保留。</p>
    </a-modal>

    <a-modal
      :title="moreTitle"
      :visible="moreVisible"
      :width="720"
      wrap-class-name="archive-op-modal"
      :mask-closable="false"
      :closable="!importing && !batchSaving && !exporting"
      @cancel="closeProductMore"
    >
      <div class="archive-op">
        <div class="archive-op-summary">
          <div><span>功能模块</span><b>商品管理 / 商品档案</b></div>
          <div><span>当前操作</span><b>{{ moreTitle }}</b></div>
          <div><span>操作对象</span><b>{{ moreTarget }}</b></div>
        </div>
        <div v-if="moreStep === 'choose'" class="archive-op-section">
          <div class="archive-op-title">选择操作</div>
          <div class="archive-op-body">
            <div class="option-list">
              <label class="option"><input v-model="moreAction" type="radio" value="批量导入"><span><b>批量导入</b><div class="help">下载模板后导入商品主数据及基础分类</div></span></label>
              <label class="option"><input v-model="moreAction" type="radio" value="导出"><span><b>导出商品档案</b><div class="help">按当前筛选条件生成 Excel 文件</div></span></label>
            </div>
          </div>
        </div>
        <template v-else-if="moreStep === 'import'">
          <div class="archive-op-note">请选择模板或导出的 Excel。导出后再改数据导入时，请把「重复数据」选为「更新」。自定义编码必填、全库不可重复，保存后不可修改。分类、品牌、基本单位、温区、装箱类型和商品标签在档案里没有时会自动创建。仓库和供应商必须已经存在。同一规格、同一仓库只能有一条当前价格。</div>
          <div class="archive-op-section">
            <div class="archive-op-title">批量导入设置</div>
            <div class="archive-op-body">
              <div class="archive-op-grid">
                <label class="archive-op-field archive-op-field-full">
                  <span>导入模板</span>
                  <div><a-button icon="download" @click="downloadProductImportTemplate">下载模板</a-button></div>
                </label>
                <label class="archive-op-field archive-op-field-full">
                  <span>导入文件</span>
                  <a-upload
                    accept=".xlsx,.xls"
                    :multiple="false"
                    :file-list="importFileList"
                    :disabled="importing"
                    :before-upload="beforeProductImport"
                    :remove="removeProductImportFile"
                  >
                    <a-button icon="upload">选择 Excel 文件</a-button>
                  </a-upload>
                </label>
                <label class="archive-op-field archive-op-field-full">
                  <span>重复数据</span>
                  <a-select v-model="importDuplicateMode">
                    <a-select-option value="update">更新（已存在则覆盖修改）</a-select-option>
                    <a-select-option value="skip">跳过（已存在则不导入）</a-select-option>
                  </a-select>
                </label>
              </div>
              <div v-if="importResult" style="margin-top:16px">
                <a-alert
                  :type="importResult.failureCount ? 'warning' : 'success'"
                  show-icon
                  :message="importResultMessage"
                />
                <a-table
                  v-if="importResult.errorRows && importResult.errorRows.length"
                  style="margin-top:12px"
                  size="small"
                  row-key="rowNumber"
                  :pagination="false"
                  :data-source="importResult.errorRows"
                  :columns="importErrorColumns"
                  :scroll="{ y: 240 }"
                />
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="moreStep === 'batch'">
          <div class="archive-op-note">{{ selectedRowKeys.length ? '确认后只修改已勾选商品。品牌或基本单位在档案中没有时会自动创建。' : '请先关闭弹窗，并在列表中勾选需要修改的商品。' }}</div>
          <div v-if="selectedRowKeys.length" class="archive-op-section">
            <div class="archive-op-title">批量修改设置</div>
            <div class="archive-op-body">
              <div class="archive-op-grid">
                <label class="archive-op-field">
                  <span>修改字段</span>
                  <a-select v-model="batchField" @change="batchValue = undefined">
                    <a-select-option value="品牌">品牌</a-select-option>
                    <a-select-option value="商品状态">商品状态</a-select-option>
                    <a-select-option value="基本单位">基本单位</a-select-option>
                  </a-select>
                </label>
                <label class="archive-op-field">
                  <span>修改为</span>
                  <a-select v-if="batchField === '商品状态'" v-model="batchValue" placeholder="请选择">
                    <a-select-option value="启用">启用</a-select-option>
                    <a-select-option value="停用">停用</a-select-option>
                  </a-select>
                  <a-select v-else-if="batchField === '品牌'" v-model="batchValue" show-search allow-clear placeholder="请选择或输入品牌" mode="combobox">
                    <a-select-option v-for="o in brandOptions" :key="o" :value="o">{{ o }}</a-select-option>
                  </a-select>
                  <a-select v-else v-model="batchValue" show-search allow-clear placeholder="请选择或输入基本单位" mode="combobox">
                    <a-select-option v-for="o in unitOptions" :key="o" :value="o">{{ o }}</a-select-option>
                  </a-select>
                </label>
              </div>
            </div>
          </div>
        </template>
        <div v-else class="archive-op-section">
          <div class="archive-op-title">导出设置</div>
          <div class="archive-op-body">
            <div class="archive-op-note">导出为 Excel（.xlsx），字段与导入模板一致，可修改后按「更新」模式重新导入。</div>
            <div class="archive-op-grid">
              <label class="archive-op-field archive-op-field-full">
                <span>导出范围</span>
                <a-select v-model="exportScope">
                  <a-select-option value="filter">当前筛选结果</a-select-option>
                  <a-select-option value="selected">已勾选商品</a-select-option>
                  <a-select-option value="all">全部商品</a-select-option>
                </a-select>
              </label>
            </div>
          </div>
        </div>
      </div>
      <template slot="footer">
        <a-button v-if="moreStep !== 'choose'" :disabled="importing || batchSaving || exporting" @click="moreStep = 'choose'">上一步</a-button>
        <a-button :disabled="importing || batchSaving || exporting" @click="closeProductMore">取消</a-button>
        <a-button v-if="moreStep === 'choose'" type="primary" @click="confirmMoreAction">下一步</a-button>
        <a-button v-else-if="moreStep === 'import'" type="primary" :loading="importing" :disabled="!importFileList.length" @click="submitProductImport">确认执行</a-button>
        <a-button v-else-if="moreStep === 'batch'" type="primary" :loading="batchSaving" :disabled="!selectedRowKeys.length" @click="submitProductBatch">确认执行</a-button>
        <a-button v-else type="primary" :loading="exporting" @click="submitProductExport">生成导出任务</a-button>
      </template>
    </a-modal>

    <a-modal
      :visible="productImagePreviewVisible"
      :footer="null"
      centered
      width="auto"
      wrap-class-name="product-image-preview-modal"
      destroy-on-close
      @cancel="closeProductImagePreview"
    >
      <img v-if="productImagePreviewUrl" class="product-image-preview-full" :src="productImagePreviewUrl" alt="商品图片预览">
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import {
  pageProduct,
  getProduct,
  createProduct,
  updateProduct,
  enableProduct,
  disableProduct,
  batchEnableProduct,
  batchDisableProduct,
  deleteProduct,
  checkBarcode,
  checkSpuCode,
  checkCustomCode,
  checkSkuCode,
  importProduct,
  batchEditProduct,
  batchSyncHuazhuProduct
} from '@/api/erp/product'
import {
  treeProductCategory,
  addProductCategory,
  editProductCategory,
  enableProductCategory,
  disableProductCategory,
  deleteProductCategory
} from '@/api/erp/productCategory'
import { parseErpApiErrorMessage } from '@/utils/erpOpenApiContext'
import GuidePriceEditor from './GuidePriceEditor.vue'
import ProductAttachmentUpload from './ProductAttachmentUpload.vue'
import { getDicts } from '@/api/system/dict/data'
import { listWarehouse } from '@/api/erp/warehouse'
import { listSupplier } from '@/api/erp/supplier'
import { listGuidePrice } from '@/api/erp/guidePrice'
import ErpSearchSelect from '@/components/Erp/ErpSearchSelect.vue'
import { convertBigIntToString } from '@/utils/json-bigint'

const warehouseOptions = ['郑州一仓', '郑州二仓', '合肥一仓', '武汉常温仓', '南京冷链仓']

/** 雪花 ID 统一为字符串，避免下拉/提交丢精度 */
function entityIdStr (v) {
  if (v == null || v === '') return undefined
  const s = String(v).trim()
  return s || undefined
}

function warehouseRowDisplayName (row, warehouseRecords) {
  const named = String((row && row.warehouse) || '').trim()
  if (named) return named
  const master = (warehouseRecords || []).find(x => String(x.id) === String(row && row.warehouseId))
  return master ? master.name : ''
}

function findMasterByIdOrName (records, id, name) {
  const list = records || []
  if (id != null && id !== '') {
    const byId = list.find(x => String(x.id) === String(id))
    if (byId) return byId
  }
  const n = String(name || '').trim()
  if (n) {
    const byName = list.find(x => x.name === n)
    if (byName) return byName
  }
  return null
}

/** 纠正详情里因 JS 精度丢失的供应商 ID，优先档案主数据，否则保留名称供后端按名解析 */
function normalizeWarehouseSupplierRefs (row, supplierRecords, vueCtx) {
  const fix = (idKey, nameKey) => {
    const name = String(row[nameKey] || '').trim()
    const master = findMasterByIdOrName(supplierRecords, row[idKey], name)
    if (master) {
      vueCtx.$set(row, idKey, entityIdStr(master.id))
      vueCtx.$set(row, nameKey, master.name)
      return
    }
    if (row[idKey] != null && (supplierRecords || []).length) {
      const idOk = supplierRecords.some(x => String(x.id) === String(row[idKey]))
      if (!idOk) vueCtx.$set(row, idKey, undefined)
    }
  }
  fix('supplierId', 'supplier')
  fix('backupSupplierId', 'backupSupplier')
}
// 对齐 Demo 价格体系上架商城短名
const mallOptions = ['华住', '美团', '自营']
const smartReplenishmentPlans = ['安全库存补货', '销量预测补货', '上下限补货', '周期补货']
const latestInboundCostMap = { '佳农食材': 5.00, '华南农副产品': 4.80, '绿源生鲜供应链': 5.20 }
const historicalMinInboundCostMap = { '佳农食材': 4.35, '华南农副产品': 4.20, '绿源生鲜供应链': 4.65 }

function defaultWarehouseRow (warehouse) {
  const master = warehouse && typeof warehouse === 'object' ? warehouse : null
  return {
    warehouseId: master ? master.id : undefined,
    warehouse: master ? master.name : (typeof warehouse === 'string' ? warehouse : ''),
    purchaseAttr: '临采',
    purchaseMethod: '订单采购',
    smartReplenishment: '',
    supplierId: undefined,
    supplier: '',
    backupSupplierId: undefined,
    backupSupplier: '',
    moqType: 'qty',
    moqValue: '',
    supplyCost: 0,
    historicalMinCost: 0
  }
}

function normalizeWarehouseRow (raw) {
  const r = Object.assign(defaultWarehouseRow(null), raw || {})
  if (r.purchaseAttr === '临采') {
    r.purchaseMethod = '订单采购'
    r.smartReplenishment = ''
  }
  if (r.moqType !== 'amount') r.moqType = 'qty'
  return r
}

const PRICE_SYSTEM_MASTERS = [
  { name: '标准客户销售价格体系', type: '客户销售', warehouses: ['郑州一仓', '郑州二仓'], items: ['销售指导价1', '销售指导价2', '销售指导价3'], status: '启用' },
  { name: '华中客户销售价格体系', type: '客户销售', warehouses: ['合肥一仓', '武汉常温仓'], items: ['销售指导价1', '销售指导价2'], status: '启用' },
  { name: '标准代采代配价格体系', type: '代采代配', warehouses: ['郑州一仓', '郑州二仓', '合肥一仓'], items: ['代采指导价1', '代采指导价2'], status: '启用' },
  { name: '冷链代采代配价格体系', type: '代采代配', warehouses: ['南京冷链仓'], items: ['代采指导价1', '代采指导价2', '代采指导价3'], status: '启用' }
]

const FORMULA_TEMPLATES = {
  '水果10%': ['销售指导价1=进价/0.90', '销售指导价2=进价/0.90', '销售指导价3=进价/0.90'],
  '水果17%': ['销售指导价1=进价/0.83', '销售指导价2=进价/0.80', '销售指导价3=进价/0.83'],
  '水果22%': ['销售指导价1=进价/0.78', '销售指导价2=进价/0.75', '销售指导价3=进价/0.78'],
  '水果27%': ['销售指导价1=进价/0.73', '销售指导价2=进价/0.70', '销售指导价3=进价/0.73']
}

function defaultPriceRanges () {
  return [
    { min: 0, max: 3, tpl: '水果10%' },
    { min: 3, max: 5, tpl: '水果17%' },
    { min: 5, max: 8, tpl: '水果22%' },
    { min: 8, max: '', tpl: '水果27%' }
  ]
}

function matchPriceMaster (warehouse, type) {
  const t = type === 'agency' ? '代采代配' : '客户销售'
  return PRICE_SYSTEM_MASTERS.find(x => x.status !== '停用' && x.type === t && (x.warehouses || []).includes(warehouse)) || null
}

function guidesFromMaster (master, oldPrices) {
  const old = Array.isArray(oldPrices) ? oldPrices.filter(p => !p.isSpecial) : []
  if (!master) {
    return [
      { name: '销售指导价1', price: 0, previous: 0, malls: [], isSpecial: false },
      { name: '销售指导价2', price: 0, previous: 0, malls: [], isSpecial: false },
      { name: '销售指导价3', price: 0, previous: 0, malls: [], isSpecial: false },
      { name: '客户特殊价', price: 0, previous: 0, malls: [], isSpecial: true }
    ]
  }
  const guides = (master.items || []).map((it, i) => {
    const name = typeof it === 'string' ? it : (it.name || ('指导价' + (i + 1)))
    const def = typeof it === 'string' ? 0 : Number(it.current || 0)
    const prev = old[i] || {}
    return {
      name,
      price: prev.price != null ? Number(prev.price) : def,
      previous: prev.previous != null ? Number(prev.previous) : 0,
      malls: Array.isArray(prev.malls) ? prev.malls.slice() : [],
      isSpecial: false
    }
  })
  const special = (Array.isArray(oldPrices) && oldPrices.find(p => p.isSpecial || p.name === '客户特殊价')) || {
    name: '客户特殊价', price: 0, previous: 0, malls: [], isSpecial: true
  }
  guides.push({
    name: special.name || '客户特殊价',
    price: Number(special.price || 0),
    previous: Number(special.previous || 0),
    malls: Array.isArray(special.malls) ? special.malls.slice() : [],
    isSpecial: true
  })
  return guides
}

function defaultManualPriceRow (index) {
  const n = (index == null ? 1 : Number(index) + 1) || 1
  return { name: '销售指导价' + n, price: 0, previous: 0, malls: [], isSpecial: false }
}

function defaultWarehousePrice (warehouse) {
  const wh = warehouse || '郑州一仓'
  return {
    warehouse: wh,
    priceSystemName: '',
    bound: true,
    adjusted: '首次建档',
    latestCost: 0,
    // 新增仓库后默认一条价格名称，其余由用户手动添加
    prices: [defaultManualPriceRow(0)],
    tiers: []
  }
}

function defaultSku (unit, unitId) {
  return {
    id: null,
    skuCode: '',
    skuName: '',
    specName: '',
    saleSpec: '',
    barcode: '',
    minQty: 1,
    priceMode: '按销售单位',
    customerPriceMode: 'fixed',
    defaultLocation: '全部货位',
    packType: '散件装箱',
    grossWeight: 0,
    netWeight: 0,
    lossRate: 0,
    volume: '',
    weigh: '否',
    refCost: 0,
    stockMode: '虚拟库存',
    stockValue: 0,
    purchaseDesc: '',
    sorting: '关闭',
    process: '关闭',
    region: '',
    origin: '',
    skuDesc: '',
    specDesc: '',
    feature: '',
    afterSale: '',
    remark: '',
    status: '启用',
    image: '',
    baseUnitName: unit || '斤',
    configBaseUnit: unit || '斤',
    caseUnitName: unit || '斤',
    saleUnitMode: 'base',
    caseRate: 1,
    caseUnitTouched: false,
    inventoryLocked: false,
    units: [{ unitId, unit: unit || '斤', rate: 1, base: true, sale: true, purchase: true, defaultSale: true, defaultPurchase: true }],
    guidePrices: [],
    warehousePrices: []
  }
}

const emptyForm = () => ({
  id: null,
  buildMethod: 'spu_create',
  status: '启用',
  image: '',
  spuCode: '',
  spuName: '',
  alias: '',
  productType: '标准产品',
  customCode: '',
  categoryId: undefined,
  baseUnitId: undefined,
  baseUnit: '斤',
  brand: undefined,
  tempZone: '常温',
  purchaseAttr: '临采',
  purchaseMethod: '订单采购',
  performanceMethod: '计重',
  lossRate: 0,
  smartReplenishment: '',
  origin: '',
  shelfLifeDays: undefined,
  video: '',
  description: '',
  tags: [],
  feature: '',
  afterSale: '',
  taxRate: 0,
  invoiceName: '',
  taxCode: '',
  taxCategory: '',
  qualityReport: '',
  reportName: '',
  reportValidPeriod: '',
  warehouses: [],
  guidePrices: [],
  moqs: [],
  skus: [defaultSku('斤')]
})

function simpleEditableTable (headers, rows, buildCells) {
  return h => h('div', { class: 'sub-table-wrap' }, [h('table', { class: 'sub-table' }, [h('thead', [h('tr', headers.map(t => h('th', t)))]), h('tbody', rows.map((r, i) => h('tr', { key: i }, buildCells(h, r, i))))])])
}

const UnitTable = {
  props: { sku: Object, baseUnit: String, unitOptions: Array },
  methods: {
    changeUnit (row, value) {
      const master = (this.unitOptions || []).find(x => String(x.id) === String(value))
      if (!master) return
      row.unitId = master.id
      row.unit = master.name
    },
    selectableUnits (row) {
      const used = new Set(((this.sku && this.sku.units) || [])
        .filter(x => x !== row && x.unitId != null)
        .map(x => String(x.unitId)))
      return (this.unitOptions || []).filter(x => !used.has(String(x.id)))
    },
    toggleCapability (row, key, checked) {
      row[key] = checked
      if (!checked && key === 'sale') row.defaultSale = false
      if (!checked && key === 'purchase') row.defaultPurchase = false
    }
  },
  render (h) {
    const rows = (this.sku && this.sku.units) || []
    const base = this.baseUnit || '基本单位'
    return h('div', { class: 'multi-unit-table-wrap' }, [
      h('table', { class: 'multi-unit-table', style: { minWidth: '760px' } }, [
        h('thead', [h('tr', [
          h('th', { style: { minWidth: '120px' } }, '单位名称'),
          h('th', { style: { minWidth: '90px' } }, '换算比例'),
          h('th', { style: { minWidth: '135px' } }, '换算关系'),
          h('th', { class: 'unit-check', style: { minWidth: '68px' } }, '可销售'),
          h('th', { class: 'unit-check', style: { minWidth: '68px' } }, '可采购'),
          h('th', { class: 'unit-check', style: { minWidth: '82px' } }, '默认销售'),
          h('th', { class: 'unit-check', style: { minWidth: '82px' } }, '默认采购'),
          h('th', { style: { minWidth: '76px' } }, '操作')
        ])]),
        h('tbody', rows.length ? rows.map((u, i) => h('tr', { key: i }, [
          h('td', u.base
            ? [h('span', u.unit || base), h('span', { class: 'unit-base-tag' }, '基本单位')]
            : [h('a-select', {
              props: { value: u.unitId != null ? String(u.unitId) : undefined, size: 'small', placeholder: '请选择单位' },
              style: { width: '100%' },
              on: { change: v => this.changeUnit(u, v) }
            }, this.selectableUnits(u).map(o => h('a-select-option', { key: String(o.id), props: { value: String(o.id) } }, o.name)))]
          ),
          h('td', u.base
            ? '1 (固定)'
            : [h('a-input-number', { props: { value: u.rate, min: 0.000001, precision: 6, size: 'small' }, style: { width: '100%' }, on: { change: v => { u.rate = v } } })]
          ),
          h('td', { class: 'unit-desc' }, `1${u.unit || '单位'} = ${u.rate || 1}${base}`),
          h('td', { class: 'unit-check' }, [h('a-checkbox', { props: { checked: !!u.sale }, on: { change: e => this.toggleCapability(u, 'sale', e.target.checked) } })]),
          h('td', { class: 'unit-check' }, [h('a-checkbox', { props: { checked: !!u.purchase }, on: { change: e => this.toggleCapability(u, 'purchase', e.target.checked) } })]),
          h('td', { class: 'unit-check' }, [h('a-radio', { props: { checked: !!u.defaultSale }, on: { change: () => this.$emit('set-default', 'sale', i) } })]),
          h('td', { class: 'unit-check' }, [h('a-radio', { props: { checked: !!u.defaultPurchase }, on: { change: () => this.$emit('set-default', 'purchase', i) } })]),
          h('td', { class: 'unit-actions' }, u.base
            ? [h('span', { class: 'unit-locked' }, '不可删除')]
            : [h('a', { class: 'danger-link', on: { click: () => this.$emit('remove', i) } }, '删除')]
          )
        ])) : [h('tr', [h('td', { attrs: { colspan: 8 }, class: 'sub-empty' }, '暂无计量单位')])])
      ])
    ])
  }
}

function boundWarehouseNames (profileJson) {
  let profile = {}
  if (profileJson && typeof profileJson === 'object') profile = profileJson
  else if (profileJson) {
    try { profile = JSON.parse(profileJson) } catch (e) { profile = {} }
  }
  const bindings = Array.isArray(profile.warehouseBindings) ? profile.warehouseBindings : []
  return bindings.map(item => String((item && item.warehouseName) || '').trim()).filter(Boolean)
}

function supplierBindsWarehouse (supplier, warehouseName) {
  const name = String(warehouseName || '').trim()
  if (!supplier || !name) return false
  return (supplier.warehouseNames || []).indexOf(name) >= 0
}

function supplierOptionLabel (supplier) {
  if (!supplier) return ''
  return String(supplier.name || '').trim()
}

/** 下拉仅展示名称；title 保留编号供搜索与悬停查看 */
function supplierOptionSearchText (supplier) {
  if (!supplier) return ''
  const code = String(supplier.code || '').trim()
  const name = supplierOptionLabel(supplier)
  return code ? `${code} ${name}` : name
}

const WarehouseTable = {
  components: { ErpSearchSelect },
  props: { rows: Array, warehouseOptions: Array, supplierOptions: Array },
  methods: {
    warehouseNameOf (row) {
      const named = String((row && row.warehouse) || '').trim()
      if (named) return named
      const master = (this.warehouseOptions || []).find(x => String(x.id) === String(row && row.warehouseId))
      return master ? master.name : ''
    },
    suppliersFor (row) {
      const warehouseName = this.warehouseNameOf(row)
      if (!warehouseName) return []
      return (this.supplierOptions || []).filter(item => supplierBindsWarehouse(item, warehouseName))
    },
    supplierPlaceholder (row, bound) {
      if (!this.warehouseNameOf(row)) return '请先选择仓库'
      return bound.length ? '请选择供应商' : '该仓库暂无绑定供应商'
    },
    supplierOptionNodes (h, options, currentId) {
      const nodes = options.map(o => h('a-select-option', {
        key: String(o.id),
        props: { value: String(o.id), title: supplierOptionSearchText(o) }
      }, supplierOptionLabel(o)))
      if (currentId == null || options.some(o => String(o.id) === String(currentId))) return nodes
      const current = (this.supplierOptions || []).find(o => String(o.id) === String(currentId))
      if (!current) return nodes
      const orphanLabel = supplierOptionLabel(current) + '（未绑定该仓库）'
      nodes.unshift(h('a-select-option', {
        key: 'unbound-' + current.id,
        props: { value: String(current.id), disabled: true, title: orphanLabel }
      }, orphanLabel))
      return nodes
    },
    patch (i, key, value) {
      const row = (this.rows || [])[i]
      if (!row) return
      if (key === 'supplierId' || key === 'backupSupplierId' || key === 'warehouseId') {
        value = entityIdStr(value)
      }
      this.$set(row, key, value)
      if (key === 'purchaseAttr') {
        if (value === '临采') {
          this.$set(row, 'purchaseMethod', '订单采购')
          this.$set(row, 'smartReplenishment', '')
        }
      }
      if (key === 'supplierId') {
        const master = findMasterByIdOrName(this.supplierOptions, value, row.supplier)
        this.$set(row, 'supplier', master ? master.name : '')
        if (String(row.backupSupplierId) === String(value)) {
          this.$set(row, 'backupSupplierId', undefined)
          this.$set(row, 'backupSupplier', '')
        }
        this.$set(row, 'supplyCost', latestInboundCostMap[row.supplier] || 0)
        this.$set(row, 'historicalMinCost', historicalMinInboundCostMap[row.supplier] || 0)
      }
      if (key === 'backupSupplierId') {
        const master = findMasterByIdOrName(this.supplierOptions, value, row.backupSupplier)
        this.$set(row, 'backupSupplier', master ? master.name : '')
      }
      if (key === 'warehouseId') {
        const master = (this.warehouseOptions || []).find(x => String(x.id) === String(value))
        this.$set(row, 'warehouse', master ? master.name : '')
        const bound = this.suppliersFor(row)
        if (row.supplierId != null && !bound.some(x => String(x.id) === String(row.supplierId))) {
          this.$set(row, 'supplierId', undefined)
          this.$set(row, 'supplier', '')
        }
        if (row.backupSupplierId != null && !bound.some(x => String(x.id) === String(row.backupSupplierId))) {
          this.$set(row, 'backupSupplierId', undefined)
          this.$set(row, 'backupSupplier', '')
        }
      }
      this.$forceUpdate()
    }
  },
  render (h) {
    const rows = this.rows || []
    if (!rows.length) {
      return h('div', { class: 'base-info-empty' }, [
        h('span', { class: 'base-info-empty-title' }, '尚未配置仓库'),
        h('span', { class: 'base-info-empty-desc' }, '点击“添加仓库”从仓库档案选择；如无可选项，请先在仓库档案中启用仓库。')
      ])
    }
    const showSmart = false
    const headers = ['仓库', '采购属性', '采购方式']
      .concat(showSmart ? ['智能补货方案'] : [])
      .concat(['供应商信息', '备选供应商', 'MOQ类型', 'MOQ要求', '供应成本', '历史最低价', '操作'])
    const colMin = {
      '仓库': '140px',
      '采购属性': '120px',
      '采购方式': '130px',
      '智能补货方案': '160px',
      '供应商信息': '150px',
      '备选供应商': '150px',
      'MOQ类型': '140px',
      'MOQ要求': '160px',
      '供应成本': '130px',
      '历史最低价': '130px',
      '操作': '90px'
    }
    return h('div', { class: 'sub-table-wrap warehouse-table-wrap' }, [
      h('table', { class: 'sub-table warehouse-info-table', style: { minWidth: '1180px' } }, [
        h('thead', [h('tr', headers.map(t => h('th', { style: { minWidth: colMin[t] || '120px' } }, t)))]),
        h('tbody', rows.map((r, i) => {
          const moqType = r.moqType === 'amount' ? 'amount' : 'qty'
          const cells = [
            h('td', [h('a-select', { props: { value: r.warehouseId != null ? String(r.warehouseId) : undefined, size: 'small', placeholder: '请选择仓库' }, style: { width: '100%' }, on: { change: v => this.patch(i, 'warehouseId', v) } }, (this.warehouseOptions || []).map(o => h('a-select-option', { key: String(o.id), props: { value: String(o.id), disabled: rows.some((row, rowIndex) => rowIndex !== i && String(row.warehouseId) === String(o.id)) } }, o.name)))]),
            h('td', [h('a-select', { props: { value: r.purchaseAttr || '临采', size: 'small' }, style: { width: '100%' }, on: { change: v => this.patch(i, 'purchaseAttr', v) } }, ['临采', '备货'].map(o => h('a-select-option', { key: o, props: { value: o } }, o)))]),
            h('td', [h('a-select', { props: { value: r.purchaseMethod || '订单采购', size: 'small', disabled: (r.purchaseAttr || '临采') === '临采' }, style: { width: '100%' }, on: { change: v => this.patch(i, 'purchaseMethod', v) } }, ['订单采购', '库存采购'].map(o => h('a-select-option', { key: o, props: { value: o } }, o)))])
          ]
          if (showSmart) {
            cells.push(h('td', r.purchaseAttr === '备货'
              ? [h('a-select', { props: { value: r.smartReplenishment || undefined, size: 'small', placeholder: '请选择智能补货方案', allowClear: true }, style: { width: '100%' }, on: { change: v => this.patch(i, 'smartReplenishment', v || '') } }, smartReplenishmentPlans.map(o => h('a-select-option', { key: o, props: { value: o } }, o)))]
              : '—'))
          }
          const boundSuppliers = this.suppliersFor(r)
          const backupSuppliers = boundSuppliers.filter(o => String(o.id) !== String(r.supplierId))
          cells.push(
            h('td', [h('erp-search-select', { props: { value: r.supplierId != null ? String(r.supplierId) : undefined, size: 'small', placeholder: this.supplierPlaceholder(r, boundSuppliers), allowClear: true, disabled: !this.warehouseNameOf(r) }, style: { width: '100%' }, on: { change: v => this.patch(i, 'supplierId', v || undefined) } }, this.supplierOptionNodes(h, boundSuppliers, r.supplierId))]),
            h('td', [h('erp-search-select', { props: { value: r.backupSupplierId != null ? String(r.backupSupplierId) : undefined, size: 'small', placeholder: this.supplierPlaceholder(r, backupSuppliers), allowClear: true, disabled: !this.warehouseNameOf(r) }, style: { width: '100%' }, on: { change: v => this.patch(i, 'backupSupplierId', v || undefined) } }, this.supplierOptionNodes(h, backupSuppliers, r.backupSupplierId))]),
            h('td', [h('a-select', { props: { value: moqType, size: 'small' }, style: { width: '100%' }, on: { change: v => this.patch(i, 'moqType', v) } }, [
              h('a-select-option', { key: 'qty', props: { value: 'qty' } }, '按订单数量'),
              h('a-select-option', { key: 'amount', props: { value: 'amount' } }, '按订单金额')
            ])]),
            h('td', [
              h('div', { style: { display: 'flex', alignItems: 'center', gap: '4px' } }, [
                moqType === 'amount' ? h('span', '¥') : null,
                h('a-input-number', { props: { value: r.moqValue === '' || r.moqValue === undefined || r.moqValue === null ? undefined : Number(r.moqValue), size: 'small', min: 0 }, style: { flex: 1 }, on: { change: v => this.patch(i, 'moqValue', v === null || v === undefined ? '' : v) } }),
                moqType !== 'amount' ? h('span', { style: { whiteSpace: 'nowrap', color: '#8792a5', fontSize: '12px' } }, '采购单位') : null
              ])
            ]),
            h('td', [
              h('div', { style: { display: 'flex', alignItems: 'center', gap: '4px' } }, [
                h('span', '¥'),
                h('a-input-number', { props: { value: Number(r.supplyCost || 0), size: 'small', disabled: true, precision: 2 }, style: { flex: 1 } }),
                h('span', { style: { whiteSpace: 'nowrap', color: '#8792a5', fontSize: '12px' } }, '最新入库价')
              ])
            ]),
            h('td', [
              h('div', { style: { display: 'flex', alignItems: 'center', gap: '4px' } }, [
                h('span', '¥'),
                h('a-input-number', { props: { value: Number(r.historicalMinCost || 0), size: 'small', disabled: true, precision: 2 }, style: { flex: 1 } }),
                h('span', { style: { whiteSpace: 'nowrap', color: '#8792a5', fontSize: '12px' } }, '历史最低')
              ])
            ]),
            h('td', [h('a', { class: 'danger-link', on: { click: () => this.$emit('remove', i) } }, '删除')])
          )
          return h('tr', { key: i }, cells)
        }))
      ])
    ])
  }
}

const GuidePriceTable = {
  props: { rows: Array },
  render (h) {
    return simpleEditableTable(['仓库', '指导价名称', '销售单位', '销售指导价', '上架商城', '状态', '操作'], this.rows || [], (h, p, i) => [
      h('td', [h('a-select', { props: { value: p.warehouse, size: 'small' }, style: { width: '100%' }, on: { change: v => { p.warehouse = v } } }, warehouseOptions.map(o => h('a-select-option', { key: o, props: { value: o } }, o)))]),
      h('td', [h('a-input', { props: { value: p.name, size: 'small' }, on: { input: v => { p.name = v } } })]),
      h('td', [h('a-input', { props: { value: p.unit, size: 'small' }, on: { input: v => { p.unit = v } } })]),
      h('td', [h('a-input-number', { props: { value: p.price, size: 'small' }, style: { width: '100%' }, on: { change: v => { p.price = Number(v || 0) } } })]),
      h('td', [h('a-input', { props: { value: (p.malls || []).join('、'), size: 'small' }, on: { input: v => { p.malls = v ? v.split(/[、,，]/).filter(Boolean) : [] } } })]),
      h('td', [h('a-select', { props: { value: p.status, size: 'small' }, style: { width: '100%' }, on: { change: v => { p.status = v } } }, ['启用', '停用'].map(o => h('a-select-option', { key: o, props: { value: o } }, o)))]),
      h('td', [h('a', { on: { click: () => this.$emit('remove', i) } }, '删除')])
    ])(h)
  }
}

const MoqTable = {
  props: { rows: Array },
  render (h) {
    const rows = this.rows || []
    const headers = [
      { title: 'MOQ类型', minWidth: '140px' },
      { title: '最低采购要求', minWidth: '160px' },
      { title: '计量单位', minWidth: '120px' },
      { title: '备注', minWidth: '200px' },
      { title: '操作', minWidth: '90px' }
    ]
    return h('div', { class: 'sub-table-wrap moq-table-wrap' }, [
      h('table', { class: 'sub-table moq-table', style: { minWidth: '760px' } }, [
        h('thead', [h('tr', headers.map(t => h('th', { style: { minWidth: t.minWidth } }, t.title)))]),
        h('tbody', rows.length
          ? rows.map((m, i) => {
            const isQty = m.type === 'qty' || m.type === '按数量' || m.type === '最小起订量'
            return h('tr', { key: i }, [
              h('td', isQty ? '按数量' : '按金额'),
              h('td', isQty ? String(m.value != null ? m.value : '') : ('¥ ' + Number(m.value || 0).toFixed(2))),
              h('td', isQty ? (m.unit || '—') : '—'),
              h('td', m.remark || '—'),
              h('td', [h('a', { class: 'danger-link', on: { click: () => this.$emit('remove', i) } }, '删除')])
            ])
          })
          : [h('tr', [h('td', { attrs: { colspan: 5 }, class: 'sub-empty' }, '暂未设置MOQ限制')])])
      ])
    ])
  }
}

const ProductTypeNode = {
  name: 'ProductTypeNode',
  props: {
    node: { type: Object, required: true },
    depth: { type: Number, default: 0 },
    selectedKey: { type: String, default: '' },
    expandedKeys: { type: Array, default: () => [] },
    countOf: { type: Function, required: true }
  },
  computed: {
    nodeKey () { return String(this.node.id) },
    expanded () { return (this.expandedKeys || []).map(String).indexOf(this.nodeKey) !== -1 },
    selected () { return String(this.selectedKey) === this.nodeKey },
    children () { return this.node.children || [] },
    label () {
      const name = this.node.name || this.node.categoryName || ''
      const disabled = this.node.status === 'disabled' || this.node.status === '停用'
      return disabled ? `${name}（停用）` : name
    },
    count () { return this.countOf(this.node) }
  },
  template: `
    <div class="product-tree-node">
      <div class="product-tree-row" :class="{ active: selected }" :data-depth="depth">
        <button class="product-tree-toggle" :class="{ empty: !children.length }" type="button" :aria-expanded="expanded ? 'true' : 'false'" :aria-label="(expanded ? '收起' : '展开') + label" @click.stop="children.length && $emit('toggle', node)"><span class="product-tree-arrow">▶</span></button>
        <button class="product-tree-select" type="button" :aria-pressed="selected ? 'true' : 'false'" :title="label" @click="$emit('select', node)"><span class="product-tree-icon" aria-hidden="true"></span><span class="product-tree-name">{{ label }}</span><span class="product-tree-count">{{ count }}</span></button>
      </div>
      <div v-if="children.length" class="product-tree-children" :class="{ collapsed: !expanded }">
        <product-type-node v-for="child in children" :key="child.id" :node="child" :depth="depth + 1" :selected-key="selectedKey" :expanded-keys="expandedKeys" :count-of="countOf" @select="$emit('select', $event)" @toggle="$emit('toggle', $event)" />
      </div>
    </div>
  `
}

export default {
  name: 'ErpProduct',
  components: { UnitTable, WarehouseTable, GuidePriceTable, MoqTable, GuidePriceEditor, ProductAttachmentUpload, ProductTypeNode },
  data () {
    return {
      query: { keyword: '', subject: undefined, buildMethod: undefined, brand: undefined, baseUnit: undefined, status: undefined, mall: undefined, hzSyncStatus: undefined, categoryId: undefined },
      subjectOptions: ['达家上海', '达家杭州', '达家集团'],
      mallFilterOptions: ['华住商城', '美团', '自营', '未上架'],
      selectedRowKeys: [],
      list: [],
      listLoading: false,
      syncLoading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '50']
      },
      categoryTreeRaw: [],
      categoryTree: [{ id: 'all', name: '全部商品', children: [] }],
      activeCategory: 'all',
      expandedCategories: ['all'],
      selectedCategoryKeys: ['all'],
      formVisible: false,
      formReadonly: false,
      customCodeLocked: false,
      expandedRowKeys: [],
      deleteVisible: false,
      deleteLoading: false,
      deleteTarget: null,
      moreVisible: false,
      moreStep: 'choose',
      moreAction: '批量导入',
      importFileList: [],
      importing: false,
      importResult: null,
      importDuplicateMode: 'update',
      batchField: '品牌',
      batchValue: undefined,
      batchSaving: false,
      exportScope: 'filter',
      exporting: false,
      importErrorColumns: [
        { title: '行号', dataIndex: 'rowNumber', width: 70 },
        { title: '商品名称', dataIndex: 'productName', width: 160 },
        { title: '规格名称', dataIndex: 'specName', width: 120 },
        { title: '原因', dataIndex: 'message' }
      ],
      categoryPickerVisible: false,
      categoryPickerSelected: [],
      detailVisible: false,
      productImagePreviewVisible: false,
      productImagePreviewUrl: '',
      submitLoading: false,
      _syncingSpuBaseUnit: false,
      formMode: 'spu',
      formTab: 'base',
      activeSkuIndex: 0,
      skuInnerTab: 'spec',
      skuKeyword: '',
      form: emptyForm(),
      detail: null,
      warehouseOptions,
      warehouseRecords: [],
      supplierRecords: [],
      unitOptions: [],
      unitRecords: [],
      tempOptions: [],
      brandOptions: [],
      tagOptions: [],
      packOptions: [],
      mallOptions,
      FORMULA_TEMPLATES,
      // 价格体系弹窗与规则（对齐 Demo）
      priceWarehouseModalVisible: false,
      priceWarehouseDraft: undefined,
      priceRuleModalVisible: false,
      priceRuleReadonly: false,
      priceRuleModalTitle: '客户销售价格体系 · 采购价调价规则',
      priceRuleViewWarehouse: '',
      priceRuleAutoStarted: false,
      priceRuleDraft: {
        ruleWarehouses: [],
        ranges: defaultPriceRanges()
      },
      specialPriceRuleModalVisible: false,
      moqModalVisible: false,
      moqDraft: { type: 'qty', value: undefined, unit: '斤', remark: '' },
      specialRuleDraft: {
        scope: 'all',
        customers: [],
        guide: '销售指导价1',
        basis: '单指导价',
        riseBase: 1,
        risePrice: 1,
        fallBase: 1,
        fallPrice: 0.5
      },
      categoryModalVisible: false,
      categoryModalMode: 'create',
      categorySaving: false,
      categoryForm: {
        id: undefined,
        parentId: 0,
        parentName: '全部商品',
        categoryName: '',
        categoryCode: '',
        sortNo: 10,
        status: '启用',
        originStatus: '启用',
        remark: '',
        productCount: 0
      },
      rules: {
        spuName: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        categoryId: [{ required: true, message: '请选择所属分类', trigger: 'change' }],
        baseUnit: [{ required: true, message: '请选择基本单位', trigger: 'change' }],
        customCode: [{ required: true, message: '请输入自定义编码', trigger: 'blur' }]
      },
      columns: [
        { title: '图片', dataIndex: 'image', scopedSlots: { customRender: 'image' }, width: 72, align: 'center' },
        { title: '商品 / SPU', dataIndex: 'spuName', scopedSlots: { customRender: 'spu' }, width: 220 },
        { title: '建档方式', dataIndex: 'buildMethod', scopedSlots: { customRender: 'buildMethod' }, width: 130 },
        { title: '商品分类', dataIndex: 'category', scopedSlots: { customRender: 'category' }, width: 220 },
        { title: 'SKU数', dataIndex: 'skuCount', width: 72, align: 'center' },
        { title: '基本单位', dataIndex: 'baseUnit', width: 88, align: 'center' },
        { title: '仓库数', dataIndex: 'warehouseCount', width: 80, align: 'center' },
        { title: '上架商城', dataIndex: 'malls', scopedSlots: { customRender: 'malls' }, width: 160 },
        { title: '华住同步状态', dataIndex: 'hzSyncStatus', scopedSlots: { customRender: 'hzSyncStatus' }, width: 120, align: 'center' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, width: 88, align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, width: 160 },
        { title: '操作', dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, width: 236, className: 'product-list-op-col' }
      ],
      skuColumns: [
        { title: 'SKU编码', dataIndex: 'skuCode', width: 180 },
        { title: 'SKU名称', dataIndex: 'skuName', width: 180 },
        { title: '规格名称', dataIndex: 'specName', width: 140 },
        { title: '销售规格', dataIndex: 'saleSpec', width: 140 },
        { title: '基本单位', dataIndex: 'baseUnitName', width: 100 },
        { title: '条形码', dataIndex: 'barcode', width: 150 },
        { title: '最小下单数', dataIndex: 'minQty', width: 110 },
        { title: '供货成本', dataIndex: 'refCost', width: 110 },
        { title: '状态', dataIndex: 'status', width: 90 }
      ],
      warehouseDetailColumns: [
        { title: '仓库', dataIndex: 'warehouse', width: 150 },
        { title: '采购属性', dataIndex: 'purchaseAttr', width: 100 },
        { title: '采购方式', dataIndex: 'purchaseMethod', width: 120 },
        { title: '智能补货规则', dataIndex: 'smartReplenishment', width: 150 },
        { title: '主供应商', dataIndex: 'supplier', width: 160 },
        { title: '备选供应商', dataIndex: 'backupSupplier', width: 160 },
        { title: 'MOQ类型', dataIndex: 'moqType', width: 100 },
        { title: 'MOQ要求', dataIndex: 'moqValue', width: 100 },
        { title: '供货成本', dataIndex: 'supplyCost', width: 110 },
        { title: '历史最低成本', dataIndex: 'historicalMinCost', width: 130 }
      ],
      moqDetailColumns: [
        { title: 'MOQ类型', dataIndex: 'type', width: 130, customRender: value => value === 'amount' ? '按金额' : '按数量' },
        { title: '最低采购要求', dataIndex: 'value', width: 160 },
        { title: '计量单位', dataIndex: 'unit', width: 120 },
        { title: '备注', dataIndex: 'remark' }
      ]
    }
  },
  computed: {
    moreTitle () {
      if (this.moreStep === 'import') return '批量导入'
      if (this.moreStep === 'batch') return '批量修改'
      if (this.moreStep === 'export') return '导出商品档案'
      return '商品档案更多功能'
    },
    moreTarget () {
      if (this.moreStep === 'batch') {
        return this.selectedRowKeys.length ? `已选择 ${this.selectedRowKeys.length} 个商品` : '尚未选择商品'
      }
      if (this.moreStep === 'export') {
        if (this.exportScope === 'selected') {
          return this.selectedRowKeys.length ? `已选择 ${this.selectedRowKeys.length} 个商品` : '尚未选择商品'
        }
        if (this.exportScope === 'all') return '全部商品'
        return `当前 ${this.pagination.total} 条`
      }
      return '当前筛选结果'
    },
    importResultMessage () {
      const result = this.importResult || {}
      const success = result.successCount || 0
      const successSku = result.successSkuCount || 0
      const updated = result.updatedCount || 0
      const updatedSku = result.updatedSkuCount || 0
      const failure = result.failureCount || 0
      const skipped = result.skippedCount || 0
      return `共 ${result.totalCount || 0} 行，新建 ${success} 个 SPU / ${successSku} 个 SKU，更新 ${updated} 个 SPU / ${updatedSku} 个 SKU，跳过 ${skipped} 个 SPU，失败 ${failure} 个`
    },
    filterBrandOptions () {
      const names = (this.brandOptions || []).filter(Boolean)
      return names.includes('无品牌') ? names : ['无品牌'].concat(names)
    },
    filterUnitOptions () {
      const names = (this.unitOptions || []).filter(Boolean)
      return names.length ? names : ['斤', '板', '包', '箱', '盒', '桶']
    },
    showLossRate () {
      const type = this.form && this.form.productType
      return type === '非标准产品' || type === 'non_standard'
    },
    categoryPickerLabel () {
      const path = this.categoryNodePath(this.form && this.form.categoryId)
      return path.length ? path.map(node => node.name || node.categoryName).join('/') : ''
    },
    categoryPickerColumns () {
      const currentId = this.form && this.form.categoryId
      const selected = this.categoryPickerSelected || []
      const roots = (this.categoryTreeRaw || []).filter(node => this.isCategorySelectable(node, currentId))
      const find = (list, id) => (list || []).find(node => String(node.id) === String(id))
      const level1 = find(roots, selected[0])
      const level2List = level1 ? (level1.children || []).filter(node => this.isCategorySelectable(node, currentId)) : []
      const level2 = find(level2List, selected[1])
      const level3List = level2 ? (level2.children || []).filter(node => this.isCategorySelectable(node, currentId)) : []
      return [roots, level2List, level3List]
    },
    categoryPickerPathText () {
      const names = []
      this.categoryPickerColumns.forEach((column, index) => {
        const node = column.find(item => String(item.id) === String((this.categoryPickerSelected || [])[index]))
        if (node) names.push(node.name || node.categoryName)
      })
      return names.join(' / ')
    },
    formTitle () {
      return this.formMode === 'sku'
        ? (this.form.id ? '编辑SKU商品档案' : '创建SKU')
        : (this.form.id ? '编辑商品档案' : '新建商品档案')
    },
    formPageTitle () {
      if (this.formReadonly) return '商品档案详情'
      return this.formTitle
    },
    formPageBadge () {
      if (this.formReadonly) return this.form.buildMethod === 'sku_direct' ? 'SKU直建 · 自动SPU' : '查看'
      if (this.formMode === 'sku') return this.form.id ? '编辑' : 'SKU直建'
      return this.form.id ? '编辑' : '新建'
    },
    activeSku () {
      if (!this.form.skus || !this.form.skus.length) {
        this.$set(this.form, 'skus', [defaultSku(this.form.baseUnit)])
        this.activeSkuIndex = 0
      }

      if (this.activeSkuIndex < 0) {
        this.activeSkuIndex = 0
      }

      if (this.activeSkuIndex >= this.form.skus.length) {
        this.activeSkuIndex = 0
      }

      return this.form.skus[this.activeSkuIndex]
    },
    filteredSkus () {
      const list = this.form.skus || []
      const keyword = (this.skuKeyword || '').trim().toLowerCase()

      if (!keyword) return list

      return list.filter(sku => {
        return String(sku.skuName || '').toLowerCase().includes(keyword) ||
          String(sku.skuCode || '').toLowerCase().includes(keyword) ||
          String(sku.specName || '').toLowerCase().includes(keyword) ||
          String(sku.barcode || '').toLowerCase().includes(keyword)
      })
    },
    activeSkuWarehousePrices () {
      const sku = this.activeSku
      if (!sku) return []
      this.ensureSkuWarehousePrices(sku)
      return sku.warehousePrices || []
    },
    skuSaleUnitLabel () {
      const sku = this.activeSku
      if (!sku) return '销售单位'
      const u = (sku.units || []).find(x => x.defaultSale) || (sku.units || []).find(x => x.sale) || (sku.units || [])[0]
      return (u && u.unit) || this.form.baseUnit || '销售单位'
    },
    moqUnitOptions () {
      const units = []
      const push = u => { if (u && !units.includes(u)) units.push(u) }
      push(this.form.baseUnit)
      const sku = this.activeSku
      ;(sku && sku.units || []).forEach(x => push(x.unit))
      this.unitOptions.forEach(push)
      return units
    },
    canAddWarehouse () {
      const used = new Set((this.form.warehouses || []).map(x => String(x.warehouseId)))
      return (this.warehouseRecords || []).some(x => !used.has(String(x.id)))
    },
    warehouseAddHint () {
      if (!this.warehouseRecords.length) return '请先在仓库档案中维护并启用仓库'
      return this.canAddWarehouse ? '从仓库档案添加仓库' : '所有启用仓库均已添加'
    },
    canAddSkuUnit () {
      if (!this.activeSku) return false
      const used = new Set((this.activeSku.units || []).map(x => String(x.unitId)))
      return (this.unitRecords || []).some(x => !used.has(String(x.id)))
    },
    unitAddHint () {
      if (!this.unitRecords.length) return '请先在基础设置中维护并启用商品单位'
      return this.canAddSkuUnit ? '从基础设置添加计量单位' : '所有启用单位均已添加'
    },
    availablePriceWarehouses () {
      const used = new Set((this.activeSkuWarehousePrices || []).map(x => x.warehouse))
      return warehouseOptions.filter(x => !used.has(x))
    },
    formulaTemplateKeys () {
      return Object.keys(FORMULA_TEMPLATES)
    },
    detailPairs () {
      const d = this.detail || {}
      return [
        ['SPU编码', d.spuCode],
        ['建档方式', d.buildMethod === 'sku_direct' ? 'SKU直建' : 'SPU建档'],
        ['当前状态', this.statusLabel(d.status)],
        ['商品分类', d.category],
        ['商品类型', d.productType],
        ['商品别名', d.alias],
        ['自定义编码', d.customCode],
        ['基本单位', d.baseUnit],
        ['品牌', d.brand],
        ['温区', d.tempZone],
        ['采购属性', d.purchaseAttr],
        ['采购方式', d.purchaseMethod],
        ['绩效方式', d.performanceMethod],
        ['耗损比例', d.lossRate != null ? `${d.lossRate}%` : null],
        ['智能补货规则', d.smartReplenishment],
        ['产地', d.origin],
        ['保质期', d.shelfLifeDays != null ? `${d.shelfLifeDays} 天` : null],
        ['创建时间', this.formatCreateTime(d.createTime)]
      ].map(([label, value]) => ({ label, value }))
    },
    detailQualityPairs () {
      const d = this.detail || {}
      return [
        { label: '商品描述', value: d.description, span: 3 },
        { label: '商品标签', value: Array.isArray(d.tags) ? d.tags.join('、') : d.tags, span: 3 },
        { label: '商品特征', value: d.feature, span: 3 },
        { label: '售后标准', value: d.afterSale, span: 3 },
        { label: '商品税率', value: d.taxRate != null ? `${d.taxRate}%` : null },
        { label: '开票名称', value: d.invoiceName },
        { label: '税收编码', value: d.taxCode },
        { label: '大类名称', value: d.taxCategory }
      ]
    }
  },
  watch: {
    'form.baseUnit' (val, oldVal) {
      if (!this.formVisible || this._syncingSpuBaseUnit) return
      if (!val || val === oldVal) return
      this.syncBaseUnit(val)
    }
  },
  created () {
    this.loadBaseOptions()
    this.loadWarehouseOptions()
    this.loadSupplierOptions()
    this.loadCategoryTree()
    this.getList()
  },
  activated () {
    this.loadBaseOptions()
    this.loadWarehouseOptions()
    this.loadSupplierOptions()
  },
  methods: {
    loadBaseOptions () {
      const fields = [
        ['erp_product_brand', 'brandOptions'],
        ['erp_product_tag', 'tagOptions'],
        ['erp_product_unit', 'unitOptions'],
        ['erp_product_temperature', 'tempOptions'],
        ['erp_product_package_type', 'packOptions']
      ]
      Promise.all(fields.map(([type]) => getDicts(type))).then(responses => {
        responses.forEach((response, index) => {
          const rows = Array.isArray(response.data) ? response.data : []
          const enabledRows = rows.filter(row => Number(row.status) === 1)
          this[fields[index][1]] = enabledRows.map(row => row.dictLabel).filter(Boolean)
          if (fields[index][0] === 'erp_product_unit') {
            this.unitRecords = enabledRows.map(row => ({
              id: row.id,
              name: row.dictLabel,
              value: row.dictValue
            })).filter(row => row.id != null && row.name)
            this.attachUnitIds()
          }
        })
      }).catch(() => {
        this.$message.error('商品基础选项加载失败，请刷新后重试')
      })
    },
    loadWarehouseOptions () {
      return listWarehouse(true).then(response => {
        const rows = Array.isArray(response.data) ? response.data : []
        this.warehouseRecords = rows.map(row => ({
          id: entityIdStr(row.id),
          code: row.warehouseCode,
          name: row.warehouseName
        })).filter(row => row.id != null && row.name)
        this.attachWarehouseIds()
      }).catch(() => {
        this.warehouseRecords = []
        this.$message.error('仓库档案加载失败，请刷新后重试')
      })
    },
    loadSupplierOptions () {
      return listSupplier(true).then(response => {
        const rows = Array.isArray(response.data) ? response.data : []
        this.supplierRecords = rows.map(row => ({
          id: entityIdStr(row.id),
          code: row.supplierCode,
          name: row.supplierName,
          operatingSubjectId: row.operatingSubjectId,
          warehouseNames: boundWarehouseNames(row.profileJson)
        })).filter(row => row.id != null && row.name)
        this.attachSupplierIds()
      }).catch(() => {
        this.supplierRecords = []
        this.$message.error('供应商档案加载失败，请刷新后重试')
      })
    },
    attachSupplierIds () {
      ;(this.form.warehouses || []).forEach(row => {
        normalizeWarehouseSupplierRefs(row, this.supplierRecords, this)
      })
    },
    attachUnitIds () {
      const find = name => (this.unitRecords || []).find(x => x.name === name || x.value === name)
      ;(this.form.skus || []).forEach(sku => {
        ;(sku.units || []).forEach(unit => {
          const master = unit.unitId != null
            ? this.unitRecords.find(x => String(x.id) === String(unit.unitId))
            : find(unit.unit)
          if (master) {
            this.$set(unit, 'unitId', master.id)
            unit.unit = master.name
          }
        })
      })
    },
    attachWarehouseIds () {
      ;(this.form.warehouses || []).forEach(row => {
        const master = row.warehouseId != null
          ? this.warehouseRecords.find(x => String(x.id) === String(row.warehouseId))
          : this.warehouseRecords.find(x => x.name === row.warehouse)
        if (master) {
          this.$set(row, 'warehouseId', master.id)
          row.warehouse = master.name
        }
      })
    },
    resolveUnitId (name) {
      const master = (this.unitRecords || []).find(x => x.name === name || x.value === name)
      return master && master.id
    },
    initializeFormMasterRefs () {
      if (this.unitRecords.length && !this.resolveUnitId(this.form.baseUnit)) {
        this.form.baseUnit = this.unitRecords[0].name
      }
      this.syncBaseUnit(this.form.baseUnit)
      this.attachUnitIds()
      this.attachWarehouseIds()
      this.attachSupplierIds()
    },
    statusLabel (v) {
      if (v === 'enabled' || v === '启用') return '启用'
      if (v === 'disabled' || v === '停用') return '停用'
      return v || '—'
    },
    isEnabledStatus (v) {
      return v === 'enabled' || v === '启用'
    },
    formatCreateTime (value) {
      if (value == null || value === '') return '—'
      return String(value).replace('T', ' ').slice(0, 19)
    },
    hzSyncStatusLabel (v) {
      const n = v == null || v === '' ? 0 : Number(v)
      if (n === 1) return '已同步'
      if (n === 2) return '同步失败'
      return '未同步'
    },
    hzSyncStatusClass (v) {
      const n = v == null || v === '' ? 0 : Number(v)
      if (n === 1) return 'synced'
      if (n === 2) return 'failed'
      return 'unsynced'
    },
    detailValue (value) {
      if (value === null || value === undefined || value === '') return '—'
      return value
    },
    yesNo (value) {
      return value ? '是' : '否'
    },
    moneyValue (value) {
      if (value === null || value === undefined || value === '') return '—'
      return `¥${Number(value || 0).toFixed(2)}`
    },
    skuDetailPairs (sku) {
      return [
        ['规格名称', sku.specName],
        ['销售规格', sku.saleSpec],
        ['条形码', sku.barcode],
        ['最小销售量', sku.minQty],
        ['默认出库货位', sku.defaultLocation],
        ['包装方式', sku.packType],
        ['毛重(kg)', sku.grossWeight],
        ['净重(kg)', sku.netWeight],
        ['体积(m³)', sku.volume],
        ['损耗比例', sku.lossRate != null ? `${sku.lossRate}%` : null],
        ['是否称重', sku.weigh],
        ['供货成本', this.moneyValue(sku.refCost)],
        ['库存设置', this.stockModeLabel(sku.stockMode)],
        ['库存数量', sku.stockValue],
        ['分拣分包', sku.sorting],
        ['是否加工', sku.process],
        ['区域', sku.region],
        ['产地', sku.origin],
        ['采购描述', sku.purchaseDesc],
        ['SKU描述', sku.skuDesc],
        ['商品规格描述', sku.specDesc],
        ['商品特征', sku.feature],
        ['售后标准', sku.afterSale],
        ['备注', sku.remark]
      ].map(([label, value]) => ({ label, value }))
    },
    productTypeLabel (v) {
      if (v === 'standard' || v === '标准产品') return '标准产品'
      if (v === 'non_standard' || v === '非标准产品') return '非标准产品'
      return v || '—'
    },
    buildMethodLabel (record) {
      return record && record.buildMethod === 'sku_direct' ? 'SKU直建 · 自动SPU' : 'SPU建档'
    },
    mallText (record) {
      const malls = (record && record.malls) || []
      return malls.length ? malls.join('、') : '—'
    },
    renderExpandIcon (props) {
      return this.$createElement('button', {
        class: 'expandbtn',
        attrs: { type: 'button', title: props.expanded ? '收起' : '展开' },
        on: {
          click: event => {
            event.stopPropagation()
            props.onExpand(props.record, event)
          }
        }
      }, props.expanded ? '−' : '+')
    },
    onProductExpand (expanded, record) {
      const key = record && record.id
      if (key == null) return
      if (expanded) {
        if (!(this.expandedRowKeys || []).some(id => String(id) === String(key))) {
          this.expandedRowKeys = (this.expandedRowKeys || []).concat(key)
        }
      } else {
        this.expandedRowKeys = (this.expandedRowKeys || []).filter(id => String(id) !== String(key))
      }
    },
    imageText (record) {
      const image = record && record.image
      if (!image || /^https?:\/\//.test(image) || String(image).indexOf('/') >= 0) return '📦'
      return image
    },
    productCategoryPath (record) {
      const id = record && record.categoryId
      if (id == null || id === '') return (record && (record.categoryName || record.category)) || '—'
      const path = []
      const walk = (nodes, acc) => {
        for (const node of nodes || []) {
          const next = acc.concat(node.name || node.categoryName)
          if (String(node.id) === String(id)) {
            path.push.apply(path, next)
            return true
          }
          if (walk(node.children, next)) return true
        }
        return false
      }
      walk(this.categoryTreeRaw, [])
      return path.length ? path.join('/') : ((record && (record.categoryName || record.category)) || '—')
    },
    purchaseAttrLabel (v) {
      if (v === 'spot') return '临采'
      if (v === 'stock') return '备货'
      return v || '—'
    },
    decorateRow (p) {
      const row = {
        ...p,
        image: p.mainImageUrl || p.image || '🥬',
        alias: p.spuAlias || p.alias || '',
        category: p.categoryName || p.category || '—',
        baseUnit: p.baseUnitName || p.baseUnit || '—',
        brand: p.brandName || p.brand || '—',
        tempZone: p.temperatureZone || p.tempZone || '—',
        purchaseAttr: this.purchaseAttrLabel(p.purchaseAttribute || p.purchaseAttr),
        purchaseMethod: p.purchaseMethod || '—',
        productType: this.productTypeLabel(p.productType),
        status: this.statusLabel(p.status),
        hzSyncStatus: p.hzSyncStatus == null || p.hzSyncStatus === '' ? 0 : Number(p.hzSyncStatus),
        warehouseCount: p.warehouseCount || 0,
        malls: p.mallListingSummary ? String(p.mallListingSummary).split(/[、,，]/).filter(Boolean) : (p.malls || []),
        origin: p.originPlace || p.origin || '—',
        shelfLifeDays: p.shelfLifeDays,
        guidePrices: p.guidePrices || []
      }
      // 列表接口会带空 skus:[] / moqs:[]，编辑时绝不能当详情回退源
      if (!Array.isArray(row.skus) || !row.skus.length) delete row.skus
      if (!Array.isArray(row.moqs) || !row.moqs.length) delete row.moqs
      if (!row.quality) delete row.quality
      return row
    },
    /** 统一解析详情响应，避免把列表行空 skus 当成已加载 */
    extractDetailPayload (res, fallbackId) {
      let payload = res
      for (let i = 0; i < 2; i++) {
        if (!payload || typeof payload !== 'object' || Array.isArray(payload)) break
        const inner = payload.data
        const looksAjax = payload.code !== undefined || payload.success !== undefined || payload.msg !== undefined
        const looksProduct = inner && typeof inner === 'object' && !Array.isArray(inner) && (
          inner.id != null || inner.spuName != null || Array.isArray(inner.skus) || inner.spuCode != null
        )
        if ((looksAjax || looksProduct) && inner !== undefined && inner !== null) {
          payload = inner
          continue
        }
        break
      }
      if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
        throw new Error('商品详情加载失败')
      }
      if (fallbackId != null && payload.id != null && String(payload.id) !== String(fallbackId)) {
        throw new Error('商品详情 ID 不匹配')
      }
      return payload
    },
    /** 从详情对象取出 SKU 数组（兼容 skus / skuList） */
    extractApiSkus (d) {
      if (!d || typeof d !== 'object') return []
      if (Array.isArray(d.skus)) return d.skus
      if (Array.isArray(d.skuList)) return d.skuList
      if (Array.isArray(d.skuResults)) return d.skuResults
      return []
    },
    mapSkuFromApi (s, baseUnit) {
      const sku = defaultSku(baseUnit, this.resolveUnitId(baseUnit))
      if (!s || typeof s !== 'object') return sku
      sku.id = s.id != null ? entityIdStr(s.id) : null
      sku.skuCode = s.skuCode || ''
      sku.skuName = s.skuName || s.name || s.specName || ''
      sku.specName = s.specName || ''
      sku.saleSpec = s.saleSpec || s.specName || ''
      if (!sku.specName && sku.skuName) sku.specName = sku.skuName
      sku.barcode = s.barcode || ''
      sku.minQty = s.minSaleQty != null ? Number(s.minSaleQty) : (s.minQty != null ? Number(s.minQty) : 1)
      sku.priceMode = s.pricingMethod || s.priceMode || sku.priceMode
      sku.customerPriceMode = s.customerPriceMode === 'tier' || s.customerPriceMode === '阶梯定价' ? 'tier' : 'fixed'
      sku.defaultLocation = s.defaultLocation || sku.defaultLocation
      sku.packType = s.packageMethod || s.packType || sku.packType
      sku.grossWeight = s.grossWeight != null ? Number(s.grossWeight) : 0
      sku.netWeight = s.netWeight != null ? Number(s.netWeight) : 0
      sku.lossRate = s.lossRate != null ? Number(s.lossRate) : 0
      sku.volume = s.volume != null ? String(s.volume) : ''
      sku.weigh = (s.isWeighted === 1 || s.isWeighted === true || s.weigh === '是') ? '是' : '否'
      sku.refCost = s.supplyCost != null ? Number(s.supplyCost) : (s.refCost != null ? Number(s.refCost) : 0)
      sku.stockMode = s.inventorySetting || s.stockMode || sku.stockMode
      sku.stockValue = s.stockValue != null ? Number(s.stockValue) : 0
      sku.purchaseDesc = s.purchaseDesc || ''
      const sortingRaw = s.sortingPackageRule != null ? s.sortingPackageRule : s.sorting
      sku.sorting = (sortingRaw === '开启' || sortingRaw === '1' || sortingRaw === 1) ? '开启' : '关闭'
      sku.process = (s.isProcessed === 1 || s.isProcessed === true || s.process === '开启') ? '开启' : '关闭'
      sku.region = s.region || ''
      sku.origin = s.origin || ''
      sku.skuDesc = s.skuDesc || ''
      sku.specDesc = s.specDesc || ''
      sku.feature = s.feature || ''
      sku.afterSale = s.afterSaleStandard || s.afterSale || ''
      sku.image = s.imageUrl || s.image || ''
      sku.remark = s.remark || ''
      sku.status = this.statusLabel(s.status)
      sku.baseUnitName = s.baseUnitName || baseUnit || '斤'
      sku.inventoryLocked = s.id != null
      sku.configBaseUnit = sku.baseUnitName
      sku.units = (s.units && s.units.length)
        ? s.units.map(u => ({
          unitId: u.unitId || this.resolveUnitId(u.unit || u.unitName),
          unit: u.unit || u.unitName || sku.baseUnitName,
          rate: u.rate != null ? Number(u.rate) : 1,
          base: !!(u.base || u.isBaseUnit),
          sale: u.sale !== false,
          purchase: u.purchase !== false,
          defaultSale: !!(u.defaultSale || u.isDefaultSale),
          defaultPurchase: !!(u.defaultPurchase || u.isDefaultPurchase)
        }))
        : [{ unitId: this.resolveUnitId(sku.baseUnitName), unit: sku.baseUnitName, rate: 1, base: true, sale: true, purchase: true, defaultSale: true, defaultPurchase: true }]
      const caseRow = (sku.units || []).find(u => !u.base)
      const saleRow = (sku.units || []).find(u => u.defaultSale) || (sku.units || []).find(u => u.base)
      sku.caseUnitName = caseRow ? caseRow.unit : sku.baseUnitName
      sku.caseRate = caseRow && caseRow.rate != null ? Number(caseRow.rate) : 1
      sku.caseUnitTouched = !!(caseRow && caseRow.unit && caseRow.unit !== sku.baseUnitName)
      sku.saleUnitMode = saleRow && !saleRow.base ? 'case' : 'base'
      if (Array.isArray(s.warehousePrices) && s.warehousePrices.length) {
        sku.warehousePrices = s.warehousePrices
      } else if (Array.isArray(s.guidePrices) && s.guidePrices.length) {
        sku.guidePrices = s.guidePrices
      }
      this.normalizeSkuWarehousePrices(sku)
      return sku
    },
    guidePriceText (record) {
      const first = (record.guidePrices || [])[0]
      return first ? `${first.name}：${first.price || 0} 元/${first.unit || record.baseUnit}` : '—'
    },
    mapApiToForm (d) {
      const form = emptyForm()
      form.id = entityIdStr(d.id)
      form.buildMethod = d.buildMethod || 'spu_create'
      form.status = this.statusLabel(d.status)
      form.spuCode = d.spuCode || ''
      form.spuName = d.spuName || ''
      form.alias = d.spuAlias || ''
      form.productType = this.productTypeLabel(d.productType)
      form.customCode = d.customCode || ''
      this.customCodeLocked = !!(d.customCode && String(d.customCode).trim())
      form.categoryId = d.categoryId
      form.baseUnit = d.baseUnitName || '斤'
      form.baseUnitId = d.baseUnitId
      form.brand = d.brandName
      form.tempZone = d.temperatureZone || '常温'
      form.purchaseAttr = this.purchaseAttrLabel(d.purchaseAttribute) || '临采'
      form.purchaseMethod = d.purchaseMethod || '订单采购'
      form.performanceMethod = d.performanceMethod || '计重'
      form.lossRate = d.lossRate != null ? Number(d.lossRate) : 0
      form.smartReplenishment = d.replenishmentRule || ''
      form.origin = d.originPlace || ''
      form.shelfLifeDays = d.shelfLifeDays
      form.description = d.description || ''
      form.feature = d.featureDesc || ''
      form.afterSale = d.afterSaleStandard || ''
      form.image = d.mainImageUrl || ''
      form.video = d.videoUrl || ''
      form.tags = Array.isArray(d.tags) ? d.tags : []
      const q = d.quality || {}
      form.taxRate = q.taxRate != null ? Number(q.taxRate) : 0
      form.invoiceName = q.invoiceName || ''
      form.taxCode = q.taxClassificationCode || ''
      form.taxCategory = q.largeCategoryName || ''
      form.qualityReport = q.inspectionReportUrl || ''
      form.reportName = q.inspectionReportName || q.reportName || ''
      form.reportValidPeriod = q.inspectionValidPeriod || q.reportValidPeriod || ''
      const whSrc = Array.isArray(d.spuWarehouses) && d.spuWarehouses.length
        ? d.spuWarehouses
        : (Array.isArray(d.warehouses) ? d.warehouses : [])
      form.warehouses = whSrc.length
        ? whSrc.map(w => normalizeWarehouseRow({
          warehouseId: entityIdStr(w.warehouseId),
          warehouse: w.warehouse || w.warehouseName,
          purchaseAttr: this.purchaseAttrLabel(w.purchaseAttr || w.purchaseAttribute) || '临采',
          purchaseMethod: w.purchaseMethod || w.purchaseMode || '订单采购',
          smartReplenishment: w.smartReplenishment || w.replenishmentRule || '',
          supplierId: entityIdStr(w.supplierId),
          supplier: w.supplier || w.supplierName || '',
          backupSupplierId: entityIdStr(w.backupSupplierId),
          backupSupplier: w.backupSupplier || w.backupSupplierName || '',
          moqType: w.moqType || 'qty',
          moqValue: w.moqValue != null ? w.moqValue : '',
          supplyCost: w.supplyCost != null ? Number(w.supplyCost) : 0,
          historicalMinCost: w.historicalMinCost != null ? Number(w.historicalMinCost) : 0
        }))
        : []
      if (form.warehouses[0]) {
        form.purchaseAttr = form.warehouses[0].purchaseAttr || form.purchaseAttr
        form.purchaseMethod = form.warehouses[0].purchaseMethod || form.purchaseMethod
      }
      form.moqs = (d.moqs && d.moqs.length ? d.moqs : []).map(m => {
        const raw = m.moqType || m.type || 'qty'
        const isQty = raw === 'qty' || raw === '按数量' || raw === '最小起订量'
        return {
          id: m.id,
          type: isQty ? 'qty' : 'amount',
          value: m.minPurchaseRequirement != null ? Number(m.minPurchaseRequirement) : (m.value != null ? Number(m.value) : 1),
          unit: m.unitName || m.unit || form.baseUnit,
          remark: m.remark || ''
        }
      })
      if (!form.moqs.length) form.moqs = []
      const apiSkus = Array.isArray(d.skus)
        ? d.skus
        : (Array.isArray(d.skuList) ? d.skuList : [])

      form.skus = apiSkus.length
        ? apiSkus.map((s, index) => {
          const sku = this.mapSkuFromApi(s, form.baseUnit)
          sku.__key = s.id || s.skuCode || `sku_${Date.now()}_${index}`
          sku.status = this.normalizeStatus(s.status)
          return sku
        })
        : [defaultSku(form.baseUnit, this.resolveUnitId(form.baseUnit))]
      return form
    },
    buildSavePayload () {
      return {
        id: entityIdStr(this.form.id),
        spuCode: this.form.spuCode || undefined,
        spuName: this.form.spuName,
        spuAlias: this.form.alias,
        buildMethod: this.form.buildMethod,
        categoryId: this.form.categoryId,
        productType: this.form.productType,
        customCode: (this.form.customCode || '').trim(),
        baseUnitId: this.resolveUnitId(this.form.baseUnit),
        baseUnitName: this.form.baseUnit,
        brandName: this.form.brand,
        temperatureZone: this.form.tempZone,
        purchaseAttribute: (this.form.warehouses && this.form.warehouses[0] && this.form.warehouses[0].purchaseAttr) || this.form.purchaseAttr,
        purchaseMethod: (this.form.warehouses && this.form.warehouses[0] && this.form.warehouses[0].purchaseMethod) || this.form.purchaseMethod,
        performanceMethod: this.form.performanceMethod,
        lossRate: this.showLossRate ? this.form.lossRate : 0,
        replenishmentRule: (this.form.warehouses && this.form.warehouses[0] && this.form.warehouses[0].smartReplenishment) || this.form.smartReplenishment,
        originPlace: this.form.origin,
        shelfLifeDays: this.form.shelfLifeDays,
        description: this.form.description,
        featureDesc: this.form.feature,
        afterSaleStandard: this.form.afterSale,
        mainImageUrl: this.form.image,
        videoUrl: this.form.video,
        tags: Array.isArray(this.form.tags) ? this.form.tags : [],
        status: this.form.status,
        spuWarehouses: (this.form.warehouses || []).map(w => ({
          warehouseId: entityIdStr(w.warehouseId),
          warehouseName: w.warehouse,
          purchaseAttribute: w.purchaseAttr,
          purchaseMethod: w.purchaseMethod,
          replenishmentRule: w.smartReplenishment,
          supplierId: entityIdStr(w.supplierId),
          supplierName: w.supplier,
          backupSupplierId: entityIdStr(w.backupSupplierId),
          backupSupplierName: w.backupSupplier,
          moqType: w.moqType,
          moqValue: w.moqValue,
          supplyCost: w.supplyCost,
          historicalMinCost: w.historicalMinCost
        })),
        quality: {
          taxRate: this.form.taxRate,
          invoiceName: this.form.invoiceName,
          taxClassificationCode: this.form.taxCode,
          largeCategoryName: this.form.taxCategory,
          inspectionReportName: this.form.reportName,
          inspectionReportUrl: this.form.qualityReport,
          inspectionValidPeriod: this.form.reportValidPeriod
        },
        moqs: (this.form.moqs || []).map(m => ({
          id: m.id,
          moqType: m.type === 'amount' || m.type === '按金额' ? 'amount' : 'qty',
          minPurchaseRequirement: m.value,
          unitId: (m.type === 'amount' || m.type === '按金额') ? 0 : this.resolveUnitId(m.unit),
          unitName: (m.type === 'amount' || m.type === '按金额') ? undefined : (m.unit || this.form.baseUnit),
          remark: m.remark
        })),
        skus: (this.form.skus || []).map(s => ({
          id: entityIdStr(s.id),
          skuCode: s.skuCode || undefined,
          skuName: s.skuName || this.form.spuName,
          specName: s.specName || s.saleSpec || undefined,
          saleSpec: s.saleSpec || s.specName || undefined,
          barcode: s.barcode || undefined,
          baseUnitId: this.resolveUnitId(s.baseUnitName || this.form.baseUnit),
          baseUnitName: s.baseUnitName || this.form.baseUnit,
          minSaleQty: s.minQty,
          pricingMethod: s.priceMode,
          customerPriceMode: s.customerPriceMode,
          packageMethod: s.packType,
          grossWeight: s.grossWeight,
          netWeight: s.netWeight,
          volume: s.volume || undefined,
          lossRate: s.lossRate != null ? s.lossRate : 0,
          isWeighted: s.weigh === '是' ? 1 : 0,
          supplyCost: s.refCost,
          inventorySetting: s.stockMode,
          stockValue: s.stockValue,
          sortingPackageRule: s.sorting,
          isProcessed: s.process === '开启' ? 1 : 0,
          defaultLocation: s.defaultLocation || undefined,
          region: s.region || undefined,
          origin: s.origin || undefined,
          purchaseDesc: s.purchaseDesc || undefined,
          skuDesc: s.skuDesc,
          specDesc: s.specDesc || undefined,
          feature: s.feature || undefined,
          imageUrl: s.image || undefined,
          afterSaleStandard: s.afterSale,
          status: s.status || '启用',
          remark: s.remark,
          units: Array.isArray(s.units) ? s.units.map(u => ({
            unitId: u.unitId || this.resolveUnitId(u.unit),
            unitName: u.unit,
            rate: u.rate,
            base: !!u.base,
            sale: !!u.sale,
            purchase: !!u.purchase,
            defaultSale: !!u.defaultSale,
            defaultPurchase: !!u.defaultPurchase
          })) : undefined
        }))
      }
    },
    normalizeTree (nodes) {
      return (nodes || []).map(n => ({
        id: n.id,
        name: n.categoryName || n.name,
        categoryName: n.categoryName || n.name,
        categoryCode: n.categoryCode,
        parentId: n.parentId,
        levelNo: n.levelNo,
        sortNo: n.sortNo,
        status: n.status,
        remark: n.remark || '',
        productCount: n.productCount,
        children: this.normalizeTree(n.children || [])
      }))
    },
    loadCategoryTree () {
      const selectedKey = (this.selectedCategoryKeys && this.selectedCategoryKeys[0]) || 'all'
      return treeProductCategory().then(res => {
        const raw = (res && res.data) || []
        this.categoryTreeRaw = this.normalizeTree(raw)
        this.categoryTree = [{ id: 'all', name: '全部商品', children: this.categoryTreeRaw }]
        const expanded = new Set(['all'].concat(this.categoryTreeRaw.map(n => String(n.id)), (this.expandedCategories || []).map(String)))
        this.expandedCategories = Array.from(expanded)
        const exists = String(selectedKey) === 'all' || this.findCategory(selectedKey)
        if (!exists) {
          this.selectedCategoryKeys = ['all']
          this.activeCategory = 'all'
          this.query.categoryId = undefined
        } else {
          this.selectedCategoryKeys = [String(selectedKey)]
        }
      }).catch(() => {
        this.categoryTreeRaw = []
        this.categoryTree = [{ id: 'all', name: '全部商品', children: [] }]
      })
    },
    getList () {
      this.listLoading = true
      const params = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        keyword: this.query.keyword || undefined,
        brandName: this.query.brand || undefined,
        baseUnitName: this.query.baseUnit || undefined,
        buildMethod: this.query.buildMethod || undefined,
        mallListing: this.query.mall || undefined,
        status: this.query.status || undefined,
        hzSyncStatus: this.query.hzSyncStatus === undefined || this.query.hzSyncStatus === null || this.query.hzSyncStatus === ''
          ? undefined
          : String(this.query.hzSyncStatus),
        categoryId: this.query.categoryId || (this.activeCategory !== 'all' ? this.activeCategory : undefined)
      }
      return pageProduct(params).then(res => {
        const data = (res && res.data) || {}
        this.list = (data.records || []).map(this.decorateRow)
        this.pagination.total = Number(data.total || 0)
      }).finally(() => { this.listLoading = false })
    },
    categoryCount (node) {
      const children = (node.children || []).reduce((sum, child) => sum + this.categoryCount(child), 0)
      if (String(node.id) === 'all') return children
      return Number(node.productCount || 0) + children
    },
    onTypeSelect (node) {
      this.onTreeSelect([String(node.id)])
    },
    onTypeToggle (node) {
      const key = String(node.id)
      const keys = (this.expandedCategories || []).map(String)
      this.expandedCategories = keys.includes(key) ? keys.filter(item => item !== key) : keys.concat(key)
    },
    isCategorySelectable (node, currentId) {
      if (currentId != null && String(node.id) === String(currentId)) return true
      return node.status !== 'disabled' && node.status !== '停用'
    },
    categoryNodePath (id) {
      if (id == null || id === '') return []
      const path = []
      const walk = (nodes, acc) => {
        for (const node of nodes || []) {
          const next = acc.concat(node)
          if (String(node.id) === String(id)) {
            path.push.apply(path, next)
            return true
          }
          if (walk(node.children, next)) return true
        }
        return false
      }
      walk(this.categoryTreeRaw, [])
      return path
    },
    openCategoryPicker () {
      if (this.formReadonly) return
      const path = this.categoryNodePath(this.form.categoryId)
      if (path.length) {
        this.categoryPickerSelected = path.slice(0, 3).map(node => node.id)
      } else {
        const roots = (this.categoryTreeRaw || []).filter(node => this.isCategorySelectable(node, this.form.categoryId))
        this.categoryPickerSelected = []
        if (roots[0]) this.pickCategoryLevel(0, roots[0])
      }
      this.categoryPickerVisible = true
    },
    pickCategoryLevel (level, node) {
      const next = (this.categoryPickerSelected || []).slice(0, level)
      next[level] = node.id
      let current = node
      const currentId = this.form && this.form.categoryId
      for (let i = level + 1; i < 3; i++) {
        const children = (current.children || []).filter(item => this.isCategorySelectable(item, currentId))
        if (!children.length) break
        next[i] = children[0].id
        current = children[0]
      }
      this.categoryPickerSelected = next
    },
    confirmCategoryPicker () {
      const selected = this.categoryPickerSelected || []
      const id = selected.length ? selected[selected.length - 1] : null
      if (id == null || id === '') {
        this.$message.warning('请选择商品分类')
        return
      }
      const node = this.findCategory(id)
      const currentId = this.form && this.form.categoryId
      const children = node ? (node.children || []).filter(item => this.isCategorySelectable(item, currentId)) : []
      if (children.length) {
        this.$message.warning('请选择末级分类')
        return
      }
      this.form.categoryId = id
      this.categoryPickerVisible = false
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.validateField('categoryId')
      })
    },
    findCategory (id, nodes) {
      if (id == null || String(id) === 'all') return null
      const list = nodes || this.categoryTreeRaw || []
      for (const node of list) {
        if (String(node.id) === String(id)) return node
        const child = this.findCategory(id, node.children || [])
        if (child) return child
      }
      return null
    },
    categoryLabel (id) {
      if (id == null || String(id) === 'all' || String(id) === '0') return '全部商品'
      const path = []
      const walk = (nodes, acc) => {
        for (const node of nodes || []) {
          const next = acc.concat(node.name || node.categoryName)
          if (String(node.id) === String(id)) {
            path.push.apply(path, next)
            return true
          }
          if (walk(node.children, next)) return true
        }
        return false
      }
      walk(this.categoryTreeRaw, [])
      return path.length ? path.join('/') : '全部商品'
    },
    nextCategoryCode () {
      return 'CAT' + Date.now().toString(36).toUpperCase()
    },
    openCategoryCreate () {
      const selected = this.findCategory(this.activeCategory)
      this.categoryModalMode = 'create'
      this.categoryForm = {
        id: undefined,
        parentId: selected ? selected.id : 0,
        parentName: selected ? this.categoryLabel(selected.id) : '全部商品',
        categoryName: '',
        categoryCode: '',
        sortNo: 10,
        status: '启用',
        originStatus: '启用',
        remark: '',
        productCount: 0
      }
      this.categoryModalVisible = true
    },
    openCategoryMaintain () {
      const selected = this.findCategory(this.activeCategory)
      if (!selected) {
        this.$message.warning('请先选择要编辑的分类')
        return
      }
      const status = selected.status === 'disabled' || selected.status === '停用' ? '停用' : '启用'
      this.categoryModalMode = 'edit'
      this.categoryForm = {
        id: selected.id,
        parentId: selected.parentId || 0,
        parentName: this.categoryLabel(selected.parentId),
        categoryName: selected.categoryName || selected.name,
        categoryCode: selected.categoryCode || '',
        sortNo: selected.sortNo == null ? 10 : selected.sortNo,
        status,
        originStatus: status,
        remark: selected.remark || '',
        productCount: this.categoryCount(selected)
      }
      this.categoryModalVisible = true
    },
    removeCategory () {
      const selected = this.findCategory(this.activeCategory)
      if (!selected) {
        this.$message.warning('请先选择要删除的分类')
        return
      }
      const name = selected.categoryName || selected.name || '该分类'
      const count = this.categoryCount(selected)
      if (count > 0) {
        this.$message.warning(`「${name}」下还有 ${count} 个商品，不能删除`)
        return
      }
      if ((selected.children || []).length) {
        this.$message.warning(`「${name}」下还有子分类，请先删除子分类`)
        return
      }
      this.$confirm({
        title: '删除商品分类',
        content: `确认删除分类「${name}」？删除后不可恢复。`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => deleteProductCategory(selected.id).then(async () => {
          this.$message.success('分类已删除')
          if (String(this.activeCategory) === String(selected.id)) {
            this.activeCategory = undefined
            this.selectedCategoryKeys = []
            this.query.categoryId = undefined
          }
          await this.loadCategoryTree()
          this.pagination.current = 1
          await this.getList()
        })
      })
    },
    async submitCategory () {
      const name = (this.categoryForm.categoryName || '').trim()
      if (!name) {
        this.$message.warning('请输入类型名称')
        return
      }
      const payload = {
        categoryCode: (this.categoryForm.categoryCode || '').trim() || this.nextCategoryCode(),
        categoryName: name,
        parentId: this.categoryForm.parentId || 0,
        sortNo: this.categoryForm.sortNo == null ? 10 : Number(this.categoryForm.sortNo),
        remark: this.categoryForm.remark || ''
      }
      if (this.categoryModalMode === 'edit') payload.id = this.categoryForm.id
      this.categorySaving = true
      try {
        const res = this.categoryModalMode === 'edit'
          ? await editProductCategory(payload)
          : await addProductCategory(payload)
        const id = (res && res.data && res.data.id) || this.categoryForm.id
        const wantDisabled = this.categoryForm.status === '停用'
        const wasDisabled = this.categoryForm.originStatus === '停用'
        if (id && wantDisabled !== wasDisabled) {
          if (wantDisabled) await disableProductCategory(id)
          else await enableProductCategory(id)
        }
        this.$message.success(this.categoryModalMode === 'edit' ? '商品类型已保存' : '商品类型已新建')
        this.categoryModalVisible = false
        if (id) {
          this.activeCategory = id
          this.selectedCategoryKeys = [String(id)]
          this.query.categoryId = id
        }
        await this.loadCategoryTree()
        this.pagination.current = 1
        await this.getList()
      } catch (e) {
        // 接口错误由请求拦截器提示
      } finally {
        this.categorySaving = false
      }
    },
    toggleCategory (id) {
      const sid = String(id)
      this.expandedCategories = this.expandedCategories.map(String).includes(sid)
        ? this.expandedCategories.filter(x => String(x) !== sid)
        : this.expandedCategories.concat(id)
    },
    changeCategory (node) {
      this.activeCategory = node.id
      this.selectedCategoryKeys = [String(node.id)]
      this.query.categoryId = String(node.id) === 'all' ? undefined : node.id
      this.pagination.current = 1
      this.getList()
    },
    onFormTabChange (key) {
      this.formTab = key

      if (key === 'sku') {
        this.ensureSkuListLoaded()
        this.skuInnerTab = 'spec'
        this.hydrateSkuPriceWarehouses()
      }
      if (this.formMode === 'sku') {
        this.syncSkuDirectTabAccessibility()
      }
    },
    onTreeSelect (keys) {
      if (!keys || !keys.length) return
      const id = String(keys[0])
      this.activeCategory = id === 'all' ? 'all' : id
      this.selectedCategoryKeys = [id]
      this.query.categoryId = id === 'all' ? undefined : id
      this.pagination.current = 1
      this.getList()
    },
    handleQuery () {
      this.pagination.current = 1
      this.getList()
    },
    resetQuery () {
      this.query = { keyword: '', subject: undefined, buildMethod: undefined, brand: undefined, baseUnit: undefined, status: undefined, mall: undefined, hzSyncStatus: undefined, categoryId: undefined }
      this.activeCategory = 'all'
      this.selectedCategoryKeys = ['all']
      this.pagination.current = 1
      this.getList()
    },
    onPageChange (page, pageSize) {
      this.pagination.current = page
      if (pageSize) this.pagination.pageSize = pageSize
      this.getList()
    },
    onShowSizeChange (current, size) {
      this.pagination.current = 1
      this.pagination.pageSize = size
      this.getList()
    },
    onSelectChange (keys) { this.selectedRowKeys = keys },
    huazhuSyncFailMessage (e, fallback = '华住同步失败') {
      return parseErpApiErrorMessage(e, fallback)
    },
    showHuazhuOpError (e, fallback) {
      this.$message.error(this.huazhuSyncFailMessage(e, fallback), 6)
    },
    batchSyncHuazhu () {
      if (this.syncLoading) return
      if (!this.selectedRowKeys.length) return this.$message.warning('请先选择商品')
      this.syncLoading = true
      return batchSyncHuazhuProduct({ ids: this.selectedRowKeys.map(id => String(id)) }).then(() => {
        this.$message.success('华住同步完成')
        return this.getList()
      }).catch(e => {
        this.showHuazhuOpError(e)
        return this.getList()
      }).finally(() => {
        this.selectedRowKeys = []
        this.syncLoading = false
      })
    },
    syncHuazhuOne (record) {
      if (this.syncLoading) return
      if (!record || record.id == null) return
      this.syncLoading = true
      return batchSyncHuazhuProduct({ ids: [record.id] }).then(() => {
        this.$message.success('华住同步完成')
        return this.getList()
      }).catch(e => {
        this.showHuazhuOpError(e)
        return this.getList()
      }).finally(() => { this.syncLoading = false })
    },
    batchEnable () {
      if (this.syncLoading) return
      if (!this.selectedRowKeys.length) return this.$message.warning('请先选择商品')
      const n = this.selectedRowKeys.length
      this.syncLoading = true
      return batchEnableProduct({ ids: this.selectedRowKeys.map(id => String(id)) }).then(() => {
        this.$message.success(`已启用 ${n} 个商品`)
        return this.getList()
      }).catch(e => {
        this.showHuazhuOpError(e)
        return this.getList()
      }).finally(() => {
        this.selectedRowKeys = []
        this.syncLoading = false
      })
    },
    batchDisable () {
      if (this.syncLoading) return
      if (!this.selectedRowKeys.length) return this.$message.warning('请先选择商品')
      const n = this.selectedRowKeys.length
      this.syncLoading = true
      return batchDisableProduct({ ids: this.selectedRowKeys.map(id => String(id)) }).then(() => {
        this.$message.success(`已停用 ${n} 个商品`)
        return this.getList()
      }).catch(e => {
        this.showHuazhuOpError(e)
        return this.getList()
      }).finally(() => {
        this.selectedRowKeys = []
        this.syncLoading = false
      })
    },
    openProductMore () {
      this.moreStep = 'choose'
      this.moreAction = '批量导入'
      this.importFileList = []
      this.importResult = null
      this.batchField = '品牌'
      this.batchValue = undefined
      this.moreVisible = true
    },
    openProductExport () {
      this.moreStep = 'export'
      this.moreAction = '导出'
      this.exportScope = 'filter'
      this.moreVisible = true
    },
    confirmMoreAction () {
      if (this.moreAction === '导出') {
        this.moreStep = 'export'
        return
      }
      this.importFileList = []
      this.importResult = null
      this.moreStep = 'import'
    },
    closeProductMore () {
      if (this.importing || this.batchSaving || this.exporting) return
      this.moreVisible = false
      this.importFileList = []
      this.importResult = null
    },
    downloadProductImportTemplate () {
      this.download('erp/product/import-template', {}, `达家商品导入模版_${new Date().getTime()}.xlsx`)
    },
    beforeProductImport (file) {
      const isExcel = /\.(xlsx|xls)$/i.test(file.name)
      if (!isExcel) {
        this.$message.error('仅支持.xlsx或.xls格式文件')
        return false
      }
      if (file.size > 5 * 1024 * 1024) {
        this.$message.error('导入文件不能超过5MB')
        return false
      }
      this.importFileList = [file]
      this.importResult = null
      return false
    },
    removeProductImportFile () {
      if (this.importing) return false
      this.importFileList = []
      this.importResult = null
      return true
    },
    submitProductImport () {
      if (!this.importFileList.length) return this.$message.warning('请先选择需要导入的Excel文件')
      const formData = new FormData()
      formData.append('file', this.importFileList[0])
      formData.append('duplicateMode', this.importDuplicateMode || 'skip')
      this.importing = true
      importProduct(formData).then(res => {
        this.importResult = res.data || {}
        this.importFileList = []
        const success = this.importResult.successCount || 0
        const successSku = this.importResult.successSkuCount || 0
        const updated = this.importResult.updatedCount || 0
        const updatedSku = this.importResult.updatedSkuCount || 0
        const failure = this.importResult.failureCount || 0
        const skipped = this.importResult.skippedCount || 0
        const summary = `新建 ${success} 个 SPU / ${successSku} 个 SKU，更新 ${updated} 个 SPU / ${updatedSku} 个 SKU，跳过 ${skipped} 个 SPU，失败 ${failure} 个`
        if (failure) this.$message.warning('导入完成：' + summary)
        else if (skipped && !success && !updated) {
          this.$message.warning('表格中的商品都已存在，当前为「跳过」模式所以没有写入。若要按表格覆盖，请把「重复数据」改为「更新」后再导入')
        } else this.$message.success('导入完成：' + summary)
        if (success || updated) {
          this.getList()
          this.loadCategoryTree()
          this.loadBaseOptions()
        }
      }).catch(e => {
        this.$message.error((e && e.message) || '导入失败，请重试')
      }).finally(() => {
        this.importing = false
      })
    },
    submitProductBatch () {
      if (!this.selectedRowKeys.length) return this.$message.warning('请先勾选需要修改的商品')
      const value = (this.batchValue || '').trim()
      if (!value) return this.$message.warning('请填写修改后的值')
      const field = { 品牌: 'brand', 商品状态: 'status', 基本单位: 'unit' }[this.batchField]
      this.batchSaving = true
      batchEditProduct({ ids: this.selectedRowKeys, field, value }).then(() => {
        this.$message.success(`已修改 ${this.selectedRowKeys.length} 个商品的${this.batchField}`)
        this.selectedRowKeys = []
        this.moreVisible = false
        this.loadBaseOptions()
        this.getList()
      }).catch(e => {
        if (field === 'status') {
          this.showHuazhuOpError(e)
          this.getList()
        }
      }).finally(() => {
        this.batchSaving = false
      })
    },
    submitProductExport () {
      if (this.exportScope === 'selected' && !this.selectedRowKeys.length) {
        return this.$message.warning('请先勾选需要导出的商品')
      }
      const filename = `达家商品档案_${new Date().getTime()}.xlsx`
      this.exporting = true
      Promise.resolve(this.download('erp/product/export', {
        scope: this.exportScope,
        format: 'xlsx',
        ids: this.exportScope === 'selected' ? this.selectedRowKeys : undefined,
        keyword: this.query.keyword || undefined,
        brandName: this.query.brand || undefined,
        baseUnitName: this.query.baseUnit || undefined,
        buildMethod: this.query.buildMethod || undefined,
        mallListing: this.query.mall || undefined,
        status: this.query.status || undefined,
        hzSyncStatus: this.query.hzSyncStatus === undefined || this.query.hzSyncStatus === null || this.query.hzSyncStatus === ''
          ? undefined
          : String(this.query.hzSyncStatus),
        categoryId: this.query.categoryId || (this.activeCategory !== 'all' ? this.activeCategory : undefined)
      }, filename)).finally(() => {
        this.exporting = false
        this.moreVisible = false
      })
    },
    openSpuCreate () {
      this.formMode = 'spu'
      this.formReadonly = false
      this.customCodeLocked = false
      this.skuKeyword = ''
      this.form = emptyForm()
      this.initializeFormMasterRefs()
      this.formTab = 'base'
      this.activeSkuIndex = 0
      this.formVisible = true
    },
    openSkuCreate () {
      this.formMode = 'sku'
      this.formReadonly = false
      this.customCodeLocked = false
      this.skuKeyword = ''
      this.form = emptyForm()
      this.initializeFormMasterRefs()
      this.form.buildMethod = 'sku_direct'
      // 单页展开仍走 Tabs 组件；默认须落在规格 Tab，并去掉 aria-hidden，否则规格区输入框无法聚焦
      this.formTab = 'sku'
      this.activeSkuIndex = 0
      this.skuInnerTab = 'spec'
      this.formVisible = true
      this.$nextTick(() => {
        this.ensureSkuListLoaded()
        this.hydrateSkuPriceWarehouses()
        this.syncSkuDirectTabAccessibility()
      })
    },
    /** SKU 直建：CSS 已强制各 Tab 面板同页展示，清除 ant 给非激活面板的 aria-hidden，避免规格字段点不进 */
    syncSkuDirectTabAccessibility () {
      if (this.formMode !== 'sku' || !this.formVisible) return
      this.$nextTick(() => {
        const scope = this.$el && this.$el.querySelector('.product-archive-form-page')
        if (!scope) return
        scope.querySelectorAll('.ant-tabs-tabpane[aria-hidden="true"]').forEach(el => {
          el.removeAttribute('aria-hidden')
        })
      })
    },
    closeFormPage () {
      this.formVisible = false
      this.formReadonly = false
      this.customCodeLocked = false
      this.skuKeyword = ''
      this.activeSkuIndex = 0
      this.skuInnerTab = 'spec'
    },
    switchFormToEdit () {
      this.formReadonly = false
    },
    onFormDrawerClose () {
      this.closeFormPage()
    },
    normalizeStatus (value) {
      if (value === 'enabled' || value === '启用' || value === 1 || value === true) return '启用'
      if (value === 'disabled' || value === '停用' || value === 0 || value === false) return '停用'
      return value || '启用'
    },
    getSkuRealIndex (sku) {
      return (this.form.skus || []).findIndex(item => {
        if (sku.id && item.id) return String(item.id) === String(sku.id)
        if (sku.skuCode && item.skuCode) return String(item.skuCode) === String(sku.skuCode)
        return item === sku
      })
    },
    selectSku (sku) {
      const index = this.getSkuRealIndex(sku)
      this.activeSkuIndex = index >= 0 ? index : 0
      this.skuInnerTab = this.skuInnerTab || 'spec'
    },
    ensureSkuListLoaded () {
      if (!this.form.skus || !this.form.skus.length) {
        this.$set(this.form, 'skus', [defaultSku(this.form.baseUnit)])
        this.activeSkuIndex = 0
        return
      }

      this.form.skus = this.form.skus.map((sku, index) => {
        const next = Object.assign(defaultSku(this.form.baseUnit), sku, {
          __key: sku.__key || sku.id || sku.skuCode || `sku_${Date.now()}_${index}`,
          status: this.normalizeStatus(sku.status),
          customerPriceMode: sku.customerPriceMode === 'tier' || sku.customerPriceMode === '阶梯定价' ? 'tier' : 'fixed'
        })
        if (!next.baseUnitName) next.baseUnitName = this.form.baseUnit || '斤'
        if (!next.inventoryLocked) {
          next.configBaseUnit = this.form.baseUnit || next.configBaseUnit || next.baseUnitName
        } else if (!next.configBaseUnit) {
          next.configBaseUnit = next.baseUnitName
        }
        if (!next.saleSpec && next.specName) next.saleSpec = next.specName
        this.normalizeSkuWarehousePrices(next)
        return next
      })

      if (this.activeSkuIndex < 0 || this.activeSkuIndex >= this.form.skus.length) {
        this.activeSkuIndex = 0
      }
    },
    skuThumbSource (sku) {
      return (sku && sku.image) || (this.form && this.form.image) || ''
    },
    skuThumbText (sku) {
      const image = String(this.skuThumbSource(sku) || '')
      if (!image || this.isResourceUrl(image)) return '🥬'
      return image
    },
    stockModeLabel (value) {
      if (value === '不设置库存') return '不做库存限制'
      if (value === '限制库存') return '最低库存量'
      return value || '—'
    },
    skuSaleUnit (sku) {
      return (sku && sku.baseUnitName) || this.form.baseUnit || '斤'
    },
    skuWarehouseCount (sku) {
      if (!sku) return 0
      // 侧栏「N 个仓库」= 该规格已绑定价格体系的仓库数（与 Demo / 价格体系页一致）
      if (Array.isArray(sku.warehousePrices) && sku.warehousePrices.length) {
        return sku.warehousePrices.length
      }
      if (sku._priceWarehouseCount != null) return sku._priceWarehouseCount
      if (Array.isArray(sku.guidePrices) && sku.guidePrices.length) {
        return new Set(sku.guidePrices.map(x => x.warehouse || x.warehouseName).filter(Boolean)).size
      }
      return 0
    },
    /** 从指导价接口回填各 SKU 已绑定仓库，避免侧栏一直显示「0 个仓库」。 */
    hydrateSkuPriceWarehouses () {
      const skus = (this.form && this.form.skus) || []
      const tasks = skus.filter(sku => sku && sku.id).map(sku => {
        return listGuidePrice(sku.id).then(res => {
          const prices = (res && res.data) || []
          const map = {}
          prices.forEach(p => {
            const whName = p.warehouseName || p.warehouse || ''
            const key = p.warehouseId != null ? String(p.warehouseId) : whName
            if (!key) return
            if (!map[key]) {
              map[key] = {
                warehouseId: p.warehouseId,
                warehouse: whName,
                prices: []
              }
            }
            const malls = []
            if (p.huazhuMallListed === true || p.huazhuMallListed === 1 || p.huazhuMallListed === '1') malls.push('华住')
            if (p.meituanListed === true || p.meituanListed === 1 || p.meituanListed === '1') malls.push('美团')
            if (p.selfMallListed === true || p.selfMallListed === 1 || p.selfMallListed === '1') malls.push('自营')
            map[key].prices.push({
              name: p.guidePriceName || '销售指导价',
              price: p.guidePrice != null ? Number(p.guidePrice) : 0,
              previous: 0,
              malls,
              isSpecial: false
            })
          })
          const warehousePrices = Object.keys(map).map(k => map[k])
          this.$set(sku, 'warehousePrices', warehousePrices)
          this.$set(sku, '_priceWarehouseCount', warehousePrices.length)
        }).catch(() => {
          this.$set(sku, '_priceWarehouseCount', Array.isArray(sku.warehousePrices) ? sku.warehousePrices.length : 0)
        })
      })
      return Promise.all(tasks)
    },
    normalizeSkuWarehousePrices (sku) {
      if (!sku) return
      if (Array.isArray(sku.warehousePrices) && sku.warehousePrices.length) {
        sku.warehousePrices = sku.warehousePrices.map(w => {
          const whName = w.warehouse || '郑州一仓'
          const prices = (w.prices && w.prices.length)
            ? w.prices.map(p => ({
              name: p.name || '销售指导价',
              price: p.price != null ? Number(p.price) : (p.value != null ? Number(p.value) : 0),
              previous: p.previous != null ? Number(p.previous) : 0,
              malls: this.normalizeMallNames(p.malls),
              isSpecial: !!p.isSpecial || p.name === '客户特殊价'
            }))
            : [defaultManualPriceRow(0)]
          return {
            warehouse: whName,
            priceSystemName: w.priceSystemName || '',
            bound: true,
            adjusted: w.adjusted || '首次建档',
            latestCost: w.latestCost != null ? Number(w.latestCost) : 0,
            prices,
            tiers: Array.isArray(w.tiers) ? w.tiers : []
          }
        })
        return
      }
      if (Array.isArray(sku.guidePrices) && sku.guidePrices.length) {
        const map = {}
        sku.guidePrices.forEach(g => {
          const wh = g.warehouse || '郑州一仓'
          if (!map[wh]) map[wh] = defaultWarehousePrice(wh)
          if (g.name === '客户特殊价' || g.isSpecial) {
            map[wh].prices.push({
              name: '客户特殊价',
              price: g.price != null ? Number(g.price) : 0,
              previous: 0,
              malls: this.normalizeMallNames(g.malls),
              isSpecial: true
            })
            return
          }
          const exists = map[wh].prices.find(p => !p.isSpecial && p.name === (g.name || ''))
          if (exists) {
            exists.price = g.price != null ? Number(g.price) : 0
            exists.malls = this.normalizeMallNames(g.malls)
          } else {
            map[wh].prices.push({
              name: g.name || '销售指导价',
              price: g.price != null ? Number(g.price) : 0,
              previous: 0,
              malls: this.normalizeMallNames(g.malls),
              isSpecial: false
            })
          }
        })
        sku.warehousePrices = Object.keys(map).map(k => map[k])
        return
      }
      sku.warehousePrices = []
    },
    normalizeMallNames (malls) {
      if (!Array.isArray(malls)) return []
      const alias = { '华住商城': '华住', '自营商城': '自营', '华住': '华住', '美团': '美团', '自营': '自营' }
      return malls.map(m => alias[m] || m).filter((m, i, arr) => mallOptions.includes(m) && arr.indexOf(m) === i)
    },
    ensureSkuWarehousePrices (sku) {
      if (!sku) return
      if (!Array.isArray(sku.warehousePrices)) this.$set(sku, 'warehousePrices', [])
      this.normalizeSkuWarehousePrices(sku)
    },
    onCustomerPriceModeChange (e) {
      const mode = (e && e.target) ? e.target.value : e
      if (!this.activeSku) return
      // 本期商品档案价格体系先只开放固定定价
      this.activeSku.customerPriceMode = mode === 'tier' ? 'fixed' : (mode || 'fixed')
    },
    openAddPriceWarehouseModal () {
      const sku = this.activeSku
      if (!sku) return
      this.ensureSkuWarehousePrices(sku)
      if (!this.availablePriceWarehouses.length) {
        this.$message.warning('可选仓库已全部添加')
        return
      }
      this.priceWarehouseDraft = this.availablePriceWarehouses[0]
      this.priceWarehouseModalVisible = true
    },
    confirmAddPriceSystemWarehouse () {
      const sku = this.activeSku
      if (!sku) return
      const wh = this.priceWarehouseDraft
      if (!wh) {
        this.$message.warning('请选择仓库')
        return
      }
      this.ensureSkuWarehousePrices(sku)
      if ((sku.warehousePrices || []).some(x => x.warehouse === wh)) {
        this.$message.warning('该仓库已添加')
        return
      }
      sku.warehousePrices.push(defaultWarehousePrice(wh))
      this.priceWarehouseModalVisible = false
      this.$message.success('仓库已添加，请手动维护价格')
    },
    addGuidePriceRow (wi) {
      const sku = this.activeSku
      const wh = sku && sku.warehousePrices && sku.warehousePrices[wi]
      if (!wh) return
      if (!Array.isArray(wh.prices)) this.$set(wh, 'prices', [])
      const normalCount = wh.prices.filter(p => !p.isSpecial).length
      wh.prices.push(defaultManualPriceRow(normalCount))
      this.$message.success('已新增价格')
    },
    removeGuidePriceRow (wi, pi) {
      const sku = this.activeSku
      const wh = sku && sku.warehousePrices && sku.warehousePrices[wi]
      if (!wh || !Array.isArray(wh.prices)) return
      const row = wh.prices[pi]
      if (row && row.isSpecial) return
      const normalCount = wh.prices.filter(p => !p.isSpecial).length
      if (normalCount <= 1 && !(row && row.isSpecial)) {
        this.$message.warning('至少保留一条价格')
        return
      }
      wh.prices.splice(pi, 1)
    },
    removePriceSystemWarehouse (wi) {
      const sku = this.activeSku
      if (!sku || !Array.isArray(sku.warehousePrices)) return
      const name = sku.warehousePrices[wi] && sku.warehousePrices[wi].warehouse
      const self = this
      this.$confirm({
        title: '确认删除',
        content: '确定删除仓库「' + name + '」及其当前规格下的价格体系吗？',
        onOk () {
          sku.warehousePrices.splice(wi, 1)
          if (self.priceRuleDraft.ruleWarehouses) {
            self.priceRuleDraft.ruleWarehouses = self.priceRuleDraft.ruleWarehouses.filter(x => x !== name)
          }
          self.$message.success(name ? ('仓库「' + name + '」及其价格体系已删除') : '仓库已删除')
        }
      })
    },
    onLatestCostChange (wi, v) {
      const wh = this.activeSku && this.activeSku.warehousePrices && this.activeSku.warehousePrices[wi]
      if (!wh) return
      wh.latestCost = Number(v || 0)
      this.$message.success('最新进货价已更新')
    },
    openPriceRuleModal (readonly) {
      this.priceRuleReadonly = !!readonly
      this.priceRuleModalTitle = '客户销售价格体系 · 采购价调价规则'
      if (!this.priceRuleDraft.ranges || !this.priceRuleDraft.ranges.length) {
        this.$set(this.priceRuleDraft, 'ranges', defaultPriceRanges())
      }
      this.priceRuleModalVisible = true
    },
    openViewPriceRuleModal (warehouse) {
      this.priceRuleViewWarehouse = warehouse || ''
      this.priceRuleReadonly = true
      this.priceRuleModalTitle = '客户销售价格体系 · ' + (warehouse || '') + ' · 调价规则（查看）'
      if (!this.priceRuleDraft.ranges || !this.priceRuleDraft.ranges.length) {
        this.$set(this.priceRuleDraft, 'ranges', defaultPriceRanges())
      }
      this.priceRuleModalVisible = true
    },
    toggleRuleWarehouse (wh, checked) {
      if (!Array.isArray(this.priceRuleDraft.ruleWarehouses)) {
        this.$set(this.priceRuleDraft, 'ruleWarehouses', [])
      }
      const arr = this.priceRuleDraft.ruleWarehouses
      if (checked) {
        if (arr.indexOf(wh) < 0) arr.push(wh)
      } else {
        this.priceRuleDraft.ruleWarehouses = arr.filter(x => x !== wh)
      }
    },
    addPriceRange () {
      const arr = this.priceRuleDraft.ranges
      const last = arr[arr.length - 1]
      arr.push({
        min: last && last.max !== '' && last.max != null ? Number(last.max) : 0,
        max: '',
        tpl: '水果17%'
      })
    },
    removePriceRange (i) {
      const arr = this.priceRuleDraft.ranges
      if (arr.length <= 1) {
        this.$message.warning('至少保留一个价格区间')
        return
      }
      arr.splice(i, 1)
    },
    savePriceRules () {
      if (this.priceRuleReadonly) {
        this.priceRuleModalVisible = false
        return
      }
      this.$message.warning('价格规则尚未接入后端，当前不会保存，请勿用于正式业务')
    },
    openSpecialPriceRuleModal (warehouse) {
      this.specialRuleDraft = {
        scope: 'all',
        customers: [],
        guide: '销售指导价1',
        basis: '单指导价',
        riseBase: 1,
        risePrice: 1,
        fallBase: 1,
        fallPrice: 0.5,
        warehouse: warehouse || ''
      }
      this.specialPriceRuleModalVisible = true
    },
    onSpecialScopeChange () {},
    saveSpecialPriceRule () {
      this.$message.warning('客户特殊价规则尚未接入后端，当前不会保存，请勿用于正式业务')
    },
    toggleGuideMall (wi, pi, mall, checked) {
      const sku = this.activeSku
      const row = sku && sku.warehousePrices && sku.warehousePrices[wi] && sku.warehousePrices[wi].prices && sku.warehousePrices[wi].prices[pi]
      if (!row) return
      if (!Array.isArray(row.malls)) this.$set(row, 'malls', [])
      if (checked) {
        if (row.malls.indexOf(mall) < 0) row.malls.push(mall)
      } else {
        row.malls = row.malls.filter(x => x !== mall)
      }
    },
    openEdit (record) {
      getProduct(record.id).then(res => {
        const d = this.extractDetailPayload(res, record.id)
        this.form = this.mapApiToForm(d)
        this.initializeFormMasterRefs()
        this.formMode = this.form.buildMethod === 'sku_direct' ? 'sku' : 'spu'
        this.formReadonly = false
        this.formTab = 'base'
        this.activeSkuIndex = 0
        this.skuInnerTab = 'spec'
        this.ensureSkuListLoaded()
        this.formVisible = true
        this.hydrateSkuPriceWarehouses()
      }).catch(e => {
        this.$message.error((e && e.message) || '加载商品详情失败，无法编辑规格信息')
      })
    },
    openSkuPanel (record) {
      getProduct(record.id).then(res => {
        const d = this.extractDetailPayload(res, record.id)
        this.form = this.mapApiToForm(d)
        this.initializeFormMasterRefs()
        this.formMode = 'spu'
        this.formTab = 'sku'
        this.activeSkuIndex = 0
        this.skuInnerTab = 'spec'
        this.ensureSkuListLoaded()
        this.formVisible = true
        this.hydrateSkuPriceWarehouses()
      }).catch(e => {
        this.$message.error((e && e.message) || '加载规格信息失败')
      })
    },
    openDetail (record) {
      getProduct(record.id).then(res => {
        const d = this.extractDetailPayload(res, record.id)
        this.form = this.mapApiToForm(d)
        this.initializeFormMasterRefs()
        this.formMode = this.form.buildMethod === 'sku_direct' ? 'sku' : 'spu'
        this.formReadonly = true
        this.formTab = 'base'
        this.activeSkuIndex = 0
        this.skuInnerTab = 'spec'
        this.ensureSkuListLoaded()
        this.formVisible = true
        this.hydrateSkuPriceWarehouses()
      }).catch(e => {
        this.$message.error((e && e.message) || '加载商品详情失败')
      })
    },
    askDelete (record) {
      this.deleteTarget = record
      this.deleteVisible = true
    },
    confirmDelete () {
      const target = this.deleteTarget
      if (!target || !target.id) return
      if (this.deleteLoading || this.syncLoading) return
      this.deleteLoading = true
      this.syncLoading = true
      deleteProduct(target.id).then(() => {
        this.$message.success('删除成功')
        this.deleteVisible = false
        this.deleteTarget = null
        this.selectedRowKeys = (this.selectedRowKeys || []).filter(id => String(id) !== String(target.id))
        return Promise.all([this.getList(), this.loadCategoryTree()])
      }).catch(e => {
        this.showHuazhuOpError(e, '删除失败')
        return this.getList()
      }).finally(() => {
        this.deleteLoading = false
        this.syncLoading = false
      })
    },
    toggleStatus (record) {
      const req = this.isEnabledStatus(record.status) ? disableProduct(record.id) : enableProduct(record.id)
      req.then(() => {
        this.$message.success('状态已更新')
        this.getList()
      }).catch(e => {
        this.showHuazhuOpError(e)
        this.getList()
      })
    },
    onPurchaseAttrChange (v) { if (v === '临采') this.form.smartReplenishment = '' },
    isResourceUrl (value) {
      return /^(https?:\/\/|\/)/.test(String(value || ''))
    },
    publicAttachmentUrl (url) {
      const text = String(url || '').trim()
      const marker = '/local/file/'
      const index = text.indexOf(marker)
      if (index < 0) return text
      return '/admin-api' + text.substring(index)
    },
    openAttachment (url) {
      const target = this.publicAttachmentUrl(url)
      if (target) window.open(target, '_blank', 'noopener,noreferrer')
    },
    previewProductImage (url) {
      if (!this.isResourceUrl(url)) return
      const target = this.publicAttachmentUrl(url)
      if (!target) return
      this.productImagePreviewUrl = target
      this.productImagePreviewVisible = true
    },
    closeProductImagePreview () {
      this.productImagePreviewVisible = false
      this.productImagePreviewUrl = ''
    },
    showBaseTab () {
      this.formTab = 'base'
    },
    copySku () {
      if (!this.activeSku) return
      const cloned = JSON.parse(JSON.stringify(this.activeSku))
      cloned.id = null
      cloned.__key = `sku_${Date.now()}`
      cloned.skuCode = ''
      cloned.barcode = ''
      cloned.skuName = (cloned.skuName || '未命名规格') + ' - 复制'
      if (cloned.specName) cloned.specName = cloned.specName + ' - 复制'
      cloned.status = '启用'
      this.form.skus.push(cloned)
      this.activeSkuIndex = this.form.skus.length - 1
      this.skuInnerTab = 'spec'
      this.$message.success('已复制规格')
    },
    toggleSkuStatus () {
      if (!this.activeSku) return
      this.activeSku.status = this.normalizeStatus(this.activeSku.status) === '启用' ? '停用' : '启用'
      this.$message.success(`规格已${this.activeSku.status}`)
    },
    saveSku (addNew, backList, enterPrice) {
      if (!this.activeSku) return
      const name = (this.activeSku.skuName || '').trim()
      if (!name) {
        this.$message.error('请填写规格名称')
        this.skuInnerTab = 'spec'
        return
      }
      this.activeSku.skuName = name
      // 商品档案「规格名称」绑定 skuName；同步写入 specName，避免采购/销售等模块仍读旧规格
      this.activeSku.specName = name
      if (this.activeSku.saleSpec !== undefined) this.activeSku.saleSpec = name
      this._skuSaveFollowUp = {
        addNew: !!addNew,
        backList: !!backList,
        enterPrice: !!enterPrice,
        skuId: this.activeSku.id,
        skuKey: this.activeSku.__key,
        skuName: this.activeSku.skuName
      }
      this.saveForm()
    },
    saveSkuAndEnterPrice () {
      this.saveSku(false, false, true)
    },
    skuBaseUnitSelectValue (sku) {
      if (!sku) return this.form.baseUnit || '斤'
      return sku.configBaseUnit || sku.baseUnitName || this.form.baseUnit || '斤'
    },
    syncBaseUnit (unit) {
      const name = unit || this.form.baseUnit || '斤'
      this._syncingSpuBaseUnit = true
      this.form.baseUnit = name
      ;(this.form.skus || []).forEach(s => {
        this.applySkuBaseUnitFields(s, name)
      })
      ;(this.form.moqs || []).forEach(m => { m.unit = name })
      this.$nextTick(() => { this._syncingSpuBaseUnit = false })
    },
    applySkuBaseUnitFields (sku, unit) {
      if (!sku) return
      const name = unit || sku.configBaseUnit || sku.baseUnitName || this.form.baseUnit || '斤'
      this.$set(sku, 'configBaseUnit', name)
      if (!sku.inventoryLocked) {
        this.syncSkuBaseUnit(sku, name)
        if (!sku.caseUnitTouched) this.$set(sku, 'caseUnitName', name)
      }
    },
    onConfigBaseChange (sku, unit) {
      if (!sku) return
      const name = unit || sku.configBaseUnit || sku.baseUnitName || this.form.baseUnit || '斤'
      this.syncBaseUnit(name)
    },
    onCaseUnitChange (sku, unit) {
      if (!sku) return
      sku.caseUnitTouched = true
      sku.caseUnitName = unit
    },
    onSaleModeChange (sku, e) {
      if (!sku) return
      const mode = e && e.target ? e.target.value : e
      sku.saleUnitMode = mode === 'case' ? 'case' : 'base'
    },
    salePriceRate (sku) {
      if (!sku || sku.saleUnitMode !== 'case') return 1
      const inventory = sku.baseUnitName || sku.configBaseUnit
      const caseName = sku.caseUnitName || inventory
      if (!caseName || caseName === inventory) return 1
      const rate = Number(sku.caseRate)
      return rate > 0 ? rate : 1
    },
    salePriceUnitName (sku) {
      if (!sku) return ''
      if (sku.saleUnitMode === 'case') return sku.caseUnitName || sku.configBaseUnit || sku.baseUnitName || ''
      return sku.configBaseUnit || sku.baseUnitName || ''
    },
    composeSkuUnits (sku) {
      const inventory = sku.baseUnitName || sku.configBaseUnit || this.form.baseUnit || '斤'
      const caseName = sku.caseUnitName || sku.configBaseUnit || inventory
      const saleCase = sku.saleUnitMode === 'case' && caseName && caseName !== inventory
      const rate = Number(sku.caseRate) > 0 ? Number(sku.caseRate) : 1
      const rows = [{
        unitId: this.resolveUnitId(inventory),
        unit: inventory,
        rate: 1,
        base: true,
        sale: true,
        purchase: true,
        defaultSale: !saleCase,
        defaultPurchase: true
      }]
      if (caseName && caseName !== inventory) {
        rows.push({
          unitId: this.resolveUnitId(caseName),
          unit: caseName,
          rate,
          base: false,
          sale: true,
          purchase: true,
          defaultSale: sku.saleUnitMode === 'case',
          defaultPurchase: false
        })
      }
      return rows
    },
    syncSkuBaseUnit (sku, unit) {
      if (!sku) return
      const name = unit || this.form.baseUnit || '斤'
      const unitId = this.resolveUnitId(name)
      sku.baseUnitName = name
      if (!Array.isArray(sku.units) || !sku.units.length) {
        this.$set(sku, 'units', [{
          unitId,
          unit: name,
          rate: 1,
          base: true,
          sale: true,
          purchase: true,
          defaultSale: true,
          defaultPurchase: true
        }])
        return
      }
      const base = sku.units.find(u => u.base) || sku.units[0]
      base.unitId = unitId
      base.unit = name
      base.rate = 1
      base.base = true
    },
    addWarehouse () {
      const used = new Set((this.form.warehouses || []).map(x => String(x.warehouseId)))
      const wh = (this.warehouseRecords || []).find(x => !used.has(String(x.id)))
      if (!wh) {
        this.$message.warning(this.warehouseRecords.length ? '可选仓库均已添加' : '请先在仓库档案中维护启用仓库')
        return
      }
      this.form.warehouses.push(defaultWarehouseRow(wh))
    },
    removeWarehouse (i) { this.form.warehouses.splice(i, 1) },
    saveFormAndEnterSku () {
      this._afterSaveEnterSku = true
      this.saveForm()
    },
    async reloadFormAfterSave (preferSku) {
      const newId = this.form.id
      if (!newId) return
      await this.getList()
      this.loadCategoryTree()
      try {
        const d = this.extractDetailPayload(await getProduct(newId), newId)
        this.form = this.mapApiToForm(d)
        this.initializeFormMasterRefs()
        this.ensureSkuListLoaded()
        this.restoreActiveSku(preferSku)
        this.hydrateSkuPriceWarehouses()
      } catch (e) { /* 保持当前表单 */ }
    },
    restoreActiveSku (preferSku) {
      const skus = this.form.skus || []
      if (!skus.length) {
        this.activeSkuIndex = 0
        return
      }
      const prefer = preferSku || {}
      let index = -1
      if (prefer.skuId != null) {
        index = skus.findIndex(s => String(s.id) === String(prefer.skuId))
      }
      if (index < 0 && prefer.skuKey) {
        index = skus.findIndex(s => s.__key === prefer.skuKey)
      }
      if (index < 0 && prefer.skuName) {
        index = skus.findIndex(s => (s.skuName || s.specName) === prefer.skuName)
      }
      if (index < 0) index = Math.min(this.activeSkuIndex || 0, skus.length - 1)
      this.activeSkuIndex = index < 0 ? 0 : index
    },
    addSku () {
      if (!Array.isArray(this.form.skus)) this.$set(this.form, 'skus', [])
      const unit = this.form.baseUnit || '斤'
      this.form.skus.push(defaultSku(unit, this.resolveUnitId(unit)))
      this.skuKeyword = ''
      this.activeSkuIndex = this.form.skus.length - 1
    },
    addSkuUnit () {
      if (!this.activeSku) return
      const used = new Set((this.activeSku.units || []).map(x => String(x.unitId)))
      const master = (this.unitRecords || []).find(x => !used.has(String(x.id)))
      if (!master) {
        this.$message.warning(this.unitRecords.length ? '可选单位均已添加' : '请先在基础设置中维护启用单位')
        return
      }
      this.activeSku.units.push({ unitId: master.id, unit: master.name, rate: 1, base: false, sale: true, purchase: false, defaultSale: false, defaultPurchase: false })
    },
    removeSkuUnit (i) {
      if (!this.activeSku || this.activeSku.units[i].base) return
      this.activeSku.units.splice(i, 1)
    },
    setDefaultUnit (type, i) {
      const key = type === 'sale' ? 'defaultSale' : 'defaultPurchase'
      const capability = type === 'sale' ? 'sale' : 'purchase'
      this.activeSku.units.forEach((u, idx) => { u[key] = idx === i })
      this.activeSku.units[i][capability] = true
    },
    openMoqModal () {
      this.moqDraft = {
        type: 'qty',
        value: undefined,
        unit: this.form.baseUnit || (this.moqUnitOptions[0] || '斤'),
        remark: ''
      }
      this.moqModalVisible = true
    },
    onMoqTypeChange () {
      this.moqDraft.value = undefined
      if (this.moqDraft.type === 'qty' && !this.moqDraft.unit) {
        this.moqDraft.unit = this.form.baseUnit || (this.moqUnitOptions[0] || '斤')
      }
    },
    confirmAddMoq () {
      const draft = this.moqDraft || {}
      const isQty = draft.type !== 'amount'
      if (draft.value == null || draft.value === '' || Number(draft.value) <= 0) {
        this.$message.warning(isQty ? '请输入最低采购数量' : '请输入最低采购金额')
        return Promise.reject(new Error('invalid'))
      }
      if (isQty && !draft.unit) {
        this.$message.warning('请选择计量单位')
        return Promise.reject(new Error('invalid'))
      }
      if (!Array.isArray(this.form.moqs)) this.$set(this.form, 'moqs', [])
      this.form.moqs.push({
        type: isQty ? 'qty' : 'amount',
        value: Number(draft.value),
        unit: isQty ? draft.unit : '',
        remark: draft.remark || ''
      })
      this.moqModalVisible = false
      this.$message.success('MOQ规则已添加')
    },
    removeMoq (i) { this.form.moqs.splice(i, 1) },
    async assertUniqueness () {
      const customCode = (this.form.customCode || '').trim()
      if (customCode && !this.customCodeLocked) {
        const r = await checkCustomCode({ customCode, excludeSpuId: this.form.id })
        if (r && r.data === false) throw new Error('自定义编码已存在')
      }
      if (this.form.spuCode) {
        const r = await checkSpuCode({ spuCode: this.form.spuCode, excludeSpuId: this.form.id })
        if (r && r.data === false) throw new Error('SPU编码已存在')
      }
      for (const sku of this.form.skus) {
        if (sku.skuCode) {
          const r = await checkSkuCode({ skuCode: sku.skuCode, excludeSkuId: sku.id })
          if (r && r.data === false) throw new Error('SKU编码已存在：' + sku.skuCode)
        }
        if (sku.barcode) {
          const r = await checkBarcode({ barcode: sku.barcode, excludeSkuId: sku.id })
          if (r && r.data === false) throw new Error('条形码已存在：' + sku.barcode)
        }
      }
    },
    validateWarehouseAndUnits () {
      const warehouseIds = new Set()
      for (const row of (this.form.warehouses || [])) {
        const warehouseName = warehouseRowDisplayName(row, this.warehouseRecords)
        if (row.warehouseId == null || !warehouseName) {
          this.$message.error('请为每一行选择有效仓库')
          return false
        }
        if (!row.warehouse) row.warehouse = warehouseName
        const key = String(row.warehouseId)
        if (warehouseIds.has(key)) {
          this.$message.error('仓库不能重复添加：' + warehouseName)
          return false
        }
        warehouseIds.add(key)
        const bound = (this.supplierRecords || []).filter(item => supplierBindsWarehouse(item, warehouseName))
        const supplierOk = (id, name) => id == null && !name
          ? true
          : bound.some(item => String(item.id) === String(id) || item.name === name)
        if ((row.supplierId != null || row.supplier) && !supplierOk(row.supplierId, row.supplier)) {
          this.$message.error('供应商「' + (row.supplier || '') + '」未在供应商档案中绑定仓库「' + warehouseName + '」')
          return false
        }
        if ((row.backupSupplierId != null || row.backupSupplier) && !supplierOk(row.backupSupplierId, row.backupSupplier)) {
          this.$message.error('备选供应商「' + (row.backupSupplier || '') + '」未在供应商档案中绑定仓库「' + warehouseName + '」')
          return false
        }
      }
      for (let skuIndex = 0; skuIndex < this.form.skus.length; skuIndex++) {
        const sku = this.form.skus[skuIndex]
        const title = sku.skuName || sku.specName || `SKU${skuIndex + 1}`
        if (sku.saleUnitMode === 'case') {
          if (!sku.caseUnitName) {
            this.$message.error(`${title}：请选择整箱单位`)
            return false
          }
          if (!(Number(sku.caseRate) > 0)) {
            this.$message.error(`${title}：请填写大于 0 的箱规`)
            return false
          }
        }
        sku.units = this.composeSkuUnits(sku)
        const units = sku.units || []
        if (!units.length) {
          this.$message.error(`${title}：至少需要一个计量单位`)
          return false
        }
        const ids = new Set()
        for (const unit of units) {
          if (unit.unitId == null || !unit.unit) {
            this.$message.error(`${title}：请选择有效计量单位`)
            return false
          }
          const key = String(unit.unitId)
          if (ids.has(key)) {
            this.$message.error(`${title}：计量单位不能重复`)
            return false
          }
          ids.add(key)
          if (Number(unit.rate) <= 0) {
            this.$message.error(`${title}：${unit.unit}的换算比例必须大于0`)
            return false
          }
        }
        const skuBase = sku.baseUnitName || sku.configBaseUnit || this.form.baseUnit
        if (!sku.configBaseUnit && !sku.baseUnitName) {
          this.$message.error(`${title}：请选择基本单位`)
          return false
        }
        const baseUnits = units.filter(x => x.base)
        if (baseUnits.length !== 1 || baseUnits[0].unit !== skuBase) {
          this.$message.error(`${title}：库存核算单位必须保留为原来的基本单位`)
          return false
        }
        if (!units.some(x => x.sale) || !units.some(x => x.purchase)) {
          this.$message.error(`${title}：至少需要一个可销售单位和一个可采购单位`)
          return false
        }
        if (units.filter(x => x.defaultSale).length !== 1 || units.filter(x => x.defaultPurchase).length !== 1) {
          this.$message.error(`${title}：请各设置一个默认销售单位和默认采购单位`)
          return false
        }
      }
      return true
    },
    saveForm () {
      const followUp = this._skuSaveFollowUp || null
      const enterSku = !!this._afterSaveEnterSku
      this._skuSaveFollowUp = null
      this._afterSaveEnterSku = false
      this.$refs.form.validate(async valid => {
        if (!valid) return
        if (!this.form.skus.length) return this.$message.error('至少需要维护一个SKU规格')
        const spuBase = (this.form.skus[0] && (this.form.skus[0].configBaseUnit || this.form.skus[0].baseUnitName))
          || this.form.baseUnit
        if (spuBase) this.form.baseUnit = spuBase
        this.form.skus.forEach(sku => { sku.units = this.composeSkuUnits(sku) })
        this.attachWarehouseIds()
        this.attachSupplierIds()
        // 仓库价格仅用于页面展示/侧栏仓库数；正式价格在「价格体系」维护，商品档案保存不提交也不拦截。
        if (!this.validateWarehouseAndUnits()) return
        for (const sku of this.form.skus) {
          if (!sku.specName && sku.saleSpec) sku.specName = sku.saleSpec
          if (!sku.skuName) {
            sku.skuName = this.form.spuName
              ? `${this.form.spuName}${sku.specName ? ' ' + sku.specName : ''}`
              : (sku.specName || '未命名规格')
          }
          if (!sku.saleSpec && sku.specName) sku.saleSpec = sku.specName
        }
        this.submitLoading = true
        try {
          await this.assertUniqueness()
          const payload = convertBigIntToString(this.buildSavePayload())
          const req = this.form.id ? updateProduct(payload) : createProduct(payload)
          const res = await req
          this.$message.success(this.formMode === 'sku' ? 'SKU已创建，并已自动生成SPU归属' : '商品档案已保存')
          const newId = (res && res.data && (res.data.id || res.data.spuId)) || (res && (res.id || res.spuId)) || this.form.id
          if (newId) this.form.id = newId
          if (enterSku) {
            await this.reloadFormAfterSave()
            this.formTab = 'sku'
            this.skuInnerTab = 'spec'
            this.formVisible = true
            return
          }
          if (followUp && followUp.enterPrice) {
            await this.reloadFormAfterSave(followUp)
            this.formTab = 'sku'
            this.skuInnerTab = 'price'
            this.formVisible = true
            return
          }
          if (followUp && followUp.addNew && !followUp.backList) {
            // 保存并新增规格：SKU直建仅单规格，不追加；SPU 可继续加规格
            await this.reloadFormAfterSave()
            if (this.formMode !== 'sku' && this.form.buildMethod !== 'sku_direct') {
              this.addSku()
            }
            this.formTab = 'sku'
            this.skuInnerTab = 'spec'
            this.formVisible = true
            return
          }
          // 普通「保存」：回列表；「保存并进入价格体系」已在上方单独处理
          this.formVisible = false
          this.getList()
          this.loadCategoryTree()
        } catch (e) {
          this.$message.error((e && e.message) || '保存失败')
        } finally {
          this.submitLoading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.dj-product-page{display:grid;grid-template-columns:280px minmax(0,1fr);gap:16px;align-items:stretch;color:#253142;min-height:calc(100vh - 160px)}
.product-category-panel{background:#fff;border:1px solid #e5e9f0;border-radius:8px;min-height:100%;overflow:hidden;display:flex;flex-direction:column}
.category-hd{min-height:50px;padding:9px;display:flex;align-items:center;justify-content:space-between;flex-direction:row;gap:8px;border-bottom:1px solid #edf0f3;background:#fff;font-size:13px;font-weight:600}
.tree-head-title{margin:0;color:#1d2129;font-size:13px;font-weight:600;white-space:nowrap}
.category-hd .tree-actions{display:flex;align-items:center;gap:6px;width:auto;flex:none}
.category-hd .tree-actions /deep/ .ant-btn{width:auto;height:28px;padding:0 8px;font-size:12px;border-radius:4px;line-height:26px}
.tree-actions,.topbar-actions,.list-actions,.drawer-footer{display:flex;gap:9px;flex-wrap:wrap;align-items:center}
.category-list{padding:8px 8px 16px;overflow-x:hidden;overflow-y:auto;max-height:calc(100vh - 250px)}
.product-type-tree /deep/ .product-tree-node{min-width:0}
.product-type-tree /deep/ .product-tree-row{position:relative;min-width:0;width:100%;min-height:34px;display:flex;align-items:flex-start}
.product-type-tree /deep/ .product-tree-toggle{display:inline-flex;align-items:center;justify-content:center;width:18px;min-width:18px;height:28px;margin:0 4px 0 0;padding:0;border:0;background:transparent;color:#98a2b3;cursor:pointer}
.product-type-tree /deep/ .product-tree-toggle:hover{color:#1677ff}
.product-type-tree /deep/ .product-tree-toggle.empty{visibility:hidden}
.product-type-tree /deep/ .product-tree-arrow{display:inline-block;font-size:12px;line-height:1;transition:transform .15s ease}
.product-type-tree /deep/ .product-tree-toggle[aria-expanded="true"] .product-tree-arrow{transform:rotate(90deg)}
.product-type-tree /deep/ .product-tree-select{min-width:0;min-height:30px;flex:1;border:0;background:transparent;padding:6px 7px;display:flex;align-items:flex-start;color:#596574;font-size:13px;line-height:18px;text-align:left;border-radius:5px;cursor:pointer}
.product-type-tree /deep/ .product-tree-select:hover{background:#f7f8fa;color:#1d2129}
.product-type-tree /deep/ .product-tree-row.active .product-tree-select{background:#f1f3f5;color:#1d2129;font-weight:600}
.product-type-tree /deep/ .product-tree-icon{display:none;flex:0 0 16px;width:16px;height:16px;margin:1px 7px 0 0;border-radius:2px;background:linear-gradient(#6b82f2 0 0) 0 0/6px 6px no-repeat,linear-gradient(#6b82f2 0 0) 10px 0/6px 6px no-repeat,linear-gradient(#6b82f2 0 0) 0 10px/6px 6px no-repeat,linear-gradient(#6b82f2 0 0) 10px 10px/6px 6px no-repeat}
.product-type-tree /deep/ .product-tree-row[data-depth="0"] .product-tree-icon,.product-type-tree /deep/ .product-tree-row[data-depth="1"] .product-tree-icon{display:inline-block}
.product-type-tree /deep/ .product-tree-name{min-width:0;flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.product-type-tree /deep/ .product-tree-count{flex:0 0 auto;min-width:24px;margin-left:6px;margin-top:1px;text-align:right;color:#b0b7c3;font-size:11px;font-weight:400}
.product-type-tree /deep/ .product-tree-children{position:relative;margin-left:5px;padding-left:16px;min-width:0}
.product-type-tree /deep/ .product-tree-children:before{content:"";position:absolute;left:6px;top:-8px;bottom:17px;border-left:1px solid #e1e5ea}
.product-type-tree /deep/ .product-tree-children>.product-tree-node>.product-tree-row:before{content:"";position:absolute;left:-10px;top:17px;width:10px;border-top:1px solid #e1e5ea}
.product-type-tree /deep/ .product-tree-children.collapsed{display:none}
.option-list{border:1px solid #e0e5ec;border-radius:6px;overflow:hidden}
.option{padding:10px 12px;border-bottom:1px solid #edf0f4;display:flex;align-items:flex-start;gap:8px;cursor:pointer;margin:0}
.option:last-child{border-bottom:0}
.option:hover{background:#f6f9fd}
.option input{margin-top:3px}
.option b{display:block;color:#1d2129;font-weight:600}
.option .help{margin-top:2px;color:#8a95a6;font-size:12px;line-height:1.5}
.archive-op-note{padding:10px 12px;border:1px solid #bae0ff;border-radius:5px;background:#f0faff;color:#475467;font-size:12px;line-height:1.6}
.archive-op{display:flex;flex-direction:column;gap:12px}
.archive-op-summary{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));border:1px solid #e4e9f0;border-radius:6px;background:#f8fafc;overflow:hidden}
.archive-op-summary>div{min-width:0;padding:10px 12px;border-right:1px solid #e4e9f0}
.archive-op-summary>div:last-child{border-right:0}
.archive-op-summary span{display:block;margin-bottom:4px;color:#8a95a6;font-size:11px}
.archive-op-summary b{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:#1d2129;font-size:13px;font-weight:600}
.archive-op-section{border:1px solid #e4e9f0;border-radius:6px;overflow:hidden}
.archive-op-title{padding:10px 13px;border-bottom:1px solid #edf0f4;background:#fafbfc;color:#1d2129;font-weight:600;font-size:13px}
.archive-op-body{padding:14px}
.archive-op-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px 18px}
.archive-op-field{display:flex;min-width:0;flex-direction:column;gap:6px;margin:0}
.archive-op-field-full{grid-column:1/-1}
.archive-op-field>span{color:#4e5969;font-size:12px}
.archive-op-field /deep/ .ant-input,.archive-op-field /deep/ .ant-input-number,.archive-op-field /deep/ .ant-select{width:100%}
.archive-op-field /deep/ .ant-input,.archive-op-field /deep/ .ant-select-selection,.archive-op-field /deep/ .ant-input-number-input{border-radius:4px}
.product-main{min-width:0;display:flex;flex-direction:column}
/* 右侧列表：对齐客户档案 customer-list-system-card（系统标准列表） */
.product-list-pane{min-width:0;overflow:auto}
.product-list-system-card{margin:0;padding:24px;background:#fff;border:0;border-radius:2px;box-shadow:none}
.product-list-pane .list-search-card{background:transparent;border:0;border-radius:0;padding:0;margin:0}
.archive-filter-grid{display:grid;grid-template-columns:repeat(5,minmax(96px,1fr)) minmax(112px,0.72fr) minmax(220px,1.6fr) auto;gap:10px 12px;align-items:end;margin-bottom:8px}
.archive-filter-field{display:flex;min-width:0;flex-direction:column;gap:6px;color:#4e5969;font-size:12px}
.archive-filter-narrow{max-width:128px}
.archive-filter-keyword{min-width:220px}
.archive-filter-field /deep/ .ant-select,.archive-filter-field /deep/ .ant-input{width:100%}
.archive-filter-actions{display:flex;align-items:center;gap:8px;white-space:nowrap}
@media(max-width:1500px){.archive-filter-grid{grid-template-columns:repeat(4,minmax(120px,1fr))}.archive-filter-narrow{max-width:none}.archive-filter-keyword{grid-column:span 2;min-width:0}.archive-filter-actions{grid-column:1/-1;justify-content:flex-end}}
@media(max-width:900px){.archive-filter-grid{grid-template-columns:repeat(2,minmax(120px,1fr))}.archive-filter-keyword{grid-column:1/-1}}
.product-list-pane .list-search-card /deep/ .ant-form-inline .ant-form-item{display:flex;margin-bottom:24px;margin-right:0}
.product-list-pane .list-search-card /deep/ .ant-form-inline .ant-form-item > .ant-form-item-label{line-height:32px;padding-right:8px;width:auto;flex:none}
.product-list-pane .list-search-card /deep/ .ant-form-inline .ant-form-item .ant-form-item-control-wrapper{flex:1 1 auto;min-width:0}
.product-list-pane .list-search-card /deep/ .ant-form-inline .ant-form-item .ant-form-item-control{height:32px;line-height:32px}
.product-list-pane .list-search-card /deep/ .ant-form-item-label > label{color:rgba(0,0,0,.85);font-size:14px;font-weight:400}
.product-list-pane .list-search-card /deep/ .ant-input,
.product-list-pane .list-search-card /deep/ .ant-select-selection,
.product-list-pane .list-search-card /deep/ .ant-select{width:100%}
.product-list-pane .list-search-card /deep/ .ant-input,
.product-list-pane .list-search-card /deep/ .ant-select-selection{min-height:32px;height:32px;border-radius:2px;border-color:#d9d9d9}
.product-list-pane .list-search-card /deep/ .ant-select-selection--single .ant-select-selection__rendered{line-height:30px}
.product-list-pane .list-search-card /deep/ .table-page-search-submitButtons{display:block;margin-bottom:24px;white-space:nowrap;line-height:32px}
.product-list-pane .list-search-card /deep/ .table-page-search-submitButtons .ant-btn{height:32px;padding:0 15px;border-radius:2px}
.product-list-pane .list-toolbar{display:flex;align-items:center;justify-content:space-between;gap:12px;margin:0;padding:9px 2px 12px;min-height:52px;background:transparent;border:0;border-radius:0}
.product-list-pane .archive-current{min-width:0;color:#55657a;font-size:14px;line-height:32px;white-space:nowrap}
.product-list-pane .archive-current .active-type-label{color:#445166;font-weight:600;margin-right:12px}
.product-list-pane .archive-current b{margin-left:5px;color:var(--bd-primary,#2563eb);font-size:17px;font-weight:600}
.product-list-pane .list-toolbar .list-actions{display:flex;flex-wrap:wrap;justify-content:flex-end;align-items:center;gap:8px;margin-left:auto}
.product-list-pane .list-toolbar .list-actions > .ant-btn,
.product-list-pane .list-toolbar .list-actions > .ant-dropdown-trigger{margin:0}
.product-list-pane .list-toolbar .list-actions /deep/ .ant-btn{height:32px;padding:0 12px;border-radius:4px;font-size:13px}
.product-list-pane .list-refresh-btn{width:32px;height:32px;padding:0;border-radius:2px}
.product-list-pane .table-wrap{background:#fff;border:0;border-radius:0;overflow:auto;padding:0}
.product-list-pane .product-list-table{width:100%}
.product-list-pane .table-wrap /deep/ .ant-table{font-size:14px}
.product-list-pane .table-wrap /deep/ .ant-table-bordered .ant-table-thead>tr>th,
.product-list-pane .table-wrap /deep/ .ant-table-bordered .ant-table-tbody>tr>td{border-color:#e8e8e8}
.product-list-pane .table-wrap /deep/ .ant-table-thead>tr>th{background:#fafafa;color:rgba(0,0,0,.85);font-weight:500;font-size:14px;padding:12px 16px;white-space:nowrap}
.product-list-pane .table-wrap /deep/ .ant-table-tbody>tr>td{padding:12px 16px;color:rgba(0,0,0,.65);font-size:14px;vertical-align:middle}
.product-list-pane .table-wrap /deep/ .ant-table-tbody>tr:hover>td{background:#e6f7ff}
.product-list-pane .table-wrap /deep/ .ant-table-selection-column{width:48px;min-width:48px}
.product-list-pane .list-pagination{
  display:flex;
  justify-content:flex-end;
  align-items:center;
  gap:16px;
  margin:16px 0 0;
  padding:0;
  min-height:32px;
  clear:both;
}
.product-list-pane .list-pagination .pagination-total{
  color:rgba(0,0,0,.65);
  font-size:14px;
  line-height:32px;
  white-space:nowrap;
}
.product-list-pane .list-pagination /deep/ .ant-pagination{margin:0}
.product-list-pane .list-pagination /deep/ .ant-pagination-item,
.product-list-pane .list-pagination /deep/ .ant-pagination-prev,
.product-list-pane .list-pagination /deep/ .ant-pagination-next,
.product-list-pane .list-pagination /deep/ .ant-pagination-jump-prev,
.product-list-pane .list-pagination /deep/ .ant-pagination-jump-next{
  min-width:32px;
  height:32px;
  line-height:30px;
  border-radius:2px;
  margin-right:8px;
}
.product-list-pane .list-pagination /deep/ .ant-pagination-options{margin-left:0}
.product-list-pane .list-pagination /deep/ .ant-select-selection--single{
  height:32px;
  border-radius:2px;
}
.product-list-pane .list-pagination /deep/ .ant-select-selection__rendered{line-height:30px}
.product-list-pane .table-links a{color:#1890ff;font-size:14px}
.product-list-pane .table-links a:hover{color:#40a9ff}
.imgcell{width:48px;height:48px;margin:0 auto;border:1px solid #e0e5ec;border-radius:4px;display:flex;align-items:center;justify-content:center;background:#fafbfc;font-size:22px;overflow:hidden}
.list-thumb{width:100%;height:100%;object-fit:cover;display:block}
.product-name-cell{display:flex;flex-direction:column;gap:3px;line-height:1.4;min-width:0}
.product-name-cell .product-name{color:#28384d;font-weight:500}
.product-name-cell .product-name:hover{color:#1677ff}
.product-name-cell .product-code{font-family:ui-monospace,SFMono-Regular,Menlo,monospace;font-size:12px;color:#111827;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.archive-mode{display:inline-flex;align-items:center;padding:3px 8px;border-radius:10px;background:#eef3f8;color:#53657a;font-size:11px;white-space:nowrap}
.archive-mode.auto{background:#eaf4ff;color:#1677ff;border:1px solid #cfe3ff}
.category-path{color:#3e4d61;white-space:normal;word-break:break-all}
.status-dot{display:inline-flex;padding:2px 8px;border-radius:10px;background:#edf9f0;color:#2f9e44;font-size:11px;white-space:nowrap}
.status-dot.off{background:#f0f2f5;color:#778398}
.hz-sync-status{display:inline-flex;padding:2px 8px;border-radius:10px;font-size:11px;white-space:nowrap}
.hz-sync-status.unsynced{background:#fff7e8;color:#d48806}
.hz-sync-status.synced{background:#edf9f0;color:#2f9e44}
.hz-sync-status.failed{background:#fff1f0;color:#cf1322}
.ops{display:flex;gap:5px;align-items:center;flex-wrap:nowrap;min-width:212px}
.ops /deep/ .ant-btn{height:27px;padding:0 8px;font-size:12px;border-radius:4px;flex:0 0 auto}
.product-list-table /deep/ th.product-list-op-col,
.product-list-table /deep/ td.product-list-op-col{
  position:sticky;right:0;z-index:2;min-width:236px;width:236px!important;
  background:#fff;box-shadow:-8px 0 10px -8px rgba(15,23,42,.12)
}
.product-list-table /deep/ .ant-table-thead th.product-list-op-col{z-index:4;background:#fafafa}
.product-list-table /deep/ .ant-table-tbody>tr:hover>td.product-list-op-col{background:#e6f7ff}
.product-list-table /deep/ .ant-table-expanded-row>td.product-list-op-col{box-shadow:none;background:#fafcff!important}
.fake-select{height:32px;border:1px solid #d6dde8;border-radius:4px;padding:0 10px;display:flex;align-items:center;justify-content:space-between;background:#fff;cursor:pointer;color:#25324b}
.fake-select.is-placeholder{color:#9aa5b5}
.fake-select-text{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}
.fake-select-arrow{flex:0 0 auto;margin-left:8px;color:#98a2b3}
.product-archive-form-page.form-readonly .fake-select{background:#f5f6f8;color:#667085;cursor:default}
.category-grid{display:grid;grid-template-columns:repeat(3,1fr);border:1px solid #e0e5ec;border-radius:4px;overflow:hidden;min-height:280px}
.cat-col{border-right:1px solid #e0e5ec;min-height:280px}
.cat-col:last-child{border-right:0}
.cat-title{padding:10px;background:#f7f9fc;font-weight:600;color:#25324b}
.cat-item{padding:9px 11px;cursor:pointer;color:#344054}
.cat-item.active,.cat-item:hover{background:#eef5ff;color:#1677ff}
.category-picker-current{margin-top:10px;color:#667085}
.category-picker-current b{color:#25324b;font-weight:600}
.iconbtn:hover{background:#eef5ff;color:#1677ff}
.iconbtn:disabled{color:#98a2b3;cursor:not-allowed;background:transparent}
/* 新建/编辑：顶栏（标题+操作按钮）固定，表单区域独立滚动 */
.product-form-page-active /deep/ .ant-page-header,
.product-form-page-active /deep/ .ant-pro-page-header-wrap-page-header-warp{
  display:none!important;
}
.product-form-page-active /deep/ .ant-pro-page-header-wrap-children-content{
  margin:0!important;
  padding-top:0!important;
}
.product-archive-form-page{
  background:#f4f6f9;
  height:calc(100vh - 112px);
  max-height:calc(100vh - 112px);
  min-height:0;
  padding:0;
  display:flex;
  flex-direction:column;
  overflow:hidden;
  box-sizing:border-box;
}
.product-archive-form-page .archive-page-title{
  flex:0 0 auto;
  position:relative;
  z-index:30;
  display:flex;
  align-items:flex-start;
  justify-content:space-between;
  gap:16px;
  background:#fff;
  border:1px solid #e3e8ef;
  border-radius:6px;
  padding:14px 18px;
  margin:0 0 0;
  box-shadow:0 2px 8px rgba(15,23,42,.06);
}
.product-archive-form-scroll{
  flex:1 1 auto;
  min-height:0;
  overflow-x:hidden;
  overflow-y:auto;
  padding:12px 0 24px;
  -webkit-overflow-scrolling:touch;
}
.product-archive-form-page .archive-page-title h1{margin:0 0 6px;font-size:20px;font-weight:700;color:#25324b}
.product-archive-form-page .archive-page-title p{margin:0;color:#7c8da5;font-size:12px;line-height:1.6}
.product-archive-form-page .archive-page-title-right{flex:0 0 auto;display:flex;flex-direction:column;align-items:flex-end;gap:10px}
.product-archive-form-page .archive-page-badge{padding:4px 9px;border-radius:999px;background:#eef6ff;color:#2c73c9;font-size:12px}
.product-archive-form-page .archive-page-actions{display:flex;flex-wrap:wrap;justify-content:flex-end;gap:8px;align-items:center}
/* 查看态禁止改字段，但必须能点 Tab / 切换规格 / 看价格体系（勿禁整个 tabpane，否则内层「价格体系」点不到） */
.product-archive-form-page.form-readonly /deep/ .ant-input,
.product-archive-form-page.form-readonly /deep/ .ant-select-selection,
.product-archive-form-page.form-readonly /deep/ .ant-input-number,
.product-archive-form-page.form-readonly /deep/ .ant-input-number-input,
.product-archive-form-page.form-readonly /deep/ textarea,
.product-archive-form-page.form-readonly /deep/ .ant-switch,
.product-archive-form-page.form-readonly /deep/ .ant-radio-wrapper,
.product-archive-form-page.form-readonly /deep/ .ant-checkbox-wrapper,
.product-archive-form-page.form-readonly /deep/ .fake-select{background:#f5f6f8;color:#667085;pointer-events:none;cursor:default}
.product-archive-form-page.form-readonly /deep/ .sku-actions .ant-btn,
.product-archive-form-page.form-readonly /deep/ .price-system-actions .ant-btn,
.product-archive-form-page.form-readonly /deep/ .danger-link,
.product-archive-form-page.form-readonly /deep/ .ant-table-selection-column{pointer-events:none;opacity:.45}
.product-archive-form-page.form-readonly /deep/ .ant-tabs-tab{pointer-events:auto;cursor:pointer}
.product-archive-form-page .archive-page-actions{pointer-events:auto}
.product-archive-form-page.form-readonly /deep/ .archive-page-actions .ant-btn{pointer-events:auto;opacity:1}
.expandbtn{width:20px;height:20px;border:1px solid #aeb7c6;border-radius:2px;background:#fff;color:#344054;line-height:16px;padding:0;cursor:pointer}
.expandbtn:hover{border-color:#1677ff;color:#1677ff}
.product-list-table /deep/ .ant-table-expanded-row > td{background:#fafcff;padding:0!important}
.product-list-table /deep/ .ant-table-tbody>tr:not(.ant-table-expanded-row)>td{vertical-align:top}
.expand-box{padding:12px 56px 16px;display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:10px 20px;color:#536176}
.expand-box b{color:#273449;font-weight:600}
.status-tag{display:inline-flex;padding:2px 8px;border-radius:999px;font-size:12px}
.status-tag.on{background:#eafaf0;color:#159447}
.status-tag.off{background:#f0f2f5;color:#778398}
.table-links{display:flex;gap:4px;align-items:center;white-space:nowrap}
.drawer-title{width:100%;display:flex;align-items:center;justify-content:space-between;gap:16px}
.drawer-heading{display:flex;align-items:center;gap:12px;min-width:0}
.drawer-heading>div{min-width:0}
.drawer-back-button{width:32px;height:32px;flex:0 0 auto;padding:0;border:1px solid #dfe5ec;border-radius:6px;background:#fff;color:#526071;cursor:pointer}
.drawer-back-button:hover{color:#1677ff;border-color:#1677ff}
.drawer-kicker{display:block;margin-bottom:1px;color:#8090a4;font-size:11px;font-weight:600;letter-spacing:1px;line-height:16px}
.drawer-main-title{font-size:18px;font-weight:700;color:#1d2129;line-height:24px}
.drawer-sub-title{max-width:720px;margin-top:3px;color:#8792a5;font-size:12px;font-weight:400;line-height:18px;white-space:normal}
.product-form-drawer /deep/ .ant-drawer-header{padding:0;border-bottom:1px solid #e5e9f0}
.product-form-drawer /deep/ .ant-drawer-content-wrapper{max-width:100vw}
.product-form-drawer /deep/ .ant-drawer-wrapper-body{overflow:hidden}
.product-form-drawer /deep/ .ant-drawer-body{padding:0 22px 16px;background:#f5f7fa;position:relative;overflow:auto;display:flex;flex-direction:column}
.product-form-drawer /deep/ .ant-form{display:flex;flex-direction:column;min-height:100%}
.form-panel,.sku-detail{background:#f7f9fc;border:1px solid #e5e9f0;border-radius:8px;padding:16px 20px 24px}
.section{padding:20px 22px 22px;margin:0 0 16px;border:1px solid #e8edf5;border-radius:10px;background:#fff;box-shadow:0 1px 2px rgba(15,23,42,.03)}
.section:last-child{margin-bottom:0}
.section-head{display:flex;justify-content:space-between;align-items:center;gap:12px;margin-bottom:20px;padding-bottom:12px;border-bottom:1px solid #edf1f6}
.section-title{display:flex;align-items:center;gap:8px;font-size:15px;font-weight:700;color:#253142}
.section-title:before{content:"";width:7px;height:7px;border-radius:50%;background:#1677ff;box-shadow:0 0 0 4px #e8f2ff;flex:0 0 auto}
.section-title small{font-size:12px;font-weight:400;color:#9aa5b5;margin-left:4px}
.product-form-drawer /deep/ .ant-col .ant-form-item{margin-bottom:20px;width:100%}
.product-form-drawer /deep/ .ant-form-item{margin-bottom:20px}
.product-form-drawer /deep/ .ant-form-item-label{text-align:right;padding-right:8px}
.product-form-drawer /deep/ .ant-form-item-label>label{color:#415066;font-size:14px}
.product-form-drawer /deep/ .ant-form-item-control{line-height:34px}
.product-form-drawer /deep/ .ant-input,
.product-form-drawer /deep/ .ant-select-selection,
.product-form-drawer /deep/ .ant-input-number,
.product-form-drawer /deep/ .ant-tree-select .ant-select-selection{min-height:34px;border-color:#d6dde8;border-radius:6px;box-shadow:none}
.product-form-drawer /deep/ .ant-select{width:100%}
.product-form-drawer /deep/ textarea.ant-input{min-height:72px;line-height:1.5;padding-top:6px}
/* 非激活 Tab 必须彻底卸掉布局：antd 默认仅 height:0+opacity:0，配合 overflow:visible
   时偶发在视口右下角露出一条逐字竖排的重叠文字（force-render 面板内容泄漏）。 */
.product-form-tabs{background:#fff;border:1px solid #e5e9f0;border-radius:8px 8px 0 0;margin:16px 0 0;padding:0 12px;overflow:hidden}
.product-form-tabs /deep/ .ant-tabs-bar{margin-bottom:0;border-bottom:1px solid #e5e9f0}
.product-form-tabs /deep/ .ant-tabs-content{padding:0;margin-left:0!important;width:100%!important;display:block!important;overflow:hidden!important;transform:none!important}
.product-form-tabs /deep/ .ant-tabs-tabpane{width:100%!important;float:none!important;flex:none!important}
.product-form-tabs /deep/ .ant-tabs-tabpane-inactive{display:none!important;height:0!important;width:0!important;overflow:hidden!important;opacity:0!important;pointer-events:none!important;position:absolute!important;left:-9999px!important;visibility:hidden!important}
.sku-inner-tabs{margin-top:0;overflow:hidden}
.sku-inner-tabs /deep/ .ant-tabs-bar{margin-bottom:12px}
.sku-inner-tabs /deep/ .ant-tabs-content{padding:0;margin-left:0!important;width:100%!important;display:block!important;overflow:hidden!important;transform:none!important}
.sku-inner-tabs /deep/ .ant-tabs-tabpane{width:100%!important;float:none!important;flex:none!important}
.sku-inner-tabs /deep/ .ant-tabs-tabpane-inactive{display:none!important;height:0!important;width:0!important;overflow:hidden!important;opacity:0!important;pointer-events:none!important;position:absolute!important;left:-9999px!important;visibility:hidden!important}
/* SKU直建：单页版式 —— 隐藏 Tab 栏，基础/规格/价格纵向同页展开（字段不改） */
.sku-direct-single-tab{background:#fff;border:1px solid #e5e9f0;border-bottom:0;border-radius:8px 8px 0 0;margin:16px 0 0;padding:0 12px}
.sku-direct-single-tab-item{display:inline-block;padding:12px 16px;margin-bottom:-1px;border-bottom:2px solid #1677ff;color:#1677ff;font-weight:600;font-size:14px}
.product-archive-form-page.form-mode-sku .product-form-tabs{border-radius:0 0 8px 8px;margin-top:0;border-top:0;overflow:visible!important}
.product-archive-form-page.form-mode-sku .product-form-tabs /deep/ .ant-tabs-bar{display:none!important}
.product-archive-form-page.form-mode-sku .product-form-tabs /deep/ .ant-tabs-content{overflow:visible!important;height:auto!important}
.product-archive-form-page.form-mode-sku .product-form-tabs /deep/ .ant-tabs-tabpane,
.product-archive-form-page.form-mode-sku .product-form-tabs /deep/ .ant-tabs-tabpane-inactive,
.product-archive-form-page.form-mode-sku .product-form-tabs /deep/ .ant-tabs-tabpane[aria-hidden="true"]{
  display:block!important;height:auto!important;max-height:none!important;width:100%!important;overflow:visible!important;opacity:1!important;
  pointer-events:auto!important;position:static!important;left:auto!important;visibility:visible!important
}
.product-archive-form-page.form-mode-sku .sku-inner-tabs{overflow:visible!important}
.product-archive-form-page.form-mode-sku .sku-inner-tabs /deep/ .ant-tabs-bar{display:none!important}
.product-archive-form-page.form-mode-sku .sku-inner-tabs /deep/ .ant-tabs-content{overflow:visible!important;height:auto!important}
.product-archive-form-page.form-mode-sku .sku-inner-tabs /deep/ .ant-tabs-tabpane,
.product-archive-form-page.form-mode-sku .sku-inner-tabs /deep/ .ant-tabs-tabpane-inactive,
.product-archive-form-page.form-mode-sku .sku-inner-tabs /deep/ .ant-tabs-tabpane[aria-hidden="true"]{
  display:block!important;height:auto!important;max-height:none!important;width:100%!important;overflow:visible!important;opacity:1!important;
  pointer-events:auto!important;position:static!important;left:auto!important;visibility:visible!important
}
.product-archive-form-page.form-mode-sku .sku-inner-tabs /deep/ .ant-tabs-tabpane + .ant-tabs-tabpane,
.product-archive-form-page.form-mode-sku .sku-direct-price-block{margin-top:12px;padding-top:12px;border-top:1px solid #edf0f4}
.product-archive-form-page.form-mode-sku .tab-pane-body.sku-tab-body{padding-bottom:24px}
.sku-toolbar{display:flex;justify-content:space-between;align-items:flex-start;gap:12px;padding:4px 0 14px;border-bottom:1px solid #edf0f4;margin-bottom:4px}
.sku-detail-title{margin:0;font-size:16px;font-weight:700;color:#1d2129}
.sku-meta{margin-top:4px;font-size:12px;color:#8792a5}
.sku-actions,.sku-price-actions,.sku-footer{display:flex;gap:8px;flex-wrap:wrap;align-items:center}
.sku-footer{margin-top:16px;padding-top:14px;border-top:1px solid #edf0f4;justify-content:flex-end}
.price-mode-switch{display:flex;align-items:center;gap:18px;padding:12px 14px;margin:0 0 14px;background:#f8fafc;border:1px solid #e5e7eb;border-radius:6px}
.price-mode-label{font-weight:600;color:#344054;white-space:nowrap}
.sku-empty{padding:24px 12px;color:#8b96a8;font-size:13px;text-align:center}
.price-system-page{padding:4px 0 8px}
.price-system-head{margin-bottom:4px;display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap}
.price-system-head-actions{display:flex;align-items:center;gap:8px;flex-wrap:wrap}
.price-rule-config-btn{color:#1d2129;border-color:#d0d5dd;background:#fff}
.price-rule-config-btn:hover{color:#1677ff;border-color:#1677ff}
.price-empty-note,.price-unbound-note{padding:28px 16px;text-align:center;color:#98a2b3;border:1px dashed #d0d5dd;border-radius:8px;background:#fafbfc;margin:12px}
.price-unbound-note{margin:12px 14px 16px;padding:18px;text-align:left}
.warehouse-price-card{border:1px solid #e5e9f0;border-radius:8px;background:#fff;margin-bottom:14px;overflow:hidden}
.warehouse-price-card-hd{display:flex;justify-content:space-between;gap:12px;align-items:center;flex-wrap:wrap;padding:12px 14px;background:#fbfcfe;border-bottom:1px solid #edf0f4}
.warehouse-price-card-left{display:flex;align-items:center;gap:10px;flex-wrap:wrap;min-width:0}
.warehouse-name{font-size:15px;color:#1d2129}
.price-master-badge{display:inline-flex;align-items:center;gap:6px;padding:3px 9px;border-radius:12px;background:#eef5ff;color:#1677ff;font-size:12px}
.price-master-badge.price-master-empty{color:#d46b08;background:#fff7e6}
.warehouse-price-meta{color:#98a2b3;font-size:12px}
.warehouse-price-card-right{display:flex;align-items:center;gap:12px;flex-wrap:wrap}
.latest-cost-label{display:inline-flex;align-items:center;gap:6px;color:#475467;font-size:12px}
.yen{color:#98a2b3}
.price-action-link{color:#1677ff;font-size:13px;cursor:pointer;white-space:nowrap}
.price-action-link:hover{color:#4096ff}
.price-action-link.danger{color:#f5222d}
.price-action-link.danger:hover{color:#ff4d4f}
.warehouse-price-table-wrap,.price-range-table-wrap{overflow:auto}
.warehouse-price-table{width:100%;min-width:720px;border-collapse:collapse;font-size:13px}
.warehouse-price-table th{background:#fafbfd;color:#667085;font-weight:600;text-align:left;padding:10px 12px;border-bottom:1px solid #edf0f4}
.warehouse-price-table td{padding:10px 12px;border-bottom:1px solid #f0f2f5;vertical-align:middle}
.tier-price-block{min-width:880px}
.tier-price-toolbar{display:flex;justify-content:space-between;align-items:center;gap:12px;padding:10px 12px;color:#667085;font-size:13px;border-bottom:1px solid #edf0f4;background:#fff}
.tier-price-table{min-width:980px}
.guide-name-input{background:#fff!important;color:#1d2129!important}
.special-price-name{font-weight:700;color:#1d2129}
.price-input-group{display:inline-flex;align-items:center;gap:4px}
.mall-checks{display:flex;gap:14px;flex-wrap:wrap;align-items:center;white-space:nowrap}
.price-system-source{font-size:12px;color:#98a2b3}
.formula-chip{display:inline-block;margin:2px 4px 2px 0;padding:2px 8px;border-radius:10px;background:#f2f4f7;color:#475467;font-size:12px}
.price-hint{font-weight:600;color:#344054;font-size:13px}
.special-rule-section{margin-bottom:16px;padding:14px 16px;border:1px solid #eef0f4;border-radius:8px;background:#fafbfc}
.special-rule-section h4{margin:0 0 12px;font-size:14px;color:#1d2129}
.field-label{margin-bottom:6px;font-size:13px;color:#344054}
.field-label .req{color:#f5222d;margin-right:2px}
.fin-tip{margin-top:8px;padding:10px 12px;background:#f8fafc;border:1px solid #e5e7eb;border-radius:6px;color:#475467;font-size:13px;line-height:1.55}
.danger-link{color:#f5222d}
.sub-empty{text-align:center;color:#8792a5;background:#fbfcfe!important}
.tab-pane-body{overflow:visible;padding-bottom:8px}
.sku-tab-body{background:#f5f7fa;margin:0 -12px;padding:14px 12px 18px;border-radius:0 0 8px 8px;overflow:visible}
.form-panel{border-top:0!important;border-radius:0 0 8px 8px!important;margin-top:0}
.help{font-size:12px;color:#9ba5b5;margin-top:5px;line-height:1.55}
.upload-list{display:flex;gap:10px;flex-wrap:wrap}
.upload-box,.image-box{width:82px;height:82px;border:1px dashed #cbd4e0;border-radius:6px;background:#fafcff;display:flex;align-items:center;justify-content:center;flex-direction:column;color:#1677ff;font-size:12px;cursor:pointer}
.upload-box.is-disabled{cursor:not-allowed;opacity:.55;color:#8c8c8c}
.image-box{font-size:30px;color:#253142;border-style:solid}
.upload-box strong{font-size:25px;font-weight:400}
.submodule-block{margin-top:8px;border:1px solid #e3e9f2;border-radius:8px;overflow:hidden;background:#fff}
.submodule-caption{padding:12px 14px;background:#f8fafc;border-bottom:1px solid #e3e9f2;display:flex;justify-content:space-between;align-items:center;font-weight:600}
/* 基础信息末尾的三项配置视为一个连续工作区，避免卡片内再套卡片。 */
.section.base-info-group{margin:0;padding:22px 24px;border:1px solid oklch(0.88 0.012 255);border-radius:0;background:oklch(0.995 0.004 255);box-shadow:none}
.section:not(.base-info-group) + .base-info-group{border-radius:8px 8px 0 0}
.section.base-info-group + .base-info-group{border-top:0}
.section.base-info-group:last-child{border-radius:0 0 8px 8px}
.base-info-group-head{align-items:flex-start;flex-wrap:wrap;margin-bottom:14px;padding:0;border:0}
.base-info-group-head .section-title{display:block;min-width:0;font-size:14px;line-height:1.45;color:oklch(0.27 0.018 255)}
.base-info-group-head .section-title:before{display:none}
.base-info-group-head .section-title small{display:block;margin:4px 0 0;font-size:12px;font-weight:400;line-height:1.5;color:oklch(0.52 0.018 255)}
.base-info-group-head /deep/ .ant-btn{height:32px;padding:0 12px;border-radius:6px;font-size:12px;font-weight:500;white-space:nowrap}
.base-info-group-head /deep/ .ant-btn[disabled]{color:oklch(0.56 0.014 255);border-color:oklch(0.88 0.012 255);background:oklch(0.965 0.008 255)}
.base-info-card{border:1px solid oklch(0.88 0.012 255);border-radius:6px;background:oklch(0.995 0.004 255);overflow:hidden}
.base-info-card-foot{padding:10px 14px;border-top:1px solid oklch(0.91 0.009 255);background:oklch(0.975 0.006 255);color:oklch(0.52 0.018 255);font-size:12px;line-height:1.5}
.base-info-empty{display:flex;flex-direction:column;align-items:flex-start;gap:4px;padding:20px 18px;background:oklch(0.975 0.006 255)}
.base-info-empty-title{font-size:13px;font-weight:600;color:oklch(0.34 0.018 255)}
.base-info-empty-desc{font-size:12px;color:oklch(0.52 0.018 255)}
.base-info-group .sub-table-wrap,
.base-info-group .warehouse-table-wrap,
.base-info-group .multi-unit-table-wrap,
.base-info-group .moq-table-wrap{overflow-x:auto;overflow-y:hidden;width:100%;background:#fff;-webkit-overflow-scrolling:touch}
.base-info-group .sub-table,
.base-info-group .warehouse-info-table,
.base-info-group .multi-unit-table,
.base-info-group .moq-table{width:max-content;min-width:100%;border-collapse:separate;border-spacing:0;font-size:13px;table-layout:auto}
.base-info-group .sub-table th,
.base-info-group .warehouse-info-table th,
.base-info-group .multi-unit-table th,
.base-info-group .moq-table th{
  height:40px;padding:9px 14px;background:oklch(0.965 0.008 255);color:oklch(0.42 0.018 255);font-weight:600;font-size:12px;
  border-bottom:1px solid oklch(0.88 0.012 255);text-align:left;white-space:nowrap;vertical-align:middle
}
.base-info-group .sub-table td,
.base-info-group .warehouse-info-table td,
.base-info-group .multi-unit-table td,
.base-info-group .moq-table td{
  height:50px;padding:10px 14px;border-bottom:1px solid oklch(0.91 0.009 255);color:oklch(0.34 0.018 255);
  white-space:nowrap;vertical-align:middle;background:oklch(0.995 0.004 255)
}
.base-info-group .sub-table tr:last-child td,
.base-info-group .warehouse-info-table tr:last-child td,
.base-info-group .multi-unit-table tr:last-child td,
.base-info-group .moq-table tr:last-child td{border-bottom:0}
.base-info-group .sub-empty{height:68px!important;padding:22px 14px!important;text-align:center!important;color:oklch(0.52 0.018 255)!important;white-space:normal!important}
.base-info-group /deep/ .ant-select,
.base-info-group /deep/ .ant-input,
.base-info-group /deep/ .ant-input-number{width:100%}
.base-info-group /deep/ .ant-select-selection--single,
.base-info-group /deep/ .ant-input,
.base-info-group /deep/ .ant-input-number,
.base-info-group /deep/ .ant-input-number-input-wrap,
.base-info-group /deep/ .ant-input-number-input{
  height:32px!important;min-height:32px!important;line-height:30px!important;border-radius:2px
}
.base-info-group /deep/ .ant-select-selection__rendered{line-height:30px!important;margin-left:11px}
.base-info-group /deep/ .ant-input{padding:4px 11px}
.base-info-group /deep/ .ant-input-number-input{padding:0 11px}
.base-info-group .warehouse-info-table{min-width:1340px}
.base-info-group .multi-unit-table{min-width:760px}
.base-info-group .moq-table{min-width:760px}
.base-info-group .multi-unit-table .unit-check{text-align:center}
.base-info-group .multi-unit-table .unit-check /deep/ .ant-checkbox-wrapper,
.base-info-group .multi-unit-table .unit-check /deep/ .ant-radio-wrapper{margin:0}
.base-info-group .unit-desc{color:oklch(0.52 0.018 255);font-size:12px}
.base-info-group .unit-base-tag{
  display:inline-block;margin-left:8px;padding:1px 8px;border-radius:4px;
  background:oklch(0.96 0.018 255);color:oklch(0.46 0.11 255);border:1px solid oklch(0.88 0.025 255);font-size:12px;line-height:20px;vertical-align:middle;font-weight:500
}
.base-info-group .unit-locked{color:oklch(0.52 0.018 255);font-size:12px}
.base-info-group .danger-link{color:#ff4d4f;font-size:13px}
.base-info-group .danger-link:hover{color:#ff7875}
@media (max-width:900px){.section.base-info-group{padding:18px 16px}.base-info-group-head{gap:12px}.base-info-group-head .section-title{flex-basis:100%}}
.sub-table-wrap{overflow:auto;border:0;border-radius:0;background:#fff}
.sub-table{width:100%;min-width:720px;border-collapse:collapse;font-size:13px}
.sub-table th,.sub-table td{padding:10px 12px;border-bottom:1px solid #eef1f5;white-space:nowrap;text-align:left;vertical-align:middle}
.sub-table th{height:40px;background:#fafbfd;color:#53657c;font-weight:600;font-size:12px}
.sub-table tr:last-child td{border-bottom:0}
.sub-empty{text-align:center!important;color:#98a2b3;padding:22px 12px!important}
.warehouse-table-wrap{width:100%}
.multi-unit-box{margin-top:12px;border:1px solid #dce4ee;border-radius:6px;background:#fff;overflow:hidden}
.multi-unit-head{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:11px 14px;background:#f7faff;border-bottom:1px solid #e5ebf3;flex-wrap:wrap}
.multi-unit-title{font-size:13px;font-weight:700;color:#2d4059}
.multi-unit-tip{display:inline-block;margin-left:10px;font-size:12px;color:#8492a6;font-weight:400}
.multi-unit-table-wrap{overflow:auto}
.multi-unit-table{width:100%;min-width:760px;border-collapse:collapse}
.multi-unit-table th{height:40px;background:#fafbfd;color:#53657c;font-weight:600;font-size:12px;text-align:left;padding:0 12px;border-bottom:1px solid #e7ebf1;white-space:nowrap}
.multi-unit-table td{height:52px;padding:10px 12px;border-bottom:1px solid #eef1f5;vertical-align:middle;font-size:13px;color:#344054}
.multi-unit-table tr:last-child td{border-bottom:0}
.multi-unit-table .unit-check{text-align:center;min-width:84px}
.multi-unit-table .unit-desc{color:#667085;font-size:12px}
.unit-base-tag{display:inline-block;margin-left:8px;padding:2px 8px;border-radius:3px;background:#eef6ff;color:#1677ff;font-size:11px;line-height:18px;vertical-align:middle}
.unit-locked{color:#98a2b3;font-size:12px}
.multi-unit-foot{padding:10px 14px;background:#fbfcfe;border-top:1px solid #eef1f5;color:#7f8ca0;font-size:12px;line-height:1.6}
.moq-table{min-width:760px}
.moq-rule-modal /deep/ .ant-form-item{margin-bottom:18px}
.moq-rule-modal /deep/ .ant-form-item-label{line-height:32px}
.moq-rule-modal /deep/ .ant-form-item-required::before{color:#ff4d4f}
.sku-form-page{margin-top:0}
.sku-detail{min-width:0;border:1px solid #e5e9f0!important;border-radius:8px!important;padding:4px 20px 18px!important}
.sku-detail .section{padding:18px 20px;margin-bottom:14px}
.sku-subtable{width:100%;overflow:auto;border:1px solid #dfe5ee;border-radius:7px;background:#fff}
.sku-subtable .sub-table-wrap{border:0;border-radius:0}
.sku-subtable .sub-table{min-width:640px}
.price-help{margin-top:8px}
.drawer-footer{position:sticky;bottom:0;z-index:5;width:100%;max-width:100%;box-sizing:border-box;padding:14px 24px;justify-content:flex-end;border-top:1px solid #e5e9f0;background:rgba(255,255,255,.98);box-shadow:0 -4px 12px rgba(15,23,42,.04);overflow:hidden}
.detail-hero{display:flex;gap:18px;align-items:center;border:1px solid #e5e9f0;border-radius:8px;background:#fbfcfe;padding:18px;margin-bottom:16px}
.detail-image{width:86px;height:86px;border:1px solid #dfe7f1;border-radius:10px;background:#fff;display:flex;align-items:center;justify-content:center;font-size:44px;overflow:hidden;flex:none}
.detail-image img{width:100%;height:100%;object-fit:cover;cursor:pointer}.detail-attachment-links{display:flex;gap:16px;margin-top:9px;font-size:12px}
.product-image-preview-full{display:block;max-width:min(88vw,960px);max-height:78vh;margin:0 auto;object-fit:contain}
.detail-hero h2{margin:0 0 8px}
.detail-hero p{color:#5f6b7a;margin:0}
.detail-section-title{margin:20px 0 12px;font-size:16px}
.product-detail-table{background:#fff}
.detail-sku-card{margin-top:14px;padding:14px;border:1px solid #dfe5ee;border-radius:8px;background:#fff}
.detail-sku-card-title{display:flex;align-items:center;justify-content:space-between;gap:16px;margin-bottom:12px}
.detail-sku-card-title>div{display:flex;flex-direction:column;gap:3px}.detail-sku-card-title b{color:#27364a}.detail-sku-card-title span{color:#7b8796;font-size:12px}
.detail-subtable-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-top:14px}.detail-subtable-grid h4{margin:0 0 8px;color:#4b5b70;font-size:13px}
.detail-mini-table{width:100%;border:1px solid #e3e8ef;border-collapse:collapse;font-size:12px}.detail-mini-table th{padding:8px;background:#f7f9fc;color:#5d6b7d;font-weight:600;text-align:left;white-space:nowrap}.detail-mini-table td{padding:8px;border-top:1px solid #edf0f4;color:#354255}.detail-empty-cell{text-align:center;color:#98a2b3!important;padding:16px!important}
.product-detail-drawer /deep/ .ant-drawer-header{padding:0;border-bottom:1px solid #e5e9f0}
.product-detail-drawer /deep/ .ant-drawer-content-wrapper{max-width:100vw}
.product-detail-drawer /deep/ .ant-drawer-body{padding:18px 22px;background:#f5f7fa}
@media(max-width:1100px){.detail-subtable-grid{grid-template-columns:1fr}.product-list-pane .list-toolbar{align-items:flex-start;flex-direction:column;height:auto}.product-list-pane .list-toolbar .list-actions{margin-left:0;justify-content:flex-start}.product-form-drawer /deep/ .ant-drawer-content-wrapper,.product-detail-drawer /deep/ .ant-drawer-content-wrapper{width:100%!important}}
@media(max-width:900px){.product-list-search-form /deep/ .ant-col-md-8{width:50%}}
@media(max-width:760px){.dj-product-page{grid-template-columns:1fr}.product-category-panel{min-height:auto}.category-list{max-height:260px}}
@media(max-width:560px){.product-list-search-form /deep/ .ant-col-md-8{width:100%}}
@media(max-width:700px){.drawer-title{align-items:flex-start}.drawer-title>.ant-tag{margin-top:4px}.drawer-sub-title{display:none}.product-form-drawer /deep/ .ant-drawer-body,.product-detail-drawer /deep/ .ant-drawer-body{padding-left:14px;padding-right:14px}.product-form-tabs{margin-top:12px}.section{padding:16px 14px}.drawer-footer{margin:0 -14px -16px;width:calc(100% + 28px);padding-left:14px;padding-right:14px}}
</style>
